/*! lazysizes - v3.0.0 */
!function() {
    "use strict";
    function a(a) {
        var b = getComputedStyle(a, null) || {}
          , c = b.fontFamily || ""
          , d = c.match(f) || ""
          , e = d && c.match(g) || "";
        return e && (e = e[1]),
        {
            fit: d && d[1] || "",
            position: j[e] || e || "center"
        }
    }
    function b(a, b) {
        var c, d = lazySizes.cfg, e = a.cloneNode(!1), f = e.style, g = function() {
            var b = a.currentSrc || a.src;
            b && (f.backgroundImage = "url(" + (i.test(b) ? JSON.stringify(b) : b) + ")",
            c || (c = !0,
            lazySizes.rC(e, d.loadingClass),
            lazySizes.aC(e, d.loadedClass)))
        };
        a._lazysizesParentFit = b.fit,
        a.addEventListener("load", function() {
            lazySizes.rAF(g)
        }, !0),
        e.addEventListener("load", function() {
            var a = e.currentSrc || e.src;
            a && a != h && (e.src = h,
            e.srcset = "")
        }),
        lazySizes.rAF(function() {
            var c = a
              , i = a.parentNode;
            "PICTURE" == i.nodeName.toUpperCase() && (c = i,
            i = i.parentNode),
            lazySizes.rC(e, d.loadedClass),
            lazySizes.rC(e, d.lazyClass),
            lazySizes.aC(e, d.loadingClass),
            lazySizes.aC(e, d.objectFitClass || "lazysizes-display-clone"),
            e.getAttribute(d.srcsetAttr) && e.setAttribute(d.srcsetAttr, ""),
            e.getAttribute(d.srcAttr) && e.setAttribute(d.srcAttr, ""),
            e.src = h,
            e.srcset = "",
            f.backgroundRepeat = "no-repeat",
            f.backgroundPosition = b.position,
            f.backgroundSize = b.fit,
            c.style.display = "none",
            a.setAttribute("data-parent-fit", b.fit),
            a.setAttribute("data-parent-container", "prev"),
            i.insertBefore(e, c),
            a._lazysizesParentFit && delete a._lazysizesParentFit,
            a.complete && g()
        })
    }
    var c = document.createElement("a").style
      , d = "objectFit"in c
      , e = d && "objectPosition"in c
      , f = /object-fit["']*\s*:\s*["']*(contain|cover)/
      , g = /object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/
      , h = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
      , i = /\(|\)|'/
      , j = {
        center: "center",
        "50% 50%": "center"
    };
    d && e || addEventListener("lazyunveilread", function(c) {
        var e = c.target
          , f = a(e);
        !f.fit || d && "center" == f.position || b(e, f)
    }, !0)
}();
/*! lazysizes - v3.0.0 */
!function(a, b, c) {
    "use strict";
    function d(b, c) {
        var d, e, f, g, h = a.getComputedStyle(b);
        e = b.parentNode,
        g = {
            isPicture: !(!e || !m.test(e.nodeName || ""))
        },
        f = function(a, c) {
            var d = b.getAttribute("data-" + a);
            if (!d) {
                var e = h.getPropertyValue("--ls-" + a);
                e && (d = e.trim())
            }
            if (d) {
                if ("true" == d)
                    d = !0;
                else if ("false" == d)
                    d = !1;
                else if (l.test(d))
                    d = parseFloat(d);
                else if ("function" == typeof j[a])
                    d = j[a](b, d);
                else if (q.test(d))
                    try {
                        d = JSON.parse(d)
                    } catch (f) {}
                g[a] = d
            } else
                a in j && "function" != typeof j[a] ? g[a] = j[a] : c && "function" == typeof j[a] && (g[a] = j[a](b, d))
        }
        ;
        for (d in j)
            f(d);
        return c.replace(p, function(a, b) {
            b in g || f(b, !0)
        }),
        g
    }
    function e(a, b) {
        var c = []
          , d = function(a, c) {
            return k[typeof b[c]] ? b[c] : a
        };
        return c.srcset = [],
        b.absUrl && (s.setAttribute("href", a),
        a = s.href),
        a = ((b.prefix || "") + a + (b.postfix || "")).replace(p, d),
        b.widths.forEach(function(d) {
            var e = b.widthmap[d] || d
              , f = {
                u: a.replace(n, e).replace(o, b.ratio ? Math.round(d * b.ratio) : ""),
                w: d
            };
            c.push(f),
            c.srcset.push(f.c = f.u + " " + d + "w")
        }),
        c
    }
    function f(a, c, d) {
        var f = 0
          , g = 0
          , h = d;
        if (a) {
            if ("container" === c.ratio) {
                for (f = h.scrollWidth,
                g = h.scrollHeight; !(f && g || h === b); )
                    h = h.parentNode,
                    f = h.scrollWidth,
                    g = h.scrollHeight;
                f && g && (c.ratio = g / f)
            }
            a = e(a, c),
            a.isPicture = c.isPicture,
            u && "IMG" == d.nodeName.toUpperCase() ? d.removeAttribute(i.srcsetAttr) : d.setAttribute(i.srcsetAttr, a.srcset.join(", ")),
            Object.defineProperty(d, "_lazyrias", {
                value: a,
                writable: !0
            })
        }
    }
    function g(a, b) {
        var c = d(a, b);
        return j.modifyOptions.call(a, {
            target: a,
            details: c,
            detail: c
        }),
        lazySizes.fire(a, "lazyriasmodifyoptions", c),
        c
    }
    function h(a) {
        return a.getAttribute(a.getAttribute("data-srcattr") || j.srcAttr) || a.getAttribute(i.srcsetAttr) || a.getAttribute(i.srcAttr) || a.getAttribute("data-pfsrcset") || ""
    }
    if (b.addEventListener) {
        var i, j, k = {
            string: 1,
            number: 1
        }, l = /^\-*\+*\d+\.*\d*$/, m = /^picture$/i, n = /\s*\{\s*width\s*\}\s*/i, o = /\s*\{\s*height\s*\}\s*/i, p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, q = /^\[.*\]|\{.*\}$/, r = /^(?:auto|\d+(px)?)$/, s = b.createElement("a"), t = b.createElement("img"), u = "srcset"in t && !("sizes"in t), v = !!a.HTMLPictureElement && !u;
        !function() {
            var b, c = function() {}, d = {
                prefix: "",
                postfix: "",
                srcAttr: "data-src",
                absUrl: !1,
                modifyOptions: c,
                widthmap: {},
                ratio: !1
            };
            i = a.lazySizes && lazySizes.cfg || a.lazySizesConfig,
            i || (i = {},
            a.lazySizesConfig = i),
            i.supportsType || (i.supportsType = function(a) {
                return !a
            }
            ),
            i.rias || (i.rias = {}),
            j = i.rias,
            "widths"in j || (j.widths = [],
            function(a) {
                for (var b, c = 0; !b || 3e3 > b; )
                    c += 5,
                    c > 30 && (c += 1),
                    b = 36 * c,
                    a.push(b)
            }(j.widths));
            for (b in d)
                b in j || (j[b] = d[b])
        }(),
        addEventListener("lazybeforesizes", function(a) {
            var b, c, d, e, k, l, m, o, p, q, s, t, u;
            if (b = a.target,
            a.detail.dataAttr && !a.defaultPrevented && !j.disabled && (p = b.getAttribute(i.sizesAttr) || b.getAttribute("sizes")) && r.test(p)) {
                if (c = h(b),
                d = g(b, c),
                s = n.test(d.prefix) || n.test(d.postfix),
                d.isPicture && (e = b.parentNode))
                    for (k = e.getElementsByTagName("source"),
                    l = 0,
                    m = k.length; m > l; l++)
                        (s || n.test(o = h(k[l]))) && (f(o, d, k[l]),
                        t = !0);
                s || n.test(c) ? (f(c, d, b),
                t = !0) : t && (u = [],
                u.srcset = [],
                u.isPicture = !0,
                Object.defineProperty(b, "_lazyrias", {
                    value: u,
                    writable: !0
                })),
                t && (v ? b.removeAttribute(i.srcAttr) : "auto" != p && (q = {
                    width: parseInt(p, 10)
                },
                w({
                    target: b,
                    detail: q
                })))
            }
        }, !0);
        var w = function() {
            var c = function(a, b) {
                return a.w - b.w
            }
              , d = function(a) {
                var b, c, d = a.length, e = a[d - 1], f = 0;
                for (f; d > f; f++)
                    if (e = a[f],
                    e.d = e.w / a.w,
                    e.d >= a.d) {
                        !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6),
                        b.cached && (b.d += .15 * c),
                        b.d + (e.d - a.d) * c > a.d && (e = b));
                        break
                    }
                return e
            }
              , e = function(a, b) {
                var c;
                return !a._lazyrias && lazySizes.pWS && (c = lazySizes.pWS(a.getAttribute(i.srcsetAttr || ""))).length && (Object.defineProperty(a, "_lazyrias", {
                    value: c,
                    writable: !0
                }),
                b && a.parentNode && (c.isPicture = "PICTURE" == a.parentNode.nodeName.toUpperCase())),
                a._lazyrias
            }
              , f = function(b) {
                var c = a.devicePixelRatio || 1
                  , d = lazySizes.getX && lazySizes.getX(b);
                return Math.min(d || c, 2.4, c)
            }
              , g = function(b, g) {
                var h, i, j, k, l, m;
                if (l = b._lazyrias,
                l.isPicture && a.matchMedia)
                    for (i = 0,
                    h = b.parentNode.getElementsByTagName("source"),
                    j = h.length; j > i; i++)
                        if (e(h[i]) && !h[i].getAttribute("type") && (!(k = h[i].getAttribute("media")) || (matchMedia(k) || {}).matches)) {
                            l = h[i]._lazyrias;
                            break
                        }
                return (!l.w || l.w < g) && (l.w = g,
                l.d = f(b),
                m = d(l.sort(c))),
                m
            }
              , h = function(c) {
                var d, f = c.target;
                return !u && (a.respimage || a.picturefill || lazySizesConfig.pf) ? void b.removeEventListener("lazybeforesizes", h) : void (("_lazyrias"in f || c.detail.dataAttr && e(f, !0)) && (d = g(f, c.detail.width),
                d && d.u && f._lazyrias.cur != d.u && (f._lazyrias.cur = d.u,
                d.cached = !0,
                lazySizes.rAF(function() {
                    f.setAttribute(i.srcAttr, d.u),
                    f.setAttribute("src", d.u)
                }))))
            };
            return v ? h = function() {}
            : addEventListener("lazybeforesizes", h),
            h
        }()
    }
}(window, document);
/*! lazysizes - v3.0.0 */
!function(a, b) {
    var c = b(a, a.document);
    a.lazySizes = c,
    "object" == typeof module && module.exports && (module.exports = c)
}(window, function(a, b) {
    "use strict";
    if (b.getElementsByClassName) {
        var c, d = b.documentElement, e = a.Date, f = a.HTMLPictureElement, g = "addEventListener", h = "getAttribute", i = a[g], j = a.setTimeout, k = a.requestAnimationFrame || j, l = a.requestIdleCallback, m = /^picture$/i, n = ["load", "error", "lazyincluded", "_lazyloaded"], o = {}, p = Array.prototype.forEach, q = function(a, b) {
            return o[b] || (o[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")),
            o[b].test(a[h]("class") || "") && o[b]
        }, r = function(a, b) {
            q(a, b) || a.setAttribute("class", (a[h]("class") || "").trim() + " " + b)
        }, s = function(a, b) {
            var c;
            (c = q(a, b)) && a.setAttribute("class", (a[h]("class") || "").replace(c, " "))
        }, t = function(a, b, c) {
            var d = c ? g : "removeEventListener";
            c && t(a, b),
            n.forEach(function(c) {
                a[d](c, b)
            })
        }, u = function(a, c, d, e, f) {
            var g = b.createEvent("CustomEvent");
            return g.initCustomEvent(c, !e, !f, d || {}),
            a.dispatchEvent(g),
            g
        }, v = function(b, d) {
            var e;
            !f && (e = a.picturefill || c.pf) ? e({
                reevaluate: !0,
                elements: [b]
            }) : d && d.src && (b.src = d.src)
        }, w = function(a, b) {
            return (getComputedStyle(a, null) || {})[b]
        }, x = function(a, b, d) {
            for (d = d || a.offsetWidth; d < c.minSize && b && !a._lazysizesWidth; )
                d = b.offsetWidth,
                b = b.parentNode;
            return d
        }, y = function() {
            var a, c, d = [], e = [], f = d, g = function() {
                var b = f;
                for (f = d.length ? e : d,
                a = !0,
                c = !1; b.length; )
                    b.shift()();
                a = !1
            }, h = function(d, e) {
                a && !e ? d.apply(this, arguments) : (f.push(d),
                c || (c = !0,
                (b.hidden ? j : k)(g)))
            };
            return h._lsFlush = g,
            h
        }(), z = function(a, b) {
            return b ? function() {
                y(a)
            }
            : function() {
                var b = this
                  , c = arguments;
                y(function() {
                    a.apply(b, c)
                })
            }
        }, A = function(a) {
            var b, c = 0, d = 125, f = 666, g = f, h = function() {
                b = !1,
                c = e.now(),
                a()
            }, i = l ? function() {
                l(h, {
                    timeout: g
                }),
                g !== f && (g = f)
            }
            : z(function() {
                j(h)
            }, !0);
            return function(a) {
                var f;
                (a = a === !0) && (g = 44),
                b || (b = !0,
                f = d - (e.now() - c),
                0 > f && (f = 0),
                a || 9 > f && l ? i() : j(i, f))
            }
        }, B = function(a) {
            var b, c, d = 99, f = function() {
                b = null,
                a()
            }, g = function() {
                var a = e.now() - c;
                d > a ? j(g, d - a) : (l || f)(f)
            };
            return function() {
                c = e.now(),
                b || (b = j(g, d))
            }
        }, C = function() {
            var f, k, l, n, o, x, C, E, F, G, H, I, J, K, L, M = /^img$/i, N = /^iframe$/i, O = "onscroll"in a && !/glebot/.test(navigator.userAgent), P = 0, Q = 0, R = 0, S = -1, T = function(a) {
                R--,
                a && a.target && t(a.target, T),
                (!a || 0 > R || !a.target) && (R = 0)
            }, U = function(a, c) {
                var e, f = a, g = "hidden" == w(b.body, "visibility") || "hidden" != w(a, "visibility");
                for (F -= c,
                I += c,
                G -= c,
                H += c; g && (f = f.offsetParent) && f != b.body && f != d; )
                    g = (w(f, "opacity") || 1) > 0,
                    g && "visible" != w(f, "overflow") && (e = f.getBoundingClientRect(),
                    g = H > e.left && G < e.right && I > e.top - 1 && F < e.bottom + 1);
                return g
            }, V = function() {
                var a, e, g, i, j, m, n, p, q;
                if ((o = c.loadMode) && 8 > R && (a = f.length)) {
                    e = 0,
                    S++,
                    null == K && ("expand"in c || (c.expand = d.clientHeight > 500 && d.clientWidth > 500 ? 500 : 370),
                    J = c.expand,
                    K = J * c.expFactor),
                    K > Q && 1 > R && S > 2 && o > 2 && !b.hidden ? (Q = K,
                    S = 0) : Q = o > 1 && S > 1 && 6 > R ? J : P;
                    for (; a > e; e++)
                        if (f[e] && !f[e]._lazyRace)
                            if (O)
                                if ((p = f[e][h]("data-expand")) && (m = 1 * p) || (m = Q),
                                q !== m && (C = innerWidth + m * L,
                                E = innerHeight + m,
                                n = -1 * m,
                                q = m),
                                g = f[e].getBoundingClientRect(),
                                (I = g.bottom) >= n && (F = g.top) <= E && (H = g.right) >= n * L && (G = g.left) <= C && (I || H || G || F) && (l && 3 > R && !p && (3 > o || 4 > S) || U(f[e], m))) {
                                    if (ba(f[e]),
                                    j = !0,
                                    R > 9)
                                        break
                                } else
                                    !j && l && !i && 4 > R && 4 > S && o > 2 && (k[0] || c.preloadAfterLoad) && (k[0] || !p && (I || H || G || F || "auto" != f[e][h](c.sizesAttr))) && (i = k[0] || f[e]);
                            else
                                ba(f[e]);
                    i && !j && ba(i)
                }
            }, W = A(V), X = function(a) {
                r(a.target, c.loadedClass),
                s(a.target, c.loadingClass),
                t(a.target, Z)
            }, Y = z(X), Z = function(a) {
                Y({
                    target: a.target
                })
            }, $ = function(a, b) {
                try {
                    a.contentWindow.location.replace(b)
                } catch (c) {
                    a.src = b
                }
            }, _ = function(a) {
                var b, d, e = a[h](c.srcsetAttr);
                (b = c.customMedia[a[h]("data-media") || a[h]("media")]) && a.setAttribute("media", b),
                e && a.setAttribute("srcset", e),
                b && (d = a.parentNode,
                d.insertBefore(a.cloneNode(), a),
                d.removeChild(a))
            }, aa = z(function(a, b, d, e, f) {
                var g, i, k, l, o, q;
                (o = u(a, "lazybeforeunveil", b)).defaultPrevented || (e && (d ? r(a, c.autosizesClass) : a.setAttribute("sizes", e)),
                i = a[h](c.srcsetAttr),
                g = a[h](c.srcAttr),
                f && (k = a.parentNode,
                l = k && m.test(k.nodeName || "")),
                q = b.firesLoad || "src"in a && (i || g || l),
                o = {
                    target: a
                },
                q && (t(a, T, !0),
                clearTimeout(n),
                n = j(T, 2500),
                r(a, c.loadingClass),
                t(a, Z, !0)),
                l && p.call(k.getElementsByTagName("source"), _),
                i ? a.setAttribute("srcset", i) : g && !l && (N.test(a.nodeName) ? $(a, g) : a.src = g),
                (i || l) && v(a, {
                    src: g
                })),
                a._lazyRace && delete a._lazyRace,
                s(a, c.lazyClass),
                y(function() {
                    (!q || a.complete && a.naturalWidth > 1) && (q ? T(o) : R--,
                    X(o))
                }, !0)
            }), ba = function(a) {
                var b, d = M.test(a.nodeName), e = d && (a[h](c.sizesAttr) || a[h]("sizes")), f = "auto" == e;
                (!f && l || !d || !a.src && !a.srcset || a.complete || q(a, c.errorClass)) && (b = u(a, "lazyunveilread").detail,
                f && D.updateElem(a, !0, a.offsetWidth),
                a._lazyRace = !0,
                R++,
                aa(a, b, f, e, d))
            }, ca = function() {
                if (!l) {
                    if (e.now() - x < 999)
                        return void j(ca, 999);
                    var a = B(function() {
                        c.loadMode = 3,
                        W()
                    });
                    l = !0,
                    c.loadMode = 3,
                    W(),
                    i("scroll", function() {
                        3 == c.loadMode && (c.loadMode = 2),
                        a()
                    }, !0)
                }
            };
            return {
                _: function() {
                    x = e.now(),
                    f = b.getElementsByClassName(c.lazyClass),
                    k = b.getElementsByClassName(c.lazyClass + " " + c.preloadClass),
                    L = c.hFac,
                    i("scroll", W, !0),
                    i("resize", W, !0),
                    a.MutationObserver ? new MutationObserver(W).observe(d, {
                        childList: !0,
                        subtree: !0,
                        attributes: !0
                    }) : (d[g]("DOMNodeInserted", W, !0),
                    d[g]("DOMAttrModified", W, !0),
                    setInterval(W, 999)),
                    i("hashchange", W, !0),
                    ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function(a) {
                        b[g](a, W, !0)
                    }),
                    /d$|^c/.test(b.readyState) ? ca() : (i("load", ca),
                    b[g]("DOMContentLoaded", W),
                    j(ca, 2e4)),
                    f.length ? (V(),
                    y._lsFlush()) : W()
                },
                checkElems: W,
                unveil: ba
            }
        }(), D = function() {
            var a, d = z(function(a, b, c, d) {
                var e, f, g;
                if (a._lazysizesWidth = d,
                d += "px",
                a.setAttribute("sizes", d),
                m.test(b.nodeName || ""))
                    for (e = b.getElementsByTagName("source"),
                    f = 0,
                    g = e.length; g > f; f++)
                        e[f].setAttribute("sizes", d);
                c.detail.dataAttr || v(a, c.detail)
            }), e = function(a, b, c) {
                var e, f = a.parentNode;
                f && (c = x(a, f, c),
                e = u(a, "lazybeforesizes", {
                    width: c,
                    dataAttr: !!b
                }),
                e.defaultPrevented || (c = e.detail.width,
                c && c !== a._lazysizesWidth && d(a, f, e, c)))
            }, f = function() {
                var b, c = a.length;
                if (c)
                    for (b = 0; c > b; b++)
                        e(a[b])
            }, g = B(f);
            return {
                _: function() {
                    a = b.getElementsByClassName(c.autosizesClass),
                    i("resize", g)
                },
                checkElems: g,
                updateElem: e
            }
        }(), E = function() {
            E.i || (E.i = !0,
            D._(),
            C._())
        };
        return function() {
            var b, d = {
                lazyClass: "lazyload",
                loadedClass: "lazyloaded",
                loadingClass: "lazyloading",
                preloadClass: "lazypreload",
                errorClass: "lazyerror",
                autosizesClass: "lazyautosizes",
                srcAttr: "data-src",
                srcsetAttr: "data-srcset",
                sizesAttr: "data-sizes",
                minSize: 40,
                customMedia: {},
                init: !0,
                expFactor: 1.5,
                hFac: .8,
                loadMode: 2
            };
            c = a.lazySizesConfig || a.lazysizesConfig || {};
            for (b in d)
                b in c || (c[b] = d[b]);
            a.lazySizesConfig = c,
            j(function() {
                c.init && E()
            })
        }(),
        {
            cfg: c,
            autoSizer: D,
            loader: C,
            init: E,
            uP: v,
            aC: r,
            rC: s,
            hC: q,
            fire: u,
            gW: x,
            rAF: y
        }
    }
});
/*! lazysizes - v3.0.0 */
!function(a, b) {
    "use strict";
    if (a.addEventListener) {
        var c = /\s+(\d+)(w|h)\s+(\d+)(w|h)/
          , d = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/
          , e = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/
          , f = /^picture$/i
          , g = function(a) {
            return getComputedStyle(a, null) || {}
        }
          , h = {
            getParent: function(b, c) {
                var d = b
                  , e = b.parentNode;
                return c && "prev" != c || !e || !f.test(e.nodeName || "") || (e = e.parentNode),
                "self" != c && (d = "prev" == c ? b.previousElementSibling : c && (e.closest || a.jQuery) ? (e.closest ? e.closest(c) : jQuery(e).closest(c)[0]) || e : e),
                d
            },
            getFit: function(a) {
                var b, c, f = g(a), i = f.content || f.fontFamily, j = {
                    fit: a._lazysizesParentFit || a.getAttribute("data-parent-fit")
                };
                return !j.fit && i && (b = i.match(d)) && (j.fit = b[1]),
                j.fit ? (c = a._lazysizesParentContainer || a.getAttribute("data-parent-container"),
                !c && i && (b = i.match(e)) && (c = b[1]),
                j.parent = h.getParent(a, c)) : j.fit = f.objectFit,
                j
            },
            getImageRatio: function(b) {
                var d, e, g, h, i = b.parentNode, j = i && f.test(i.nodeName || "") ? i.querySelectorAll("source, img") : [b];
                for (d = 0; d < j.length; d++)
                    if (b = j[d],
                    e = b.getAttribute(lazySizesConfig.srcsetAttr) || b.getAttribute("srcset") || b.getAttribute("data-pfsrcset") || b.getAttribute("data-risrcset") || "",
                    g = b.getAttribute("media"),
                    g = lazySizesConfig.customMedia[b.getAttribute("data-media") || g] || g,
                    e && (!g || (a.matchMedia && matchMedia(g) || {}).matches)) {
                        h = parseFloat(b.getAttribute("data-aspectratio")),
                        !h && e.match(c) && (h = "w" == RegExp.$2 ? RegExp.$1 / RegExp.$3 : RegExp.$3 / RegExp.$1);
                        break
                    }
                return h
            },
            calculateSize: function(a, b) {
                var c, d, e, f, g = this.getFit(a), h = g.fit, i = g.parent;
                return "width" == h || ("contain" == h || "cover" == h) && (e = this.getImageRatio(a)) ? (i ? b = i.clientWidth : i = a,
                f = b,
                "width" == h ? f = b : (d = i.clientHeight,
                d > 40 && (c = b / d) && ("cover" == h && e > c || "contain" == h && c > e) && (f = b * (e / c))),
                f) : b
            }
        }
          , i = function() {
            a.lazySizes && (lazySizes.parentFit || (lazySizes.parentFit = h),
            a.removeEventListener("lazyunveilread", i, !0))
        };
        a.addEventListener("lazyunveilread", i, !0),
        b.addEventListener("lazybeforesizes", function(a) {
            if (!a.defaultPrevented) {
                var b = a.target;
                a.detail.width = h.calculateSize(b, a.detail.width)
            }
        }),
        setTimeout(i)
    }
}(window, document);
/*! lazysizes - v3.0.0 */
!function(a, b, c) {
    "use strict";
    var d, e = a.lazySizes && lazySizes.cfg || a.lazySizesConfig, f = b.createElement("img"), g = "sizes"in f && "srcset"in f, h = /\s+\d+h/g, i = function() {
        var a = /\s+(\d+)(w|h)\s+(\d+)(w|h)/
          , c = Array.prototype.forEach;
        return function(d) {
            var e = b.createElement("img")
              , f = function(b) {
                var c, d = b.getAttribute(lazySizesConfig.srcsetAttr);
                d && (d.match(a) && (c = "w" == RegExp.$2 ? RegExp.$1 / RegExp.$3 : RegExp.$3 / RegExp.$1,
                c && b.setAttribute("data-aspectratio", c)),
                b.setAttribute(lazySizesConfig.srcsetAttr, d.replace(h, "")))
            }
              , g = function(a) {
                var b = a.target.parentNode;
                b && "PICTURE" == b.nodeName && c.call(b.getElementsByTagName("source"), f),
                f(a.target)
            }
              , i = function() {
                e.currentSrc && b.removeEventListener("lazybeforeunveil", g)
            };
            d[1] && (b.addEventListener("lazybeforeunveil", g),
            e.onload = i,
            e.onerror = i,
            e.srcset = "data:,a 1w 1h",
            e.complete && i())
        }
    }();
    if (e || (e = {},
    a.lazySizesConfig = e),
    e.supportsType || (e.supportsType = function(a) {
        return !a
    }
    ),
    !a.picturefill && !e.pf) {
        if (a.HTMLPictureElement && g)
            return b.msElementsFromPoint && i(navigator.userAgent.match(/Edge\/(\d+)/)),
            void (e.pf = function() {}
            );
        e.pf = function(b) {
            var c, e;
            if (!a.picturefill)
                for (c = 0,
                e = b.elements.length; e > c; c++)
                    d(b.elements[c])
        }
        ,
        d = function() {
            var c = function(a, b) {
                return a.w - b.w
            }
              , f = /^\s*\d+\.*\d*px\s*$/
              , i = function(a) {
                var b, c, d = a.length, e = a[d - 1], f = 0;
                for (f; d > f; f++)
                    if (e = a[f],
                    e.d = e.w / a.w,
                    e.d >= a.d) {
                        !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6),
                        b.cached && (b.d += .15 * c),
                        b.d + (e.d - a.d) * c > a.d && (e = b));
                        break
                    }
                return e
            }
              , j = function() {
                var a, b = /(([^,\s].[^\s]+)\s+(\d+)w)/g, c = /\s/, d = function(b, c, d, e) {
                    a.push({
                        c: c,
                        u: d,
                        w: 1 * e
                    })
                };
                return function(e) {
                    return a = [],
                    e = e.trim(),
                    e.replace(h, "").replace(b, d),
                    a.length || !e || c.test(e) || a.push({
                        c: e,
                        u: e,
                        w: 99
                    }),
                    a
                }
            }()
              , k = function() {
                k.init || (k.init = !0,
                addEventListener("resize", function() {
                    var a, c = b.getElementsByClassName("lazymatchmedia"), e = function() {
                        var a, b;
                        for (a = 0,
                        b = c.length; b > a; a++)
                            d(c[a])
                    };
                    return function() {
                        clearTimeout(a),
                        a = setTimeout(e, 66)
                    }
                }()))
            }
              , l = function(b, c) {
                var d, f = b.getAttribute("srcset") || b.getAttribute(e.srcsetAttr);
                !f && c && (f = b._lazypolyfill ? b._lazypolyfill._set : b.getAttribute(e.srcAttr) || b.getAttribute("src")),
                b._lazypolyfill && b._lazypolyfill._set == f || (d = j(f || ""),
                c && b.parentNode && (d.isPicture = "PICTURE" == b.parentNode.nodeName.toUpperCase(),
                d.isPicture && a.matchMedia && (lazySizes.aC(b, "lazymatchmedia"),
                k())),
                d._set = f,
                Object.defineProperty(b, "_lazypolyfill", {
                    value: d,
                    writable: !0
                }))
            }
              , m = function(b) {
                var c = a.devicePixelRatio || 1
                  , d = lazySizes.getX && lazySizes.getX(b);
                return Math.min(d || c, 2.5, c)
            }
              , n = function(b) {
                return a.matchMedia ? (n = function(a) {
                    return !a || (matchMedia(a) || {}).matches
                }
                )(b) : !b
            }
              , o = function(a) {
                var b, d, g, h, j, k, o;
                if (h = a,
                l(h, !0),
                j = h._lazypolyfill,
                j.isPicture)
                    for (d = 0,
                    b = a.parentNode.getElementsByTagName("source"),
                    g = b.length; g > d; d++)
                        if (e.supportsType(b[d].getAttribute("type"), a) && n(b[d].getAttribute("media"))) {
                            h = b[d],
                            l(h),
                            j = h._lazypolyfill;
                            break
                        }
                return j.length > 1 ? (o = h.getAttribute("sizes") || "",
                o = f.test(o) && parseInt(o, 10) || lazySizes.gW(a, a.parentNode),
                j.d = m(a),
                !j.src || !j.w || j.w < o ? (j.w = o,
                k = i(j.sort(c)),
                j.src = k) : k = j.src) : k = j[0],
                k
            }
              , p = function(a) {
                if (!g || !a.parentNode || "PICTURE" == a.parentNode.nodeName.toUpperCase()) {
                    var b = o(a);
                    b && b.u && a._lazypolyfill.cur != b.u && (a._lazypolyfill.cur = b.u,
                    b.cached = !0,
                    a.setAttribute(e.srcAttr, b.u),
                    a.setAttribute("src", b.u))
                }
            };
            return p.parse = j,
            p
        }(),
        e.loadedClass && e.loadingClass && !function() {
            var a = [];
            ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function(b) {
                a.push(b + e.loadedClass),
                a.push(b + e.loadingClass)
            }),
            e.pf({
                elements: b.querySelectorAll(a.join(", "))
            })
        }()
    }
}(window, document),
function(a) {
    "use strict";
    var b, c = a.createElement("img");
    !("srcset"in c) || "sizes"in c || window.HTMLPictureElement || (b = /^picture$/i,
    a.addEventListener("lazybeforeunveil", function(c) {
        var d, e, f, g, h, i, j;
        !c.defaultPrevented && !lazySizesConfig.noIOSFix && (d = c.target) && (f = d.getAttribute(lazySizesConfig.srcsetAttr)) && (e = d.parentNode) && ((h = b.test(e.nodeName || "")) || (g = d.getAttribute("sizes") || d.getAttribute(lazySizesConfig.sizesAttr))) && (i = h ? e : a.createElement("picture"),
        d._lazyImgSrc || Object.defineProperty(d, "_lazyImgSrc", {
            value: a.createElement("source"),
            writable: !0
        }),
        j = d._lazyImgSrc,
        g && j.setAttribute("sizes", g),
        j.setAttribute(lazySizesConfig.srcsetAttr, f),
        d.setAttribute("data-pfsrcset", f),
        d.removeAttribute(lazySizesConfig.srcsetAttr),
        h || (e.insertBefore(i, d),
        i.appendChild(d)),
        i.insertBefore(j, d))
    }))
}(document);
/*! lazysizes - v3.0.0 */
!function() {
    "use strict";
    if (window.addEventListener) {
        var a = /\s+/g
          , b = /\s*\|\s+|\s+\|\s*/g
          , c = /^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/
          , d = /\(|\)|'/
          , e = {
            contain: 1,
            cover: 1
        }
          , f = function(a) {
            var b = lazySizes.gW(a, a.parentNode);
            return (!a._lazysizesWidth || b > a._lazysizesWidth) && (a._lazysizesWidth = b),
            a._lazysizesWidth
        }
          , g = function(a) {
            var b;
            return b = (getComputedStyle(a) || {
                getPropertyValue: function() {}
            }).getPropertyValue("background-size"),
            !e[b] && e[a.style.backgroundSize] && (b = a.style.backgroundSize),
            b
        }
          , h = function(d, e, f) {
            var g = document.createElement("picture")
              , h = e.getAttribute(lazySizesConfig.sizesAttr)
              , i = e.getAttribute("data-ratio")
              , j = e.getAttribute("data-optimumx");
            e._lazybgset && e._lazybgset.parentNode == e && e.removeChild(e._lazybgset),
            Object.defineProperty(f, "_lazybgset", {
                value: e,
                writable: !0
            }),
            Object.defineProperty(e, "_lazybgset", {
                value: g,
                writable: !0
            }),
            d = d.replace(a, " ").split(b),
            g.style.display = "none",
            f.className = lazySizesConfig.lazyClass,
            1 != d.length || h || (h = "auto"),
            d.forEach(function(a) {
                var b = document.createElement("source");
                h && "auto" != h && b.setAttribute("sizes", h),
                a.match(c) && (b.setAttribute(lazySizesConfig.srcsetAttr, RegExp.$1),
                RegExp.$2 && b.setAttribute("media", lazySizesConfig.customMedia[RegExp.$2] || RegExp.$2)),
                g.appendChild(b)
            }),
            h && (f.setAttribute(lazySizesConfig.sizesAttr, h),
            e.removeAttribute(lazySizesConfig.sizesAttr),
            e.removeAttribute("sizes")),
            j && f.setAttribute("data-optimumx", j),
            i && f.setAttribute("data-ratio", i),
            g.appendChild(f),
            e.appendChild(g)
        }
          , i = function(a) {
            if (a.target._lazybgset) {
                var b = a.target
                  , c = b._lazybgset
                  , e = b.currentSrc || b.src;
                e && (c.style.backgroundImage = "url(" + (d.test(e) ? JSON.stringify(e) : e) + ")"),
                b._lazybgsetLoading && (lazySizes.fire(c, "_lazyloaded", {}, !1, !0),
                delete b._lazybgsetLoading)
            }
        };
        addEventListener("lazybeforeunveil", function(a) {
            var b, c, d;
            !a.defaultPrevented && (b = a.target.getAttribute("data-bgset")) && (d = a.target,
            c = document.createElement("img"),
            c.alt = "",
            c._lazybgsetLoading = !0,
            a.detail.firesLoad = !0,
            h(b, d, c),
            setTimeout(function() {
                lazySizes.loader.unveil(c),
                lazySizes.rAF(function() {
                    lazySizes.fire(c, "_lazyloaded", {}, !0, !0),
                    c.complete && i({
                        target: c
                    })
                })
            }))
        }),
        document.addEventListener("load", i, !0),
        window.addEventListener("lazybeforesizes", function(a) {
            if (a.target._lazybgset && a.detail.dataAttr) {
                var b = a.target._lazybgset
                  , c = g(b);
                e[c] && (a.target._lazysizesParentFit = c,
                lazySizes.rAF(function() {
                    a.target.setAttribute("data-parent-fit", c),
                    a.target._lazysizesParentFit && delete a.target._lazysizesParentFit
                }))
            }
        }, !0),
        document.documentElement.addEventListener("lazybeforesizes", function(a) {
            !a.defaultPrevented && a.target._lazybgset && (a.detail.width = f(a.target._lazybgset))
        })
    }
}();
/*!* enquire.min.js*/
/*!
 * enquire.js v2.1.2 - Awesome Media Queries in JavaScript
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)*/
!function(e, t, n) {
    var i = window.matchMedia;
    "undefined" != typeof module && module.exports ? module.exports = n(i) : "function" == typeof define && define.amd ? define(function() {
        return t[e] = n(i)
    }) : t[e] = n(i)
}("enquire", this, function(e) {
    "use strict";
    function t(e, t) {
        var n, i = 0, o = e.length;
        for (i; o > i && (n = t(e[i], i),
        n !== !1); i++)
            ;
    }
    function n(e) {
        return "[object Array]" === Object.prototype.toString.apply(e)
    }
    function i(e) {
        return "function" == typeof e
    }
    function o(e) {
        this.options = e,
        !e.deferSetup && this.setup()
    }
    function r(t, n) {
        this.query = t,
        this.isUnconditional = n,
        this.handlers = [],
        this.mql = e(t);
        var i = this;
        this.listener = function(e) {
            i.mql = e,
            i.assess()
        }
        ,
        this.mql.addListener(this.listener)
    }
    function s() {
        if (!e)
            throw new Error("matchMedia not present, legacy browsers require a polyfill");
        this.queries = {},
        this.browserIsIncapable = !e("only all").matches
    }
    return o.prototype = {
        setup: function() {
            this.options.setup && this.options.setup(),
            this.initialised = !0
        },
        on: function() {
            !this.initialised && this.setup(),
            this.options.match && this.options.match()
        },
        off: function() {
            this.options.unmatch && this.options.unmatch()
        },
        destroy: function() {
            this.options.destroy ? this.options.destroy() : this.off()
        },
        equals: function(e) {
            return this.options === e || this.options.match === e
        }
    },
    r.prototype = {
        addHandler: function(e) {
            var t = new o(e);
            this.handlers.push(t),
            this.matches() && t.on()
        },
        removeHandler: function(e) {
            var n = this.handlers;
            t(n, function(t, i) {
                return t.equals(e) ? (t.destroy(),
                !n.splice(i, 1)) : void 0
            })
        },
        matches: function() {
            return this.mql.matches || this.isUnconditional
        },
        clear: function() {
            t(this.handlers, function(e) {
                e.destroy()
            }),
            this.mql.removeListener(this.listener),
            this.handlers.length = 0
        },
        assess: function() {
            var e = this.matches() ? "on" : "off";
            t(this.handlers, function(t) {
                t[e]()
            })
        }
    },
    s.prototype = {
        register: function(e, o, s) {
            var a = this.queries
              , l = s && this.browserIsIncapable;
            return a[e] || (a[e] = new r(e,l)),
            i(o) && (o = {
                match: o
            }),
            n(o) || (o = [o]),
            t(o, function(t) {
                i(t) && (t = {
                    match: t
                }),
                a[e].addHandler(t)
            }),
            this
        },
        unregister: function(e, t) {
            var n = this.queries[e];
            return n && (t ? n.removeHandler(t) : (n.clear(),
            delete this.queries[e])),
            this
        }
    },
    new s
}),
/*!
 * jquery.zoom.min.js */
/*! Zoom 1.7.15 - http://www.jacklmoore.com/zoom */
function(e) {
    var t = {
        url: !1,
        callback: !1,
        target: !1,
        duration: 120,
        on: "mouseover",
        touch: !0,
        onZoomIn: !1,
        onZoomOut: !1,
        magnify: 1
    };
    e.zoom = function(t, n, i, o) {
        var r, s, a, l, u, c, d, p = e(t), f = p.css("position"), h = e(n);
        return p.css("position", /(absolute|fixed)/.test(f) ? f : "relative"),
        p.css("overflow", "hidden"),
        i.style.width = i.style.height = "",
        e(i).addClass("zoomImg").css({
            position: "absolute",
            top: 0,
            left: 0,
            opacity: 0,
            width: i.width * o,
            height: i.height * o,
            border: "none",
            maxWidth: "none",
            maxHeight: "none"
        }).appendTo(t),
        {
            init: function() {
                s = p.outerWidth(),
                r = p.outerHeight(),
                n === p[0] ? (l = s,
                a = r) : (l = h.outerWidth(),
                a = h.outerHeight()),
                u = (i.width - s) / l,
                c = (i.height - r) / a,
                d = h.offset()
            },
            move: function(e) {
                var t = e.pageX - d.left
                  , n = e.pageY - d.top;
                n = Math.max(Math.min(n, a), 0),
                t = Math.max(Math.min(t, l), 0),
                i.style.left = t * -u + "px",
                i.style.top = n * -c + "px"
            }
        }
    }
    ,
    e.fn.zoom = function(n) {
        return this.each(function() {
            var i, o = e.extend({}, t, n || {}), r = o.target || this, s = this, a = e(s), l = e(r), u = document.createElement("img"), c = e(u), d = "mousemove.zoom", p = !1, f = !1;
            (o.url || (i = a.find("img"),
            i[0] && (o.url = i.data("src") || i.attr("src")),
            o.url)) && (!function() {
                var e = l.css("position")
                  , t = l.css("overflow");
                a.one("zoom.destroy", function() {
                    a.off(".zoom"),
                    l.css("position", e),
                    l.css("overflow", t),
                    c.remove()
                })
            }(),
            u.onload = function() {
                function t(t) {
                    i.init(),
                    i.move(t),
                    c.stop().fadeTo(e.support.opacity ? o.duration : 0, 1, !!e.isFunction(o.onZoomIn) && o.onZoomIn.call(u))
                }
                function n() {
                    c.stop().fadeTo(o.duration, 0, !!e.isFunction(o.onZoomOut) && o.onZoomOut.call(u))
                }
                var i = e.zoom(r, s, u, o.magnify);
                "grab" === o.on ? a.on("mousedown.zoom", function(o) {
                    1 === o.which && (e(document).one("mouseup.zoom", function() {
                        n(),
                        e(document).off(d, i.move)
                    }),
                    t(o),
                    e(document).on(d, i.move),
                    o.preventDefault())
                }) : "click" === o.on ? a.on("click.zoom", function(o) {
                    return p ? void 0 : (p = !0,
                    t(o),
                    e(document).on(d, i.move),
                    e(document).one("click.zoom", function() {
                        n(),
                        p = !1,
                        e(document).off(d, i.move)
                    }),
                    !1)
                }) : "toggle" === o.on ? a.on("click.zoom", function(e) {
                    p ? n() : t(e),
                    p = !p
                }) : "mouseover" === o.on && (i.init(),
                a.on("mouseenter.zoom", t).on("mouseleave.zoom", n).on(d, i.move)),
                o.touch && a.on("touchstart.zoom", function(e) {
                    e.preventDefault(),
                    f ? (f = !1,
                    n()) : (f = !0,
                    t(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]))
                }).on("touchmove.zoom", function(e) {
                    e.preventDefault(),
                    i.move(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0])
                }).on("touchend.zoom", function(e) {
                    e.preventDefault(),
                    f && (f = !1,
                    n())
                }),
                e.isFunction(o.callback) && o.callback.call(u)
            }
            ,
            u.src = o.url)
        })
    }
    ,
    e.fn.zoom.defaults = t
}(window.jQuery),
function() {
    function e(e, t) {
        for (var n = -1, i = t.length, o = e.length; ++n < i; )
            e[o + n] = t[n];
        return e
    }
    function t(e, t, n) {
        for (var i = -1, o = e.length; ++i < o; ) {
            var r = e[i]
              , s = t(r);
            if (null != s && (a === le ? s === s : n(s, a)))
                var a = s
                  , l = r
        }
        return l
    }
    function n(e, t, n) {
        var i;
        return n(e, function(e, n, o) {
            return t(e, n, o) ? (i = e,
            !1) : void 0
        }),
        i
    }
    function i(e, t, n, i, o) {
        return o(e, function(e, o, r) {
            n = i ? (i = !1,
            e) : t(n, e, o, r)
        }),
        n
    }
    function o(e, t) {
        return T(t, function(t) {
            return e[t]
        })
    }
    function r(e) {
        return e && e.Object === Object ? e : null
    }
    function s(e) {
        return fe[e]
    }
    function a(e) {
        var t = !1;
        if (null != e && "function" != typeof e.toString)
            try {
                t = !!(e + "")
            } catch (e) {}
        return t
    }
    function l(e, t) {
        return e = "number" == typeof e || pe.test(e) ? +e : -1,
        e > -1 && 0 == e % 1 && (null == t ? 9007199254740991 : t) > e
    }
    function u(e) {
        if (Z(e) && !Re(e)) {
            if (e instanceof c)
                return e;
            if (Ce.call(e, "__wrapped__")) {
                var t = new c(e.__wrapped__,e.__chain__);
                return t.__actions__ = A(e.__actions__),
                t
            }
        }
        return new c(e)
    }
    function c(e, t) {
        this.__wrapped__ = e,
        this.__actions__ = [],
        this.__chain__ = !!t
    }
    function d(e, t, n, i) {
        var o;
        return (o = e === le) || (o = Te[n],
        o = (e === o || e !== e && o !== o) && !Ce.call(i, n)),
        o ? t : e
    }
    function p(e) {
        return J(e) ? Ne(e) : {}
    }
    function f(e, t, n) {
        if ("function" != typeof e)
            throw new TypeError("Expected a function");
        return setTimeout(function() {
            e.apply(le, n)
        }, t)
    }
    function h(e, t) {
        var n = !0;
        return Pe(e, function(e, i, o) {
            return n = !!t(e, i, o)
        }),
        n
    }
    function v(e, t) {
        var n = [];
        return Pe(e, function(e, i, o) {
            t(e, i, o) && n.push(e)
        }),
        n
    }
    function g(t, n, i, o) {
        o || (o = []);
        for (var r = -1, s = t.length; ++r < s; ) {
            var a = t[r];
            n > 0 && Z(a) && V(a) && (i || Re(a) || Y(a)) ? n > 1 ? g(a, n - 1, i, o) : e(o, a) : i || (o[o.length] = a)
        }
        return o
    }
    function m(e, t) {
        return e && Le(e, t, ie)
    }
    function y(e, t) {
        return v(t, function(t) {
            return G(e[t])
        })
    }
    function w(e, t, n, i, o) {
        return e === t || (null == e || null == t || !J(e) && !Z(t) ? e !== e && t !== t : b(e, t, w, n, i, o))
    }
    function b(e, t, n, i, o, r) {
        var s = Re(e)
          , l = Re(t)
          , u = "[object Array]"
          , c = "[object Array]";
        s || (u = $e.call(e),
        "[object Arguments]" == u && (u = "[object Object]")),
        l || (c = $e.call(t),
        "[object Arguments]" == c && (c = "[object Object]"));
        var d = "[object Object]" == u && !a(e)
          , l = "[object Object]" == c && !a(t);
        return !(c = u == c) || s || d ? 2 & o || (u = d && Ce.call(e, "__wrapped__"),
        l = l && Ce.call(t, "__wrapped__"),
        !u && !l) ? !!c && (r || (r = []),
        (u = M(r, function(t) {
            return t[0] === e
        })) && u[1] ? u[1] == t : (r.push([e, t]),
        t = (s ? P : _)(e, t, n, i, o, r),
        r.pop(),
        t)) : n(u ? e.value() : e, l ? t.value() : t, i, o, r) : L(e, t, u)
    }
    function x(e) {
        var t = typeof e;
        return "function" == t ? e : null == e ? se : ("object" == t ? C : $)(e)
    }
    function k(e) {
        e = null == e ? e : Object(e);
        var t, n = [];
        for (t in e)
            n.push(t);
        return n
    }
    function T(e, t) {
        var n = -1
          , i = V(e) ? Array(e.length) : [];
        return Pe(e, function(e, o, r) {
            i[++n] = t(e, o, r)
        }),
        i
    }
    function C(e) {
        var t = ie(e);
        return function(n) {
            var i = t.length;
            if (null == n)
                return !i;
            for (n = Object(n); i--; ) {
                var o = t[i];
                if (!(o in n && w(e[o], n[o], le, 3)))
                    return !1
            }
            return !0
        }
    }
    function S(e, t) {
        return e = Object(e),
        W(t, function(t, n) {
            return n in e && (t[n] = e[n]),
            t
        }, {})
    }
    function $(e) {
        return function(t) {
            return null == t ? le : t[e]
        }
    }
    function E(e, t, n) {
        var i = -1
          , o = e.length;
        for (0 > t && (t = -t > o ? 0 : o + t),
        n = n > o ? o : n,
        0 > n && (n += o),
        o = t > n ? 0 : n - t >>> 0,
        t >>>= 0,
        n = Array(o); ++i < o; )
            n[i] = e[i + t];
        return n
    }
    function A(e) {
        return E(e, 0, e.length)
    }
    function j(e, t) {
        var n;
        return Pe(e, function(e, i, o) {
            return n = t(e, i, o),
            !n
        }),
        !!n
    }
    function N(t, n) {
        return W(n, function(t, n) {
            return n.func.apply(n.thisArg, e([t], n.args))
        }, t)
    }
    function D(e, t, n, i) {
        n || (n = {});
        for (var o = -1, r = t.length; ++o < r; ) {
            var s = t[o]
              , a = i ? i(n[s], e[s], s, n, e) : e[s]
              , l = n
              , u = l[s];
            Ce.call(l, s) && (u === a || u !== u && a !== a) && (a !== le || s in l) || (l[s] = a)
        }
        return n
    }
    function O(e) {
        return U(function(t, n) {
            var i = -1
              , o = n.length
              , r = o > 1 ? n[o - 1] : le
              , r = "function" == typeof r ? (o--,
            r) : le;
            for (t = Object(t); ++i < o; ) {
                var s = n[i];
                s && e(t, s, i, r)
            }
            return t
        })
    }
    function H(e) {
        return function() {
            var t = arguments
              , n = p(e.prototype)
              , t = e.apply(n, t);
            return J(t) ? t : n
        }
    }
    function q(e, t, n) {
        function i() {
            for (var r = -1, s = arguments.length, a = -1, l = n.length, u = Array(l + s), c = this && this !== xe && this instanceof i ? o : e; ++a < l; )
                u[a] = n[a];
            for (; s--; )
                u[a++] = arguments[++r];
            return c.apply(t, u)
        }
        if ("function" != typeof e)
            throw new TypeError("Expected a function");
        var o = H(e);
        return i
    }
    function P(e, t, n, i, o, r) {
        var s = -1
          , a = 1 & o
          , l = e.length
          , u = t.length;
        if (l != u && !(2 & o && u > l))
            return !1;
        for (u = !0; ++s < l; ) {
            var c = e[s]
              , d = t[s];
            if (void 0 !== le) {
                u = !1;
                break
            }
            if (a) {
                if (!j(t, function(e) {
                    return c === e || n(c, e, i, o, r)
                })) {
                    u = !1;
                    break
                }
            } else if (c !== d && !n(c, d, i, o, r)) {
                u = !1;
                break
            }
        }
        return u
    }
    function L(e, t, n) {
        switch (n) {
        case "[object Boolean]":
        case "[object Date]":
            return +e == +t;
        case "[object Error]":
            return e.name == t.name && e.message == t.message;
        case "[object Number]":
            return e != +e ? t != +t : e == +t;
        case "[object RegExp]":
        case "[object String]":
            return e == t + ""
        }
        return !1
    }
    function _(e, t, n, i, o, r) {
        var s = 2 & o
          , a = ie(e)
          , l = a.length
          , u = ie(t).length;
        if (l != u && !s)
            return !1;
        for (var c = l; c--; ) {
            var d = a[c];
            if (!(s ? d in t : Ce.call(t, d)))
                return !1
        }
        for (u = !0; ++c < l; ) {
            var d = a[c]
              , p = e[d]
              , f = t[d];
            if (void 0 !== le || p !== f && !n(p, f, i, o, r)) {
                u = !1;
                break
            }
            s || (s = "constructor" == d)
        }
        return u && !s && (n = e.constructor,
        i = t.constructor,
        n != i && "constructor"in e && "constructor"in t && !("function" == typeof n && n instanceof n && "function" == typeof i && i instanceof i) && (u = !1)),
        u
    }
    function z(e) {
        var t = e ? e.length : le;
        if (Q(t) && (Re(e) || ee(e) || Y(e))) {
            e = String;
            for (var n = -1, i = Array(t); ++n < t; )
                i[n] = e(n);
            t = i
        } else
            t = null;
        return t
    }
    function I(e) {
        var t = e && e.constructor
          , t = G(t) && t.prototype || Te;
        return e === t
    }
    function F(e) {
        return e ? e[0] : le
    }
    function M(e, t) {
        return n(e, x(t), Pe)
    }
    function R(e, t) {
        return Pe(e, "function" == typeof t ? t : se)
    }
    function W(e, t, n) {
        return i(e, x(t), n, 3 > arguments.length, Pe)
    }
    function B(e, t) {
        var n;
        if ("function" != typeof t)
            throw new TypeError("Expected a function");
        return e = We(e),
        function() {
            return 0 < --e && (n = t.apply(this, arguments)),
            1 >= e && (t = le),
            n
        }
    }
    function U(e) {
        var t;
        if ("function" != typeof e)
            throw new TypeError("Expected a function");
        return t = qe(t === le ? e.length - 1 : We(t), 0),
        function() {
            for (var n = arguments, i = -1, o = qe(n.length - t, 0), r = Array(o); ++i < o; )
                r[i] = n[t + i];
            for (o = Array(t + 1),
            i = -1; ++i < t; )
                o[i] = n[i];
            return o[t] = r,
            e.apply(this, o)
        }
    }
    function X(e, t) {
        return e > t
    }
    function Y(e) {
        return Z(e) && V(e) && Ce.call(e, "callee") && (!De.call(e, "callee") || "[object Arguments]" == $e.call(e))
    }
    function V(e) {
        return null != e && !("function" == typeof e && G(e)) && Q(_e(e))
    }
    function G(e) {
        return e = J(e) ? $e.call(e) : "",
        "[object Function]" == e || "[object GeneratorFunction]" == e
    }
    function Q(e) {
        return "number" == typeof e && e > -1 && 0 == e % 1 && 9007199254740991 >= e
    }
    function J(e) {
        var t = typeof e;
        return !!e && ("object" == t || "function" == t)
    }
    function Z(e) {
        return !!e && "object" == typeof e
    }
    function K(e) {
        return "number" == typeof e || Z(e) && "[object Number]" == $e.call(e)
    }
    function ee(e) {
        return "string" == typeof e || !Re(e) && Z(e) && "[object String]" == $e.call(e)
    }
    function te(e, t) {
        return t > e
    }
    function ne(e) {
        return "string" == typeof e ? e : null == e ? "" : e + ""
    }
    function ie(e) {
        var t = I(e);
        if (!t && !V(e))
            return He(Object(e));
        var n, i = z(e), o = !!i, i = i || [], r = i.length;
        for (n in e)
            !Ce.call(e, n) || o && ("length" == n || l(n, r)) || t && "constructor" == n || i.push(n);
        return i
    }
    function oe(e) {
        for (var t = -1, n = I(e), i = k(e), o = i.length, r = z(e), s = !!r, r = r || [], a = r.length; ++t < o; ) {
            var u = i[t];
            s && ("length" == u || l(u, a)) || "constructor" == u && (n || !Ce.call(e, u)) || r.push(u)
        }
        return r
    }
    function re(e) {
        return e ? o(e, ie(e)) : []
    }
    function se(e) {
        return e
    }
    function ae(t, n, i) {
        var o = ie(n)
          , r = y(n, o);
        null != i || J(n) && (r.length || !o.length) || (i = n,
        n = t,
        t = this,
        r = y(n, ie(n)));
        var s = !(J(i) && "chain"in i) || i.chain
          , a = G(t);
        return Pe(r, function(i) {
            var o = n[i];
            t[i] = o,
            a && (t.prototype[i] = function() {
                var n = this.__chain__;
                if (s || n) {
                    var i = t(this.__wrapped__);
                    return (i.__actions__ = A(this.__actions__)).push({
                        func: o,
                        args: arguments,
                        thisArg: t
                    }),
                    i.__chain__ = n,
                    i
                }
                return o.apply(t, e([this.value()], arguments))
            }
            )
        }),
        t
    }
    var le, ue = 1 / 0, ce = /[&<>"'`]/g, de = RegExp(ce.source), pe = /^(?:0|[1-9]\d*)$/, fe = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
        "`": "&#96;"
    }, he = {
        function: !0,
        object: !0
    }, ve = he[typeof exports] && exports && !exports.nodeType ? exports : le, ge = he[typeof module] && module && !module.nodeType ? module : le, me = ge && ge.exports === ve ? ve : le, ye = r(he[typeof self] && self), we = r(he[typeof window] && window), be = r(he[typeof this] && this), xe = r(ve && ge && "object" == typeof global && global) || we !== (be && be.window) && we || ye || be || Function("return this")(), ke = Array.prototype, Te = Object.prototype, Ce = Te.hasOwnProperty, Se = 0, $e = Te.toString, Ee = xe._, Ae = xe.Reflect, je = Ae ? Ae.f : le, Ne = Object.create, De = Te.propertyIsEnumerable, Oe = xe.isFinite, He = Object.keys, qe = Math.max, Pe = function(e, t) {
        return function(n, i) {
            if (null == n)
                return n;
            if (!V(n))
                return e(n, i);
            for (var o = n.length, r = t ? o : -1, s = Object(n); (t ? r-- : ++r < o) && !1 !== i(s[r], r, s); )
                ;
            return n
        }
    }(m), Le = function(e) {
        return function(t, n, i) {
            var o = -1
              , r = Object(t);
            i = i(t);
            for (var s = i.length; s--; ) {
                var a = i[e ? s : ++o];
                if (!1 === n(r[a], a, r))
                    break
            }
            return t
        }
    }();
    je && !De.call({
        valueOf: 1
    }, "valueOf") && (k = function(e) {
        e = je(e);
        for (var t, n = []; !(t = e.next()).done; )
            n.push(t.value);
        return n
    }
    );
    var _e = $("length")
      , ze = U(function(t, n) {
        return Re(t) || (t = null == t ? [] : [Object(t)]),
        g(n, 1),
        e(A(t), re)
    })
      , Ie = U(function(e, t, n) {
        return q(e, t, n)
    })
      , Fe = U(function(e, t) {
        return f(e, 1, t)
    })
      , Me = U(function(e, t, n) {
        return f(e, Be(t) || 0, n)
    })
      , Re = Array.isArray
      , We = Number
      , Be = Number
      , Ue = O(function(e, t) {
        D(t, ie(t), e)
    })
      , Xe = O(function(e, t) {
        D(t, oe(t), e)
    })
      , Ye = O(function(e, t, n, i) {
        D(t, oe(t), e, i)
    })
      , Ve = U(function(e) {
        return e.push(le, d),
        Ye.apply(le, e)
    })
      , Ge = U(function(e, t) {
        return null == e ? {} : S(e, g(t, 1))
    })
      , Qe = x;
    c.prototype = p(u.prototype),
    c.prototype.constructor = c,
    u.assignIn = Xe,
    u.before = B,
    u.bind = Ie,
    u.chain = function(e) {
        return e = u(e),
        e.__chain__ = !0,
        e
    }
    ,
    u.compact = function(e) {
        return v(e, Boolean)
    }
    ,
    u.concat = ze,
    u.create = function(e, t) {
        var n = p(e);
        return t ? Ue(n, t) : n
    }
    ,
    u.defaults = Ve,
    u.defer = Fe,
    u.delay = Me,
    u.filter = function(e, t) {
        return v(e, x(t))
    }
    ,
    u.flatten = function(e) {
        return e && e.length ? g(e, 1) : []
    }
    ,
    u.flattenDeep = function(e) {
        return e && e.length ? g(e, ue) : []
    }
    ,
    u.iteratee = Qe,
    u.keys = ie,
    u.map = function(e, t) {
        return T(e, x(t))
    }
    ,
    u.matches = function(e) {
        return C(Ue({}, e))
    }
    ,
    u.mixin = ae,
    u.negate = function(e) {
        if ("function" != typeof e)
            throw new TypeError("Expected a function");
        return function() {
            return !e.apply(this, arguments)
        }
    }
    ,
    u.once = function(e) {
        return B(2, e)
    }
    ,
    u.pick = Ge,
    u.slice = function(e, t, n) {
        var i = e ? e.length : 0;
        return n = n === le ? i : +n,
        i ? E(e, null == t ? 0 : +t, n) : []
    }
    ,
    u.sortBy = function(e, t) {
        var n = 0;
        return t = x(t),
        T(T(e, function(e, i, o) {
            return {
                c: e,
                b: n++,
                a: t(e, i, o)
            }
        }).sort(function(e, t) {
            var n;
            e: {
                n = e.a;
                var i = t.a;
                if (n !== i) {
                    var o = null === n
                      , r = n === le
                      , s = n === n
                      , a = null === i
                      , l = i === le
                      , u = i === i;
                    if (n > i && !a || !s || o && !l && u || r && u) {
                        n = 1;
                        break e
                    }
                    if (i > n && !o || !u || a && !r && s || l && s) {
                        n = -1;
                        break e
                    }
                }
                n = 0
            }
            return n || e.b - t.b
        }), $("c"))
    }
    ,
    u.tap = function(e, t) {
        return t(e),
        e
    }
    ,
    u.thru = function(e, t) {
        return t(e)
    }
    ,
    u.toArray = function(e) {
        return V(e) ? e.length ? A(e) : [] : re(e)
    }
    ,
    u.values = re,
    u.extend = Xe,
    ae(u, u),
    u.clone = function(e) {
        return J(e) ? Re(e) ? A(e) : D(e, ie(e)) : e
    }
    ,
    u.escape = function(e) {
        return (e = ne(e)) && de.test(e) ? e.replace(ce, s) : e
    }
    ,
    u.every = function(e, t, n) {
        return t = n ? le : t,
        h(e, x(t))
    }
    ,
    u.find = M,
    u.forEach = R,
    u.has = function(e, t) {
        return null != e && Ce.call(e, t)
    }
    ,
    u.head = F,
    u.identity = se,
    u.indexOf = function(e, t, n) {
        var i = e ? e.length : 0;
        n = "number" == typeof n ? 0 > n ? qe(i + n, 0) : n : 0,
        n = (n || 0) - 1;
        for (var o = t === t; ++n < i; ) {
            var r = e[n];
            if (o ? r === t : r !== r)
                return n
        }
        return -1
    }
    ,
    u.isArguments = Y,
    u.isArray = Re,
    u.isBoolean = function(e) {
        return !0 === e || !1 === e || Z(e) && "[object Boolean]" == $e.call(e)
    }
    ,
    u.isDate = function(e) {
        return Z(e) && "[object Date]" == $e.call(e)
    }
    ,
    u.isEmpty = function(e) {
        if (V(e) && (Re(e) || ee(e) || G(e.splice) || Y(e)))
            return !e.length;
        for (var t in e)
            if (Ce.call(e, t))
                return !1;
        return !0
    }
    ,
    u.isEqual = function(e, t) {
        return w(e, t)
    }
    ,
    u.isFinite = function(e) {
        return "number" == typeof e && Oe(e)
    }
    ,
    u.isFunction = G,
    u.isNaN = function(e) {
        return K(e) && e != +e
    }
    ,
    u.isNull = function(e) {
        return null === e
    }
    ,
    u.isNumber = K,
    u.isObject = J,
    u.isRegExp = function(e) {
        return J(e) && "[object RegExp]" == $e.call(e)
    }
    ,
    u.isString = ee,
    u.isUndefined = function(e) {
        return e === le
    }
    ,
    u.last = function(e) {
        var t = e ? e.length : 0;
        return t ? e[t - 1] : le
    }
    ,
    u.max = function(e) {
        return e && e.length ? t(e, se, X) : le
    }
    ,
    u.min = function(e) {
        return e && e.length ? t(e, se, te) : le
    }
    ,
    u.noConflict = function() {
        return xe._ === this && (xe._ = Ee),
        this
    }
    ,
    u.noop = function() {}
    ,
    u.reduce = W,
    u.result = function(e, t, n) {
        return t = null == e ? le : e[t],
        t === le && (t = n),
        G(t) ? t.call(e) : t
    }
    ,
    u.size = function(e) {
        return null == e ? 0 : (e = V(e) ? e : ie(e),
        e.length)
    }
    ,
    u.some = function(e, t, n) {
        return t = n ? le : t,
        j(e, x(t))
    }
    ,
    u.uniqueId = function(e) {
        var t = ++Se;
        return ne(e) + t
    }
    ,
    u.each = R,
    u.first = F,
    ae(u, function() {
        var e = {};
        return m(u, function(t, n) {
            Ce.call(u.prototype, n) || (e[n] = t)
        }),
        e
    }(), {
        chain: !1
    }),
    u.VERSION = "4.5.1",
    Pe("pop join replace reverse split push shift sort splice unshift".split(" "), function(e) {
        var t = (/^(?:replace|split)$/.test(e) ? String.prototype : ke)[e]
          , n = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru"
          , i = /^(?:pop|join|replace|shift)$/.test(e);
        u.prototype[e] = function() {
            var e = arguments;
            return i && !this.__chain__ ? t.apply(this.value(), e) : this[n](function(n) {
                return t.apply(n, e)
            })
        }
    }),
    u.prototype.toJSON = u.prototype.valueOf = u.prototype.value = function() {
        return N(this.__wrapped__, this.__actions__)
    }
    ,
    (we || ye || {})._ = u,
    "function" == typeof define && "object" == typeof define.amd && define.amd ? define(function() {
        return u
    }) : ve && ge ? (me && ((ge.exports = u)._ = u),
    ve._ = u) : xe._ = u
}
.call(this),
/*!
 * mobile-sniff.min.js
 */
!function() {
    window.mobileCheck = function() {
        var e = !1;
        return function(t) {
            (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(t.substr(0, 4))) && (e = !0)
        }(navigator.userAgent || navigator.vendor || window.opera),
        e
    }
}(),
/*!
 * modernizr.min.js */
/*! modernizr 3.3.1 (Custom Build) | MIT ** https://modernizr.com/download/?-csstransforms-flexbox-svg-setclasses !*/
!function(e, t, n) {
    function i(e, t) {
        return typeof e === t
    }
    function o() {
        var e, t, n, o, r, s, a;
        for (var l in w)
            if (w.hasOwnProperty(l)) {
                if (e = [],
                t = w[l],
                t.name && (e.push(t.name.toLowerCase()),
                t.options && t.options.aliases && t.options.aliases.length))
                    for (n = 0; n < t.options.aliases.length; n++)
                        e.push(t.options.aliases[n].toLowerCase());
                for (o = i(t.fn, "function") ? t.fn() : t.fn,
                r = 0; r < e.length; r++)
                    s = e[r],
                    a = s.split("."),
                    1 === a.length ? x[a[0]] = o : (!x[a[0]] || x[a[0]]instanceof Boolean || (x[a[0]] = new Boolean(x[a[0]])),
                    x[a[0]][a[1]] = o),
                    y.push((o ? "" : "no-") + a.join("-"))
            }
    }
    function r(e) {
        var t = k.className
          , n = x._config.classPrefix || "";
        if (T && (t = t.baseVal),
        x._config.enableJSClass) {
            var i = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
            t = t.replace(i, "$1" + n + "js$2")
        }
        x._config.enableClasses && (t += " " + n + e.join(" " + n),
        T ? k.className.baseVal = t : k.className = t)
    }
    function s(e, t) {
        return !!~("" + e).indexOf(t)
    }
    function a() {
        return "function" != typeof t.createElement ? t.createElement(arguments[0]) : T ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0]) : t.createElement.apply(t, arguments)
    }
    function l(e) {
        return e.replace(/([a-z])-([a-z])/g, function(e, t, n) {
            return t + n.toUpperCase()
        }).replace(/^-/, "")
    }
    function u(e, t) {
        return function() {
            return e.apply(t, arguments)
        }
    }
    function c(e, t, n) {
        var o;
        for (var r in e)
            if (e[r]in t)
                return n === !1 ? e[r] : (o = t[e[r]],
                i(o, "function") ? u(o, n || t) : o);
        return !1
    }
    function d(e) {
        return e.replace(/([A-Z])/g, function(e, t) {
            return "-" + t.toLowerCase()
        }).replace(/^ms-/, "-ms-")
    }
    function p() {
        var e = t.body;
        return e || (e = a(T ? "svg" : "body"),
        e.fake = !0),
        e
    }
    function f(e, n, i, o) {
        var r, s, l, u, c = "modernizr", d = a("div"), f = p();
        if (parseInt(i, 10))
            for (; i--; )
                l = a("div"),
                l.id = o ? o[i] : c + (i + 1),
                d.appendChild(l);
        return r = a("style"),
        r.type = "text/css",
        r.id = "s" + c,
        (f.fake ? f : d).appendChild(r),
        f.appendChild(d),
        r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(t.createTextNode(e)),
        d.id = c,
        f.fake && (f.style.background = "",
        f.style.overflow = "hidden",
        u = k.style.overflow,
        k.style.overflow = "hidden",
        k.appendChild(f)),
        s = n(d, e),
        f.fake ? (f.parentNode.removeChild(f),
        k.style.overflow = u,
        k.offsetHeight) : d.parentNode.removeChild(d),
        !!s
    }
    function h(t, i) {
        var o = t.length;
        if ("CSS"in e && "supports"in e.CSS) {
            for (; o--; )
                if (e.CSS.supports(d(t[o]), i))
                    return !0;
            return !1
        }
        if ("CSSSupportsRule"in e) {
            for (var r = []; o--; )
                r.push("(" + d(t[o]) + ":" + i + ")");
            return r = r.join(" or "),
            f("@supports (" + r + ") { #modernizr { position: absolute; } }", function(e) {
                return "absolute" == getComputedStyle(e, null).position
            })
        }
        return n
    }
    function v(e, t, o, r) {
        function u() {
            d && (delete A.style,
            delete A.modElem)
        }
        if (r = !i(r, "undefined") && r,
        !i(o, "undefined")) {
            var c = h(e, o);
            if (!i(c, "undefined"))
                return c
        }
        for (var d, p, f, v, g, m = ["modernizr", "tspan", "samp"]; !A.style && m.length; )
            d = !0,
            A.modElem = a(m.shift()),
            A.style = A.modElem.style;
        for (f = e.length,
        p = 0; f > p; p++)
            if (v = e[p],
            g = A.style[v],
            s(v, "-") && (v = l(v)),
            A.style[v] !== n) {
                if (r || i(o, "undefined"))
                    return u(),
                    "pfx" != t || v;
                try {
                    A.style[v] = o
                } catch (e) {}
                if (A.style[v] != g)
                    return u(),
                    "pfx" != t || v
            }
        return u(),
        !1
    }
    function g(e, t, n, o, r) {
        var s = e.charAt(0).toUpperCase() + e.slice(1)
          , a = (e + " " + S.join(s + " ") + s).split(" ");
        return i(t, "string") || i(t, "undefined") ? v(a, t, o, r) : (a = (e + " " + $.join(s + " ") + s).split(" "),
        c(a, t, n))
    }
    function m(e, t, i) {
        return g(e, n, n, t, i)
    }
    var y = []
      , w = []
      , b = {
        _version: "3.3.1",
        _config: {
            classPrefix: "",
            enableClasses: !0,
            enableJSClass: !0,
            usePrefixes: !0
        },
        _q: [],
        on: function(e, t) {
            var n = this;
            setTimeout(function() {
                t(n[e])
            }, 0)
        },
        addTest: function(e, t, n) {
            w.push({
                name: e,
                fn: t,
                options: n
            })
        },
        addAsyncTest: function(e) {
            w.push({
                name: null,
                fn: e
            })
        }
    }
      , x = function() {};
    x.prototype = b,
    x = new x,
    x.addTest("svg", !!t.createElementNS && !!t.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect);
    var k = t.documentElement
      , T = "svg" === k.nodeName.toLowerCase()
      , C = "Moz O ms Webkit"
      , S = b._config.usePrefixes ? C.split(" ") : [];
    b._cssomPrefixes = S;
    var $ = b._config.usePrefixes ? C.toLowerCase().split(" ") : [];
    b._domPrefixes = $;
    var E = {
        elem: a("modernizr")
    };
    x._q.push(function() {
        delete E.elem
    });
    var A = {
        style: E.elem.style
    };
    x._q.unshift(function() {
        delete A.style
    }),
    b.testAllProps = g,
    b.testAllProps = m,
    x.addTest("flexbox", m("flexBasis", "1px", !0)),
    x.addTest("csstransforms", function() {
        return -1 === navigator.userAgent.indexOf("Android 2.") && m("transform", "scale(1)", !0)
    }),
    o(),
    r(y),
    delete b.addTest,
    delete b.addAsyncTest;
    for (var j = 0; j < x._q.length; j++)
        x._q[j]();
    e.Modernizr = x
}(window, document),
/*!
 * slick-slim.min.js ** Version: 1.6.0 ** Website: http://kenwheeler.github.io */
!function(a) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], a) : "undefined" != typeof exports ? module.exports = a(require("jquery")) : a(jQuery)
}(function(a) {
    "use strict";
    var b = window.Slick || {};
    b = function() {
        function c(c, d) {
            var f, e = this;
            e.defaults = {
                accessibility: !0,
                adaptiveHeight: !1,
                appendArrows: a(c),
                appendDots: a(c),
                arrows: !0,
                asNavFor: null,
                prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
                nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
                autoplay: !1,
                autoplaySpeed: 3e3,
                centerMode: !1,
                centerPadding: "50px",
                cssEase: "ease",
                customPaging: function(b, c) {
                    return a('<button type="button" data-role="none" role="button" tabindex="0" />').text(c + 1)
                },
                dots: !1,
                dotsClass: "slick-dots",
                draggable: !0,
                easing: "linear",
                edgeFriction: .35,
                fade: !1,
                focusOnSelect: !1,
                infinite: !0,
                initialSlide: 0,
                lazyLoad: "ondemand",
                mobileFirst: !1,
                pauseOnHover: !0,
                pauseOnFocus: !0,
                pauseOnDotsHover: !1,
                respondTo: "window",
                responsive: null,
                rows: 1,
                rtl: !1,
                slide: "",
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: !0,
                swipeToSlide: !1,
                touchMove: !0,
                touchThreshold: 5,
                useCSS: !0,
                useTransform: !0,
                variableWidth: !1,
                vertical: !1,
                verticalSwiping: !1,
                waitForAnimate: !0,
                zIndex: 1e3
            },
            e.initials = {
                animating: !1,
                dragging: !1,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: !1,
                slideOffset: 0,
                swipeLeft: null,
                $list: null,
                touchObject: {},
                transformsEnabled: !1,
                unslicked: !1
            },
            a.extend(e, e.initials),
            e.activeBreakpoint = null,
            e.animType = null,
            e.animProp = null,
            e.breakpoints = [],
            e.breakpointSettings = [],
            e.cssTransitions = !1,
            e.focussed = !1,
            e.interrupted = !1,
            e.hidden = "hidden",
            e.paused = !0,
            e.positionProp = null,
            e.respondTo = null,
            e.rowCount = 1,
            e.shouldClick = !0,
            e.$slider = a(c),
            e.$slidesCache = null,
            e.transformType = null,
            e.transitionType = null,
            e.visibilityChange = "visibilitychange",
            e.windowWidth = 0,
            e.windowTimer = null,
            f = a(c).data("slick") || {},
            e.options = a.extend({}, e.defaults, d, f),
            e.currentSlide = e.options.initialSlide,
            e.originalSettings = e.options,
            "undefined" != typeof document.mozHidden ? (e.hidden = "mozHidden",
            e.visibilityChange = "mozvisibilitychange") : "undefined" != typeof document.webkitHidden && (e.hidden = "webkitHidden",
            e.visibilityChange = "webkitvisibilitychange"),
            e.autoPlay = a.proxy(e.autoPlay, e),
            e.autoPlayClear = a.proxy(e.autoPlayClear, e),
            e.autoPlayIterator = a.proxy(e.autoPlayIterator, e),
            e.changeSlide = a.proxy(e.changeSlide, e),
            e.clickHandler = a.proxy(e.clickHandler, e),
            e.selectHandler = a.proxy(e.selectHandler, e),
            e.setPosition = a.proxy(e.setPosition, e),
            e.swipeHandler = a.proxy(e.swipeHandler, e),
            e.dragHandler = a.proxy(e.dragHandler, e),
            e.keyHandler = a.proxy(e.keyHandler, e),
            e.instanceUid = b++,
            e.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/,
            e.registerBreakpoints(),
            e.init(!0)
        }
        var b = 0;
        return c
    }(),
    b.prototype.activateADA = function() {
        var a = this;
        a.$slideTrack.find(".slick-active").attr({
            "aria-hidden": "false"
        }).find("a, input, button, select").attr({
            tabindex: "0"
        })
    }
    ,
    b.prototype.addSlide = b.prototype.slickAdd = function(b, c, d) {
        var e = this;
        if ("boolean" == typeof c)
            d = c,
            c = null;
        else if (0 > c || c >= e.slideCount)
            return !1;
        e.unload(),
        "number" == typeof c ? 0 === c && 0 === e.$slides.length ? a(b).appendTo(e.$slideTrack) : d ? a(b).insertBefore(e.$slides.eq(c)) : a(b).insertAfter(e.$slides.eq(c)) : d === !0 ? a(b).prependTo(e.$slideTrack) : a(b).appendTo(e.$slideTrack),
        e.$slides = e.$slideTrack.children(this.options.slide),
        e.$slideTrack.children(this.options.slide).detach(),
        e.$slideTrack.append(e.$slides),
        e.$slides.each(function(b, c) {
            a(c).attr("data-slick-index", b)
        }),
        e.$slidesCache = e.$slides,
        e.reinit()
    }
    ,
    b.prototype.animateHeight = function() {
        var a = this;
        if (1 === a.options.slidesToShow && a.options.adaptiveHeight === !0 && a.options.vertical === !1) {
            var b = a.$slides.eq(a.currentSlide).outerHeight(!0);
            a.$list.animate({
                height: b
            }, a.options.speed)
        }
    }
    ,
    b.prototype.animateSlide = function(b, c) {
        var d = {}
          , e = this;
        e.animateHeight(),
        e.options.rtl === !0 && e.options.vertical === !1 && (b = -b),
        e.transformsEnabled === !1 ? e.options.vertical === !1 ? e.$slideTrack.animate({
            left: b
        }, e.options.speed, e.options.easing, c) : e.$slideTrack.animate({
            top: b
        }, e.options.speed, e.options.easing, c) : e.cssTransitions === !1 ? (e.options.rtl === !0 && (e.currentLeft = -e.currentLeft),
        a({
            animStart: e.currentLeft
        }).animate({
            animStart: b
        }, {
            duration: e.options.speed,
            easing: e.options.easing,
            step: function(a) {
                a = Math.ceil(a),
                e.options.vertical === !1 ? (d[e.animType] = "translate(" + a + "px, 0px)",
                e.$slideTrack.css(d)) : (d[e.animType] = "translate(0px," + a + "px)",
                e.$slideTrack.css(d))
            },
            complete: function() {
                c && c.call()
            }
        })) : (e.applyTransition(),
        b = Math.ceil(b),
        e.options.vertical === !1 ? d[e.animType] = "translate3d(" + b + "px, 0px, 0px)" : d[e.animType] = "translate3d(0px," + b + "px, 0px)",
        e.$slideTrack.css(d),
        c && setTimeout(function() {
            e.disableTransition(),
            c.call()
        }, e.options.speed))
    }
    ,
    b.prototype.getNavTarget = function() {
        var b = this
          , c = b.options.asNavFor;
        return c && null !== c && (c = a(c).not(b.$slider)),
        c
    }
    ,
    b.prototype.asNavFor = function(b) {
        var c = this
          , d = c.getNavTarget();
        null !== d && "object" == typeof d && d.each(function() {
            var c = a(this).slick("getSlick");
            c.unslicked || c.slideHandler(b, !0)
        })
    }
    ,
    b.prototype.applyTransition = function(a) {
        var b = this
          , c = {};
        b.options.fade === !1 ? c[b.transitionType] = b.transformType + " " + b.options.speed + "ms " + b.options.cssEase : c[b.transitionType] = "opacity " + b.options.speed + "ms " + b.options.cssEase,
        b.options.fade === !1 ? b.$slideTrack.css(c) : b.$slides.eq(a).css(c)
    }
    ,
    b.prototype.autoPlay = function() {
        var a = this;
        a.autoPlayClear(),
        a.slideCount > a.options.slidesToShow && (a.autoPlayTimer = setInterval(a.autoPlayIterator, a.options.autoplaySpeed))
    }
    ,
    b.prototype.autoPlayClear = function() {
        var a = this;
        a.autoPlayTimer && clearInterval(a.autoPlayTimer)
    }
    ,
    b.prototype.autoPlayIterator = function() {
        var a = this
          , b = a.currentSlide + a.options.slidesToScroll;
        a.paused || a.interrupted || a.focussed || (a.options.infinite === !1 && (1 === a.direction && a.currentSlide + 1 === a.slideCount - 1 ? a.direction = 0 : 0 === a.direction && (b = a.currentSlide - a.options.slidesToScroll,
        a.currentSlide - 1 === 0 && (a.direction = 1))),
        a.slideHandler(b))
    }
    ,
    b.prototype.buildArrows = function() {
        var b = this;
        b.options.arrows === !0 && (b.$prevArrow = a(b.options.prevArrow).addClass("slick-arrow"),
        b.$nextArrow = a(b.options.nextArrow).addClass("slick-arrow"),
        b.slideCount > b.options.slidesToShow ? (b.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
        b.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
        b.htmlExpr.test(b.options.prevArrow) && b.$prevArrow.prependTo(b.options.appendArrows),
        b.htmlExpr.test(b.options.nextArrow) && b.$nextArrow.appendTo(b.options.appendArrows),
        b.options.infinite !== !0 && b.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : b.$prevArrow.add(b.$nextArrow).addClass("slick-hidden").attr({
            "aria-disabled": "true",
            tabindex: "-1"
        }))
    }
    ,
    b.prototype.buildDots = function() {
        var c, d, b = this;
        if (b.options.dots === !0 && b.slideCount > b.options.slidesToShow) {
            for (b.$slider.addClass("slick-dotted"),
            d = a("<ul />").addClass(b.options.dotsClass),
            c = 0; c <= b.getDotCount(); c += 1)
                d.append(a("<li />").append(b.options.customPaging.call(this, b, c)));
            b.$dots = d.appendTo(b.options.appendDots),
            b.$dots.find("li").first().addClass("slick-active").attr("aria-hidden", "false")
        }
    }
    ,
    b.prototype.buildOut = function() {
        var b = this;
        b.$slides = b.$slider.children(b.options.slide + ":not(.slick-cloned)").addClass("slick-slide"),
        b.slideCount = b.$slides.length,
        b.$slides.each(function(b, c) {
            a(c).attr("data-slick-index", b).data("originalStyling", a(c).attr("style") || "")
        }),
        b.$slider.addClass("slick-slider"),
        b.$slideTrack = 0 === b.slideCount ? a('<div class="slick-track"/>').appendTo(b.$slider) : b.$slides.wrapAll('<div class="slick-track"/>').parent(),
        b.$list = b.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent(),
        b.$slideTrack.css("opacity", 0),
        (b.options.centerMode === !0 || b.options.swipeToSlide === !0) && (b.options.slidesToScroll = 1),
        a("img[data-lazy]", b.$slider).not("[src]").addClass("slick-loading"),
        b.setupInfinite(),
        b.buildArrows(),
        b.buildDots(),
        b.updateDots(),
        b.setSlideClasses("number" == typeof b.currentSlide ? b.currentSlide : 0),
        b.options.draggable === !0 && b.$list.addClass("draggable")
    }
    ,
    b.prototype.buildRows = function() {
        var b, c, d, e, f, g, h, a = this;
        if (e = document.createDocumentFragment(),
        g = a.$slider.children(),
        a.options.rows > 1) {
            for (h = a.options.slidesPerRow * a.options.rows,
            f = Math.ceil(g.length / h),
            b = 0; f > b; b++) {
                var i = document.createElement("div");
                for (c = 0; c < a.options.rows; c++) {
                    var j = document.createElement("div");
                    for (d = 0; d < a.options.slidesPerRow; d++) {
                        var k = b * h + (c * a.options.slidesPerRow + d);
                        g.get(k) && j.appendChild(g.get(k))
                    }
                    i.appendChild(j)
                }
                e.appendChild(i)
            }
            a.$slider.empty().append(e),
            a.$slider.children().children().children().css({
                width: 100 / a.options.slidesPerRow + "%",
                display: "inline-block"
            })
        }
    }
    ,
    b.prototype.checkResponsive = function(b, c) {
        var e, f, g, d = this, h = !1, i = d.$slider.width(), j = window.innerWidth || a(window).width();
        if ("window" === d.respondTo ? g = j : "slider" === d.respondTo ? g = i : "min" === d.respondTo && (g = Math.min(j, i)),
        d.options.responsive && d.options.responsive.length && null !== d.options.responsive) {
            f = null;
            for (e in d.breakpoints)
                d.breakpoints.hasOwnProperty(e) && (d.originalSettings.mobileFirst === !1 ? g < d.breakpoints[e] && (f = d.breakpoints[e]) : g > d.breakpoints[e] && (f = d.breakpoints[e]));
            null !== f ? null !== d.activeBreakpoint ? (f !== d.activeBreakpoint || c) && (d.activeBreakpoint = f,
            "unslick" === d.breakpointSettings[f] ? d.unslick(f) : (d.options = a.extend({}, d.originalSettings, d.breakpointSettings[f]),
            b === !0 && (d.currentSlide = d.options.initialSlide),
            d.refresh(b)),
            h = f) : (d.activeBreakpoint = f,
            "unslick" === d.breakpointSettings[f] ? d.unslick(f) : (d.options = a.extend({}, d.originalSettings, d.breakpointSettings[f]),
            b === !0 && (d.currentSlide = d.options.initialSlide),
            d.refresh(b)),
            h = f) : null !== d.activeBreakpoint && (d.activeBreakpoint = null,
            d.options = d.originalSettings,
            b === !0 && (d.currentSlide = d.options.initialSlide),
            d.refresh(b),
            h = f),
            b || h === !1 || d.$slider.trigger("breakpoint", [d, h])
        }
    }
    ,
    b.prototype.changeSlide = function(b, c) {
        var f, g, h, d = this, e = a(b.currentTarget);
        switch (e.is("a") && b.preventDefault(),
        e.is("li") || (e = e.closest("li")),
        h = d.slideCount % d.options.slidesToScroll !== 0,
        f = h ? 0 : (d.slideCount - d.currentSlide) % d.options.slidesToScroll,
        b.data.message) {
        case "previous":
            g = 0 === f ? d.options.slidesToScroll : d.options.slidesToShow - f,
            d.slideCount > d.options.slidesToShow && d.slideHandler(d.currentSlide - g, !1, c);
            break;
        case "next":
            g = 0 === f ? d.options.slidesToScroll : f,
            d.slideCount > d.options.slidesToShow && d.slideHandler(d.currentSlide + g, !1, c);
            break;
        case "index":
            var i = 0 === b.data.index ? 0 : b.data.index || e.index() * d.options.slidesToScroll;
            d.slideHandler(d.checkNavigable(i), !1, c),
            e.children().trigger("focus");
            break;
        default:
            return
        }
    }
    ,
    b.prototype.checkNavigable = function(a) {
        var c, d, b = this;
        if (c = b.getNavigableIndexes(),
        d = 0,
        a > c[c.length - 1])
            a = c[c.length - 1];
        else
            for (var e in c) {
                if (a < c[e]) {
                    a = d;
                    break
                }
                d = c[e]
            }
        return a
    }
    ,
    b.prototype.cleanUpEvents = function() {
        var b = this;
        b.options.dots && null !== b.$dots && a("li", b.$dots).off("click.slick", b.changeSlide).off("mouseenter.slick", a.proxy(b.interrupt, b, !0)).off("mouseleave.slick", a.proxy(b.interrupt, b, !1)),
        b.$slider.off("focus.slick blur.slick"),
        b.options.arrows === !0 && b.slideCount > b.options.slidesToShow && (b.$prevArrow && b.$prevArrow.off("click.slick", b.changeSlide),
        b.$nextArrow && b.$nextArrow.off("click.slick", b.changeSlide)),
        b.$list.off("touchstart.slick mousedown.slick", b.swipeHandler),
        b.$list.off("touchmove.slick mousemove.slick", b.swipeHandler),
        b.$list.off("touchend.slick mouseup.slick", b.swipeHandler),
        b.$list.off("touchcancel.slick mouseleave.slick", b.swipeHandler),
        b.$list.off("click.slick", b.clickHandler),
        a(document).off(b.visibilityChange, b.visibility),
        b.cleanUpSlideEvents(),
        b.options.accessibility === !0 && b.$list.off("keydown.slick", b.keyHandler),
        b.options.focusOnSelect === !0 && a(b.$slideTrack).children().off("click.slick", b.selectHandler),
        a(window).off("orientationchange.slick.slick-" + b.instanceUid, b.orientationChange),
        a(window).off("resize.slick.slick-" + b.instanceUid, b.resize),
        a("[draggable!=true]", b.$slideTrack).off("dragstart", b.preventDefault),
        a(window).off("load.slick.slick-" + b.instanceUid, b.setPosition),
        a(document).off("ready.slick.slick-" + b.instanceUid, b.setPosition)
    }
    ,
    b.prototype.cleanUpSlideEvents = function() {
        var b = this;
        b.$list.off("mouseenter.slick", a.proxy(b.interrupt, b, !0)),
        b.$list.off("mouseleave.slick", a.proxy(b.interrupt, b, !1))
    }
    ,
    b.prototype.cleanUpRows = function() {
        var b, a = this;
        a.options.rows > 1 && (b = a.$slides.children().children(),
        b.removeAttr("style"),
        a.$slider.empty().append(b))
    }
    ,
    b.prototype.clickHandler = function(a) {
        var b = this;
        b.shouldClick === !1 && (a.stopImmediatePropagation(),
        a.stopPropagation(),
        a.preventDefault())
    }
    ,
    b.prototype.destroy = function(b) {
        var c = this;
        c.autoPlayClear(),
        c.touchObject = {},
        c.cleanUpEvents(),
        a(".slick-cloned", c.$slider).detach(),
        c.$dots && c.$dots.remove(),
        c.$prevArrow && c.$prevArrow.length && (c.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""),
        c.htmlExpr.test(c.options.prevArrow) && c.$prevArrow.remove()),
        c.$nextArrow && c.$nextArrow.length && (c.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""),
        c.htmlExpr.test(c.options.nextArrow) && c.$nextArrow.remove()),
        c.$slides && (c.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
            a(this).attr("style", a(this).data("originalStyling"))
        }),
        c.$slideTrack.children(this.options.slide).detach(),
        c.$slideTrack.detach(),
        c.$list.detach(),
        c.$slider.append(c.$slides)),
        c.cleanUpRows(),
        c.$slider.removeClass("slick-slider"),
        c.$slider.removeClass("slick-initialized"),
        c.$slider.removeClass("slick-dotted"),
        c.unslicked = !0,
        b || c.$slider.trigger("destroy", [c])
    }
    ,
    b.prototype.disableTransition = function(a) {
        var b = this
          , c = {};
        c[b.transitionType] = "",
        b.options.fade === !1 ? b.$slideTrack.css(c) : b.$slides.eq(a).css(c)
    }
    ,
    b.prototype.fadeSlide = function(a, b) {
        var c = this;
        c.cssTransitions === !1 ? (c.$slides.eq(a).css({
            zIndex: c.options.zIndex
        }),
        c.$slides.eq(a).animate({
            opacity: 1
        }, c.options.speed, c.options.easing, b)) : (c.applyTransition(a),
        c.$slides.eq(a).css({
            opacity: 1,
            zIndex: c.options.zIndex
        }),
        b && setTimeout(function() {
            c.disableTransition(a),
            b.call()
        }, c.options.speed))
    }
    ,
    b.prototype.fadeSlideOut = function(a) {
        var b = this;
        b.cssTransitions === !1 ? b.$slides.eq(a).animate({
            opacity: 0,
            zIndex: b.options.zIndex - 2
        }, b.options.speed, b.options.easing) : (b.applyTransition(a),
        b.$slides.eq(a).css({
            opacity: 0,
            zIndex: b.options.zIndex - 2
        }))
    }
    ,
    b.prototype.filterSlides = b.prototype.slickFilter = function(a) {
        var b = this;
        null !== a && (b.$slidesCache = b.$slides,
        b.unload(),
        b.$slideTrack.children(this.options.slide).detach(),
        b.$slidesCache.filter(a).appendTo(b.$slideTrack),
        b.reinit())
    }
    ,
    b.prototype.focusHandler = function() {
        var b = this;
        b.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*:not(.slick-arrow)", function(c) {
            c.stopImmediatePropagation();
            var d = a(this);
            setTimeout(function() {
                b.options.pauseOnFocus && (b.focussed = d.is(":focus"),
                b.autoPlay())
            }, 0)
        })
    }
    ,
    b.prototype.getCurrent = b.prototype.slickCurrentSlide = function() {
        var a = this;
        return a.currentSlide
    }
    ,
    b.prototype.getDotCount = function() {
        var a = this
          , b = 0
          , c = 0
          , d = 0;
        if (a.options.infinite === !0)
            for (; b < a.slideCount; )
                ++d,
                b = c + a.options.slidesToScroll,
                c += a.options.slidesToScroll <= a.options.slidesToShow ? a.options.slidesToScroll : a.options.slidesToShow;
        else if (a.options.centerMode === !0)
            d = a.slideCount;
        else if (a.options.asNavFor)
            for (; b < a.slideCount; )
                ++d,
                b = c + a.options.slidesToScroll,
                c += a.options.slidesToScroll <= a.options.slidesToShow ? a.options.slidesToScroll : a.options.slidesToShow;
        else
            d = 1 + Math.ceil((a.slideCount - a.options.slidesToShow) / a.options.slidesToScroll);
        return d - 1
    }
    ,
    b.prototype.getLeft = function(a) {
        var c, d, f, b = this, e = 0;
        return b.slideOffset = 0,
        d = b.$slides.first().outerHeight(!0),
        b.options.infinite === !0 ? (b.slideCount > b.options.slidesToShow && (b.slideOffset = b.slideWidth * b.options.slidesToShow * -1,
        e = d * b.options.slidesToShow * -1),
        b.slideCount % b.options.slidesToScroll !== 0 && a + b.options.slidesToScroll > b.slideCount && b.slideCount > b.options.slidesToShow && (a > b.slideCount ? (b.slideOffset = (b.options.slidesToShow - (a - b.slideCount)) * b.slideWidth * -1,
        e = (b.options.slidesToShow - (a - b.slideCount)) * d * -1) : (b.slideOffset = b.slideCount % b.options.slidesToScroll * b.slideWidth * -1,
        e = b.slideCount % b.options.slidesToScroll * d * -1))) : a + b.options.slidesToShow > b.slideCount && (b.slideOffset = (a + b.options.slidesToShow - b.slideCount) * b.slideWidth,
        e = (a + b.options.slidesToShow - b.slideCount) * d),
        b.slideCount <= b.options.slidesToShow && (b.slideOffset = 0,
        e = 0),
        b.options.centerMode === !0 && b.options.infinite === !0 ? b.slideOffset += b.slideWidth * Math.floor(b.options.slidesToShow / 2) - b.slideWidth : b.options.centerMode === !0 && (b.slideOffset = 0,
        b.slideOffset += b.slideWidth * Math.floor(b.options.slidesToShow / 2)),
        c = b.options.vertical === !1 ? a * b.slideWidth * -1 + b.slideOffset : a * d * -1 + e,
        b.options.variableWidth === !0 && (f = b.slideCount <= b.options.slidesToShow || b.options.infinite === !1 ? b.$slideTrack.children(".slick-slide").eq(a) : b.$slideTrack.children(".slick-slide").eq(a + b.options.slidesToShow),
        c = b.options.rtl === !0 ? f[0] ? -1 * (b.$slideTrack.width() - f[0].offsetLeft - f.width()) : 0 : f[0] ? -1 * f[0].offsetLeft : 0,
        b.options.centerMode === !0 && (f = b.slideCount <= b.options.slidesToShow || b.options.infinite === !1 ? b.$slideTrack.children(".slick-slide").eq(a) : b.$slideTrack.children(".slick-slide").eq(a + b.options.slidesToShow + 1),
        c = b.options.rtl === !0 ? f[0] ? -1 * (b.$slideTrack.width() - f[0].offsetLeft - f.width()) : 0 : f[0] ? -1 * f[0].offsetLeft : 0,
        c += (b.$list.width() - f.outerWidth()) / 2)),
        c
    }
    ,
    b.prototype.getOption = b.prototype.slickGetOption = function(a) {
        var b = this;
        return b.options[a]
    }
    ,
    b.prototype.getNavigableIndexes = function() {
        var e, a = this, b = 0, c = 0, d = [];
        for (a.options.infinite === !1 ? e = a.slideCount : (b = -1 * a.options.slidesToScroll,
        c = -1 * a.options.slidesToScroll,
        e = 2 * a.slideCount); e > b; )
            d.push(b),
            b = c + a.options.slidesToScroll,
            c += a.options.slidesToScroll <= a.options.slidesToShow ? a.options.slidesToScroll : a.options.slidesToShow;
        return d
    }
    ,
    b.prototype.getSlick = function() {
        return this
    }
    ,
    b.prototype.getSlideCount = function() {
        var c, d, e, b = this;
        return e = b.options.centerMode === !0 ? b.slideWidth * Math.floor(b.options.slidesToShow / 2) : 0,
        b.options.swipeToSlide === !0 ? (b.$slideTrack.find(".slick-slide").each(function(c, f) {
            return f.offsetLeft - e + a(f).outerWidth() / 2 > -1 * b.swipeLeft ? (d = f,
            !1) : void 0
        }),
        c = Math.abs(a(d).attr("data-slick-index") - b.currentSlide) || 1) : b.options.slidesToScroll
    }
    ,
    b.prototype.goTo = b.prototype.slickGoTo = function(a, b) {
        var c = this;
        c.changeSlide({
            data: {
                message: "index",
                index: parseInt(a)
            }
        }, b)
    }
    ,
    b.prototype.init = function(b) {
        var c = this;
        a(c.$slider).hasClass("slick-initialized") || (a(c.$slider).addClass("slick-initialized"),
        c.buildRows(),
        c.buildOut(),
        c.setProps(),
        c.startLoad(),
        c.loadSlider(),
        c.initializeEvents(),
        c.updateArrows(),
        c.updateDots(),
        c.checkResponsive(!0),
        c.focusHandler()),
        b && c.$slider.trigger("init", [c]),
        c.options.accessibility === !0 && c.initADA(),
        c.options.autoplay && (c.paused = !1,
        c.autoPlay())
    }
    ,
    b.prototype.initADA = function() {
        var b = this;
        b.$slides.add(b.$slideTrack.find(".slick-cloned")).attr({
            "aria-hidden": "true",
            tabindex: "-1"
        }).find("a, input, button, select").attr({
            tabindex: "-1"
        }),
        b.$slideTrack.attr("role", "listbox"),
        b.$slides.not(b.$slideTrack.find(".slick-cloned")).each(function(c) {
            a(this).attr({
                role: "option",
                "aria-describedby": "slick-slide" + b.instanceUid + c
            })
        }),
        null !== b.$dots && b.$dots.attr("role", "tablist").find("li").each(function(c) {
            a(this).attr({
                role: "presentation",
                "aria-selected": "false",
                "aria-controls": "navigation" + b.instanceUid + c,
                id: "slick-slide" + b.instanceUid + c
            })
        }).first().attr("aria-selected", "true").end().find("button").attr("role", "button").end().closest("div").attr("role", "toolbar"),
        b.activateADA()
    }
    ,
    b.prototype.initArrowEvents = function() {
        var a = this;
        a.options.arrows === !0 && a.slideCount > a.options.slidesToShow && (a.$prevArrow.off("click.slick").on("click.slick", {
            message: "previous"
        }, a.changeSlide),
        a.$nextArrow.off("click.slick").on("click.slick", {
            message: "next"
        }, a.changeSlide))
    }
    ,
    b.prototype.initDotEvents = function() {
        var b = this;
        b.options.dots === !0 && b.slideCount > b.options.slidesToShow && a("li", b.$dots).on("click.slick", {
            message: "index"
        }, b.changeSlide),
        b.options.dots === !0 && b.options.pauseOnDotsHover === !0 && a("li", b.$dots).on("mouseenter.slick", a.proxy(b.interrupt, b, !0)).on("mouseleave.slick", a.proxy(b.interrupt, b, !1))
    }
    ,
    b.prototype.initSlideEvents = function() {
        var b = this;
        b.options.pauseOnHover && (b.$list.on("mouseenter.slick", a.proxy(b.interrupt, b, !0)),
        b.$list.on("mouseleave.slick", a.proxy(b.interrupt, b, !1)))
    }
    ,
    b.prototype.initializeEvents = function() {
        var b = this;
        b.initArrowEvents(),
        b.initDotEvents(),
        b.initSlideEvents(),
        b.$list.on("touchstart.slick mousedown.slick", {
            action: "start"
        }, b.swipeHandler),
        b.$list.on("touchmove.slick mousemove.slick", {
            action: "move"
        }, b.swipeHandler),
        b.$list.on("touchend.slick mouseup.slick", {
            action: "end"
        }, b.swipeHandler),
        b.$list.on("touchcancel.slick mouseleave.slick", {
            action: "end"
        }, b.swipeHandler),
        b.$list.on("click.slick", b.clickHandler),
        a(document).on(b.visibilityChange, a.proxy(b.visibility, b)),
        b.options.accessibility === !0 && b.$list.on("keydown.slick", b.keyHandler),
        b.options.focusOnSelect === !0 && a(b.$slideTrack).children().on("click.slick", b.selectHandler),
        a(window).on("orientationchange.slick.slick-" + b.instanceUid, a.proxy(b.orientationChange, b)),
        a(window).on("resize.slick.slick-" + b.instanceUid, a.proxy(b.resize, b)),
        a("[draggable!=true]", b.$slideTrack).on("dragstart", b.preventDefault),
        a(window).on("load.slick.slick-" + b.instanceUid, b.setPosition),
        a(document).on("ready.slick.slick-" + b.instanceUid, b.setPosition)
    }
    ,
    b.prototype.initUI = function() {
        var a = this;
        a.options.arrows === !0 && a.slideCount > a.options.slidesToShow && (a.$prevArrow.show(),
        a.$nextArrow.show()),
        a.options.dots === !0 && a.slideCount > a.options.slidesToShow && a.$dots.show()
    }
    ,
    b.prototype.keyHandler = function(a) {
        var b = this;
        a.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === a.keyCode && b.options.accessibility === !0 ? b.changeSlide({
            data: {
                message: b.options.rtl === !0 ? "next" : "previous"
            }
        }) : 39 === a.keyCode && b.options.accessibility === !0 && b.changeSlide({
            data: {
                message: b.options.rtl === !0 ? "previous" : "next"
            }
        }))
    }
    ,
    b.prototype.lazyLoad = function() {
        function g(c) {
            a("img[data-lazy]", c).each(function() {
                var c = a(this)
                  , d = a(this).attr("data-lazy")
                  , e = document.createElement("img");
                e.onload = function() {
                    c.animate({
                        opacity: 0
                    }, 100, function() {
                        c.attr("src", d).animate({
                            opacity: 1
                        }, 200, function() {
                            c.removeAttr("data-lazy").removeClass("slick-loading")
                        }),
                        b.$slider.trigger("lazyLoaded", [b, c, d])
                    })
                }
                ,
                e.onerror = function() {
                    c.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),
                    b.$slider.trigger("lazyLoadError", [b, c, d])
                }
                ,
                e.src = d
            })
        }
        var c, d, e, f, b = this;
        b.options.centerMode === !0 ? b.options.infinite === !0 ? (e = b.currentSlide + (b.options.slidesToShow / 2 + 1),
        f = e + b.options.slidesToShow + 2) : (e = Math.max(0, b.currentSlide - (b.options.slidesToShow / 2 + 1)),
        f = 2 + (b.options.slidesToShow / 2 + 1) + b.currentSlide) : (e = b.options.infinite ? b.options.slidesToShow + b.currentSlide : b.currentSlide,
        f = Math.ceil(e + b.options.slidesToShow),
        b.options.fade === !0 && (e > 0 && e--,
        f <= b.slideCount && f++)),
        c = b.$slider.find(".slick-slide").slice(e, f),
        g(c),
        b.slideCount <= b.options.slidesToShow ? (d = b.$slider.find(".slick-slide"),
        g(d)) : b.currentSlide >= b.slideCount - b.options.slidesToShow ? (d = b.$slider.find(".slick-cloned").slice(0, b.options.slidesToShow),
        g(d)) : 0 === b.currentSlide && (d = b.$slider.find(".slick-cloned").slice(-1 * b.options.slidesToShow),
        g(d))
    }
    ,
    b.prototype.loadSlider = function() {
        var a = this;
        a.setPosition(),
        a.$slideTrack.css({
            opacity: 1
        }),
        a.$slider.removeClass("slick-loading"),
        a.initUI(),
        "progressive" === a.options.lazyLoad && a.progressiveLazyLoad()
    }
    ,
    b.prototype.next = b.prototype.slickNext = function() {
        var a = this;
        a.changeSlide({
            data: {
                message: "next"
            }
        })
    }
    ,
    b.prototype.orientationChange = function() {
        var a = this;
        a.checkResponsive(),
        a.setPosition()
    }
    ,
    b.prototype.pause = b.prototype.slickPause = function() {
        var a = this;
        a.autoPlayClear(),
        a.paused = !0
    }
    ,
    b.prototype.play = b.prototype.slickPlay = function() {
        var a = this;
        a.autoPlay(),
        a.options.autoplay = !0,
        a.paused = !1,
        a.focussed = !1,
        a.interrupted = !1
    }
    ,
    b.prototype.postSlide = function(a) {
        var b = this;
        b.unslicked || (b.$slider.trigger("afterChange", [b, a]),
        b.animating = !1,
        b.setPosition(),
        b.swipeLeft = null,
        b.options.autoplay && b.autoPlay(),
        b.options.accessibility === !0 && b.initADA())
    }
    ,
    b.prototype.prev = b.prototype.slickPrev = function() {
        var a = this;
        a.changeSlide({
            data: {
                message: "previous"
            }
        })
    }
    ,
    b.prototype.preventDefault = function(a) {
        a.preventDefault()
    }
    ,
    b.prototype.progressiveLazyLoad = function(b) {
        b = b || 1;
        var e, f, g, c = this, d = a("img[data-lazy]", c.$slider);
        d.length ? (e = d.first(),
        f = e.attr("data-lazy"),
        g = document.createElement("img"),
        g.onload = function() {
            e.attr("src", f).removeAttr("data-lazy").removeClass("slick-loading"),
            c.options.adaptiveHeight === !0 && c.setPosition(),
            c.$slider.trigger("lazyLoaded", [c, e, f]),
            c.progressiveLazyLoad()
        }
        ,
        g.onerror = function() {
            3 > b ? setTimeout(function() {
                c.progressiveLazyLoad(b + 1)
            }, 500) : (e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),
            c.$slider.trigger("lazyLoadError", [c, e, f]),
            c.progressiveLazyLoad())
        }
        ,
        g.src = f) : c.$slider.trigger("allImagesLoaded", [c])
    }
    ,
    b.prototype.refresh = function(b) {
        var d, e, c = this;
        e = c.slideCount - c.options.slidesToShow,
        !c.options.infinite && c.currentSlide > e && (c.currentSlide = e),
        c.slideCount <= c.options.slidesToShow && (c.currentSlide = 0),
        d = c.currentSlide,
        c.destroy(!0),
        a.extend(c, c.initials, {
            currentSlide: d
        }),
        c.init(),
        b || c.changeSlide({
            data: {
                message: "index",
                index: d
            }
        }, !1)
    }
    ,
    b.prototype.registerBreakpoints = function() {
        var c, d, e, b = this, f = b.options.responsive || null;
        if ("array" === a.type(f) && f.length) {
            b.respondTo = b.options.respondTo || "window";
            for (c in f)
                if (e = b.breakpoints.length - 1,
                d = f[c].breakpoint,
                f.hasOwnProperty(c)) {
                    for (; e >= 0; )
                        b.breakpoints[e] && b.breakpoints[e] === d && b.breakpoints.splice(e, 1),
                        e--;
                    b.breakpoints.push(d),
                    b.breakpointSettings[d] = f[c].settings
                }
            b.breakpoints.sort(function(a, c) {
                return b.options.mobileFirst ? a - c : c - a
            })
        }
    }
    ,
    b.prototype.reinit = function() {
        var b = this;
        b.$slides = b.$slideTrack.children(b.options.slide).addClass("slick-slide"),
        b.slideCount = b.$slides.length,
        b.currentSlide >= b.slideCount && 0 !== b.currentSlide && (b.currentSlide = b.currentSlide - b.options.slidesToScroll),
        b.slideCount <= b.options.slidesToShow && (b.currentSlide = 0),
        b.registerBreakpoints(),
        b.setProps(),
        b.setupInfinite(),
        b.buildArrows(),
        b.updateArrows(),
        b.initArrowEvents(),
        b.buildDots(),
        b.updateDots(),
        b.initDotEvents(),
        b.cleanUpSlideEvents(),
        b.initSlideEvents(),
        b.checkResponsive(!1, !0),
        b.options.focusOnSelect === !0 && a(b.$slideTrack).children().on("click.slick", b.selectHandler),
        b.setSlideClasses("number" == typeof b.currentSlide ? b.currentSlide : 0),
        b.setPosition(),
        b.focusHandler(),
        b.paused = !b.options.autoplay,
        b.autoPlay(),
        b.$slider.trigger("reInit", [b])
    }
    ,
    b.prototype.resize = function() {
        var b = this;
        a(window).width() !== b.windowWidth && (clearTimeout(b.windowDelay),
        b.windowDelay = window.setTimeout(function() {
            b.windowWidth = a(window).width(),
            b.checkResponsive(),
            b.unslicked || b.setPosition()
        }, 50))
    }
    ,
    b.prototype.removeSlide = b.prototype.slickRemove = function(a, b, c) {
        var d = this;
        return "boolean" == typeof a ? (b = a,
        a = b === !0 ? 0 : d.slideCount - 1) : a = b === !0 ? --a : a,
        d.slideCount < 1 || 0 > a || a > d.slideCount - 1 ? !1 : (d.unload(),
        c === !0 ? d.$slideTrack.children().remove() : d.$slideTrack.children(this.options.slide).eq(a).remove(),
        d.$slides = d.$slideTrack.children(this.options.slide),
        d.$slideTrack.children(this.options.slide).detach(),
        d.$slideTrack.append(d.$slides),
        d.$slidesCache = d.$slides,
        void d.reinit())
    }
    ,
    b.prototype.setCSS = function(a) {
        var d, e, b = this, c = {};
        b.options.rtl === !0 && (a = -a),
        d = "left" == b.positionProp ? Math.ceil(a) + "px" : "0px",
        e = "top" == b.positionProp ? Math.ceil(a) + "px" : "0px",
        c[b.positionProp] = a,
        b.transformsEnabled === !1 ? b.$slideTrack.css(c) : (c = {},
        b.cssTransitions === !1 ? (c[b.animType] = "translate(" + d + ", " + e + ")",
        b.$slideTrack.css(c)) : (c[b.animType] = "translate3d(" + d + ", " + e + ", 0px)",
        b.$slideTrack.css(c)))
    }
    ,
    b.prototype.setDimensions = function() {
        var a = this;
        a.options.vertical === !1 ? a.options.centerMode === !0 && a.$list.css({
            padding: "0px " + a.options.centerPadding
        }) : (a.$list.height(a.$slides.first().outerHeight(!0) * a.options.slidesToShow),
        a.options.centerMode === !0 && a.$list.css({
            padding: a.options.centerPadding + " 0px"
        })),
        a.listWidth = a.$list.width(),
        a.listHeight = a.$list.height(),
        a.options.vertical === !1 && a.options.variableWidth === !1 ? (a.slideWidth = Math.ceil(a.listWidth / a.options.slidesToShow),
        a.$slideTrack.width(Math.ceil(a.slideWidth * a.$slideTrack.children(".slick-slide").length))) : a.options.variableWidth === !0 ? a.$slideTrack.width(5e3 * a.slideCount) : (a.slideWidth = Math.ceil(a.listWidth),
        a.$slideTrack.height(Math.ceil(a.$slides.first().outerHeight(!0) * a.$slideTrack.children(".slick-slide").length)));
        var b = a.$slides.first().outerWidth(!0) - a.$slides.first().width();
        a.options.variableWidth === !1 && a.$slideTrack.children(".slick-slide").width(a.slideWidth - b)
    }
    ,
    b.prototype.setFade = function() {
        var c, b = this;
        b.$slides.each(function(d, e) {
            c = b.slideWidth * d * -1,
            b.options.rtl === !0 ? a(e).css({
                position: "relative",
                right: c,
                top: 0,
                zIndex: b.options.zIndex - 2,
                opacity: 0
            }) : a(e).css({
                position: "relative",
                left: c,
                top: 0,
                zIndex: b.options.zIndex - 2,
                opacity: 0
            })
        }),
        b.$slides.eq(b.currentSlide).css({
            zIndex: b.options.zIndex - 1,
            opacity: 1
        })
    }
    ,
    b.prototype.setHeight = function() {
        var a = this;
        if (1 === a.options.slidesToShow && a.options.adaptiveHeight === !0 && a.options.vertical === !1) {
            var b = a.$slides.eq(a.currentSlide).outerHeight(!0);
            a.$list.css("height", b)
        }
    }
    ,
    b.prototype.setOption = b.prototype.slickSetOption = function() {
        var c, d, e, f, h, b = this, g = !1;
        if ("object" === a.type(arguments[0]) ? (e = arguments[0],
        g = arguments[1],
        h = "multiple") : "string" === a.type(arguments[0]) && (e = arguments[0],
        f = arguments[1],
        g = arguments[2],
        "responsive" === arguments[0] && "array" === a.type(arguments[1]) ? h = "responsive" : "undefined" != typeof arguments[1] && (h = "single")),
        "single" === h)
            b.options[e] = f;
        else if ("multiple" === h)
            a.each(e, function(a, c) {
                b.options[a] = c
            });
        else if ("responsive" === h)
            for (d in f)
                if ("array" !== a.type(b.options.responsive))
                    b.options.responsive = [f[d]];
                else {
                    for (c = b.options.responsive.length - 1; c >= 0; )
                        b.options.responsive[c].breakpoint === f[d].breakpoint && b.options.responsive.splice(c, 1),
                        c--;
                    b.options.responsive.push(f[d])
                }
        g && (b.unload(),
        b.reinit())
    }
    ,
    b.prototype.setPosition = function() {
        var a = this;
        a.setDimensions(),
        a.setHeight(),
        a.options.fade === !1 ? a.setCSS(a.getLeft(a.currentSlide)) : a.setFade(),
        a.$slider.trigger("setPosition", [a])
    }
    ,
    b.prototype.setProps = function() {
        var a = this
          , b = document.body.style;
        a.positionProp = a.options.vertical === !0 ? "top" : "left",
        "top" === a.positionProp ? a.$slider.addClass("slick-vertical") : a.$slider.removeClass("slick-vertical"),
        (void 0 !== b.WebkitTransition || void 0 !== b.MozTransition || void 0 !== b.msTransition) && a.options.useCSS === !0 && (a.cssTransitions = !0),
        a.options.fade && ("number" == typeof a.options.zIndex ? a.options.zIndex < 3 && (a.options.zIndex = 3) : a.options.zIndex = a.defaults.zIndex),
        void 0 !== b.OTransform && (a.animType = "OTransform",
        a.transformType = "-o-transform",
        a.transitionType = "OTransition",
        void 0 === b.perspectiveProperty && void 0 === b.webkitPerspective && (a.animType = !1)),
        void 0 !== b.MozTransform && (a.animType = "MozTransform",
        a.transformType = "-moz-transform",
        a.transitionType = "MozTransition",
        void 0 === b.perspectiveProperty && void 0 === b.MozPerspective && (a.animType = !1)),
        void 0 !== b.webkitTransform && (a.animType = "webkitTransform",
        a.transformType = "-webkit-transform",
        a.transitionType = "webkitTransition",
        void 0 === b.perspectiveProperty && void 0 === b.webkitPerspective && (a.animType = !1)),
        void 0 !== b.msTransform && (a.animType = "msTransform",
        a.transformType = "-ms-transform",
        a.transitionType = "msTransition",
        void 0 === b.msTransform && (a.animType = !1)),
        void 0 !== b.transform && a.animType !== !1 && (a.animType = "transform",
        a.transformType = "transform",
        a.transitionType = "transition"),
        a.transformsEnabled = a.options.useTransform && null !== a.animType && a.animType !== !1
    }
    ,
    b.prototype.setSlideClasses = function(a) {
        var c, d, e, f, b = this;
        d = b.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"),
        b.$slides.eq(a).addClass("slick-current"),
        b.options.centerMode === !0 ? (c = Math.floor(b.options.slidesToShow / 2),
        b.options.infinite === !0 && (a >= c && a <= b.slideCount - 1 - c ? b.$slides.slice(a - c, a + c + 1).addClass("slick-active").attr("aria-hidden", "false") : (e = b.options.slidesToShow + a,
        d.slice(e - c + 1, e + c + 2).addClass("slick-active").attr("aria-hidden", "false")),
        0 === a ? d.eq(d.length - 1 - b.options.slidesToShow).addClass("slick-center") : a === b.slideCount - 1 && d.eq(b.options.slidesToShow).addClass("slick-center")),
        b.$slides.eq(a).addClass("slick-center")) : a >= 0 && a <= b.slideCount - b.options.slidesToShow ? b.$slides.slice(a, a + b.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : d.length <= b.options.slidesToShow ? d.addClass("slick-active").attr("aria-hidden", "false") : (f = b.slideCount % b.options.slidesToShow,
        e = b.options.infinite === !0 ? b.options.slidesToShow + a : a,
        b.options.slidesToShow == b.options.slidesToScroll && b.slideCount - a < b.options.slidesToShow ? d.slice(e - (b.options.slidesToShow - f), e + f).addClass("slick-active").attr("aria-hidden", "false") : d.slice(e, e + b.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false")),
        "ondemand" === b.options.lazyLoad && b.lazyLoad()
    }
    ,
    b.prototype.setupInfinite = function() {
        var c, d, e, b = this;
        if (b.options.fade === !0 && (b.options.centerMode = !1),
        b.options.infinite === !0 && b.options.fade === !1 && (d = null,
        b.slideCount > b.options.slidesToShow)) {
            for (e = b.options.centerMode === !0 ? b.options.slidesToShow + 1 : b.options.slidesToShow,
            c = b.slideCount; c > b.slideCount - e; c -= 1)
                d = c - 1,
                a(b.$slides[d]).clone(!0).attr("id", "").attr("data-slick-index", d - b.slideCount).prependTo(b.$slideTrack).addClass("slick-cloned");
            for (c = 0; e > c; c += 1)
                d = c,
                a(b.$slides[d]).clone(!0).attr("id", "").attr("data-slick-index", d + b.slideCount).appendTo(b.$slideTrack).addClass("slick-cloned");
            b.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
                a(this).attr("id", "")
            })
        }
    }
    ,
    b.prototype.interrupt = function(a) {
        var b = this;
        a || b.autoPlay(),
        b.interrupted = a
    }
    ,
    b.prototype.selectHandler = function(b) {
        var c = this
          , d = a(b.target).is(".slick-slide") ? a(b.target) : a(b.target).parents(".slick-slide")
          , e = parseInt(d.attr("data-slick-index"));
        return e || (e = 0),
        c.slideCount <= c.options.slidesToShow ? (c.setSlideClasses(e),
        void c.asNavFor(e)) : void c.slideHandler(e)
    }
    ,
    b.prototype.slideHandler = function(a, b, c) {
        var d, e, f, g, j, h = null, i = this;
        return b = b || !1,
        i.animating === !0 && i.options.waitForAnimate === !0 || i.options.fade === !0 && i.currentSlide === a || i.slideCount <= i.options.slidesToShow ? void 0 : (b === !1 && i.asNavFor(a),
        d = a,
        h = i.getLeft(d),
        g = i.getLeft(i.currentSlide),
        i.currentLeft = null === i.swipeLeft ? g : i.swipeLeft,
        i.options.infinite === !1 && i.options.centerMode === !1 && (0 > a || a > i.getDotCount() * i.options.slidesToScroll) ? void (i.options.fade === !1 && (d = i.currentSlide,
        c !== !0 ? i.animateSlide(g, function() {
            i.postSlide(d)
        }) : i.postSlide(d))) : i.options.infinite === !1 && i.options.centerMode === !0 && (0 > a || a > i.slideCount - i.options.slidesToScroll) ? void (i.options.fade === !1 && (d = i.currentSlide,
        c !== !0 ? i.animateSlide(g, function() {
            i.postSlide(d)
        }) : i.postSlide(d))) : (i.options.autoplay && clearInterval(i.autoPlayTimer),
        e = 0 > d ? i.slideCount % i.options.slidesToScroll !== 0 ? i.slideCount - i.slideCount % i.options.slidesToScroll : i.slideCount + d : d >= i.slideCount ? i.slideCount % i.options.slidesToScroll !== 0 ? 0 : d - i.slideCount : d,
        i.animating = !0,
        i.$slider.trigger("beforeChange", [i, i.currentSlide, e]),
        f = i.currentSlide,
        i.currentSlide = e,
        i.setSlideClasses(i.currentSlide),
        i.options.asNavFor && (j = i.getNavTarget(),
        j = j.slick("getSlick"),
        j.slideCount <= j.options.slidesToShow && j.setSlideClasses(i.currentSlide)),
        i.updateDots(),
        i.updateArrows(),
        i.options.fade === !0 ? (c !== !0 ? (i.fadeSlideOut(f),
        i.fadeSlide(e, function() {
            i.postSlide(e)
        })) : i.postSlide(e),
        void i.animateHeight()) : void (c !== !0 ? i.animateSlide(h, function() {
            i.postSlide(e)
        }) : i.postSlide(e))))
    }
    ,
    b.prototype.startLoad = function() {
        var a = this;
        a.options.arrows === !0 && a.slideCount > a.options.slidesToShow && (a.$prevArrow.hide(),
        a.$nextArrow.hide()),
        a.options.dots === !0 && a.slideCount > a.options.slidesToShow && a.$dots.hide(),
        a.$slider.addClass("slick-loading")
    }
    ,
    b.prototype.swipeDirection = function() {
        var a, b, c, d, e = this;
        return a = e.touchObject.startX - e.touchObject.curX,
        b = e.touchObject.startY - e.touchObject.curY,
        c = Math.atan2(b, a),
        d = Math.round(180 * c / Math.PI),
        0 > d && (d = 360 - Math.abs(d)),
        45 >= d && d >= 0 ? e.options.rtl === !1 ? "left" : "right" : 360 >= d && d >= 315 ? e.options.rtl === !1 ? "left" : "right" : d >= 135 && 225 >= d ? e.options.rtl === !1 ? "right" : "left" : e.options.verticalSwiping === !0 ? d >= 35 && 135 >= d ? "down" : "up" : "vertical"
    }
    ,
    b.prototype.swipeEnd = function(a) {
        var c, d, b = this;
        if (b.dragging = !1,
        b.interrupted = !1,
        b.shouldClick = b.touchObject.swipeLength > 10 ? !1 : !0,
        void 0 === b.touchObject.curX)
            return !1;
        if (b.touchObject.edgeHit === !0 && b.$slider.trigger("edge", [b, b.swipeDirection()]),
        b.touchObject.swipeLength >= b.touchObject.minSwipe) {
            switch (d = b.swipeDirection()) {
            case "left":
            case "down":
                c = b.options.swipeToSlide ? b.checkNavigable(b.currentSlide + b.getSlideCount()) : b.currentSlide + b.getSlideCount(),
                b.currentDirection = 0;
                break;
            case "right":
            case "up":
                c = b.options.swipeToSlide ? b.checkNavigable(b.currentSlide - b.getSlideCount()) : b.currentSlide - b.getSlideCount(),
                b.currentDirection = 1
            }
            "vertical" != d && (b.slideHandler(c),
            b.touchObject = {},
            b.$slider.trigger("swipe", [b, d]))
        } else
            b.touchObject.startX !== b.touchObject.curX && (b.slideHandler(b.currentSlide),
            b.touchObject = {})
    }
    ,
    b.prototype.swipeHandler = function(a) {
        var b = this;
        if (!(b.options.swipe === !1 || "ontouchend"in document && b.options.swipe === !1 || b.options.draggable === !1 && -1 !== a.type.indexOf("mouse")))
            switch (b.touchObject.fingerCount = a.originalEvent && void 0 !== a.originalEvent.touches ? a.originalEvent.touches.length : 1,
            b.touchObject.minSwipe = b.listWidth / b.options.touchThreshold,
            b.options.verticalSwiping === !0 && (b.touchObject.minSwipe = b.listHeight / b.options.touchThreshold),
            a.data.action) {
            case "start":
                b.swipeStart(a);
                break;
            case "move":
                b.swipeMove(a);
                break;
            case "end":
                b.swipeEnd(a)
            }
    }
    ,
    b.prototype.swipeMove = function(a) {
        var d, e, f, g, h, b = this;
        return h = void 0 !== a.originalEvent ? a.originalEvent.touches : null,
        !b.dragging || h && 1 !== h.length ? !1 : (d = b.getLeft(b.currentSlide),
        b.touchObject.curX = void 0 !== h ? h[0].pageX : a.clientX,
        b.touchObject.curY = void 0 !== h ? h[0].pageY : a.clientY,
        b.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(b.touchObject.curX - b.touchObject.startX, 2))),
        b.options.verticalSwiping === !0 && (b.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(b.touchObject.curY - b.touchObject.startY, 2)))),
        e = b.swipeDirection(),
        "vertical" !== e ? (void 0 !== a.originalEvent && b.touchObject.swipeLength > 4 && a.preventDefault(),
        g = (b.options.rtl === !1 ? 1 : -1) * (b.touchObject.curX > b.touchObject.startX ? 1 : -1),
        b.options.verticalSwiping === !0 && (g = b.touchObject.curY > b.touchObject.startY ? 1 : -1),
        f = b.touchObject.swipeLength,
        b.touchObject.edgeHit = !1,
        b.options.infinite === !1 && (0 === b.currentSlide && "right" === e || b.currentSlide >= b.getDotCount() && "left" === e) && (f = b.touchObject.swipeLength * b.options.edgeFriction,
        b.touchObject.edgeHit = !0),
        b.options.vertical === !1 ? b.swipeLeft = d + f * g : b.swipeLeft = d + f * (b.$list.height() / b.listWidth) * g,
        b.options.verticalSwiping === !0 && (b.swipeLeft = d + f * g),
        b.options.fade === !0 || b.options.touchMove === !1 ? !1 : b.animating === !0 ? (b.swipeLeft = null,
        !1) : void b.setCSS(b.swipeLeft)) : void 0)
    }
    ,
    b.prototype.swipeStart = function(a) {
        var c, b = this;
        return b.interrupted = !0,
        1 !== b.touchObject.fingerCount || b.slideCount <= b.options.slidesToShow ? (b.touchObject = {},
        !1) : (void 0 !== a.originalEvent && void 0 !== a.originalEvent.touches && (c = a.originalEvent.touches[0]),
        b.touchObject.startX = b.touchObject.curX = void 0 !== c ? c.pageX : a.clientX,
        b.touchObject.startY = b.touchObject.curY = void 0 !== c ? c.pageY : a.clientY,
        void (b.dragging = !0))
    }
    ,
    b.prototype.unfilterSlides = b.prototype.slickUnfilter = function() {
        var a = this;
        null !== a.$slidesCache && (a.unload(),
        a.$slideTrack.children(this.options.slide).detach(),
        a.$slidesCache.appendTo(a.$slideTrack),
        a.reinit())
    }
    ,
    b.prototype.unload = function() {
        var b = this;
        a(".slick-cloned", b.$slider).remove(),
        b.$dots && b.$dots.remove(),
        b.$prevArrow && b.htmlExpr.test(b.options.prevArrow) && b.$prevArrow.remove(),
        b.$nextArrow && b.htmlExpr.test(b.options.nextArrow) && b.$nextArrow.remove(),
        b.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
    }
    ,
    b.prototype.unslick = function(a) {
        var b = this;
        b.$slider.trigger("unslick", [b, a]),
        b.destroy()
    }
    ,
    b.prototype.updateArrows = function() {
        var b, a = this;
        b = Math.floor(a.options.slidesToShow / 2),
        a.options.arrows === !0 && a.slideCount > a.options.slidesToShow && !a.options.infinite && (a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
        a.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
        0 === a.currentSlide ? (a.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
        a.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : a.currentSlide >= a.slideCount - a.options.slidesToShow && a.options.centerMode === !1 ? (a.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
        a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : a.currentSlide >= a.slideCount - 1 && a.options.centerMode === !0 && (a.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
        a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
    }
    ,
    b.prototype.updateDots = function() {
        var a = this;
        null !== a.$dots && (a.$dots.find("li").removeClass("slick-active").attr("aria-hidden", "true"),
        a.$dots.find("li").eq(Math.floor(a.currentSlide / a.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden", "false"))
    }
    ,
    b.prototype.visibility = function() {
        var a = this;
        a.options.autoplay && (document[a.hidden] ? a.interrupted = !0 : a.interrupted = !1)
    }
    ,
    a.fn.slick = function() {
        var f, g, a = this, c = arguments[0], d = Array.prototype.slice.call(arguments, 1), e = a.length;
        for (f = 0; e > f; f++)
            if ("object" == typeof c || "undefined" == typeof c ? a[f].slick = new b(a[f],c) : g = a[f].slick[c].apply(a[f].slick, d),
            "undefined" != typeof g)
                return g;
        return a
    }
}),
/*
/*! Magnific Popup - v1.1.0 - 2016-02-20
* http://dimsemenov.com/plugins/magnific-popup/
* Copyright (c) 2016 Dmitry Semenov; */
!function(a) {
    "function" == typeof define && define.amd ? define(["jquery"], a) : a("object" == typeof exports ? require("jquery") : window.jQuery || window.Zepto)
}(function(a) {
    var b, c, d, e, f, g, h = "Close", i = "BeforeClose", j = "AfterClose", k = "BeforeAppend", l = "MarkupParse", m = "Open", n = "Change", o = "mfp", p = "." + o, q = "mfp-ready", r = "mfp-removing", s = "mfp-prevent-close", t = function() {}, u = !!window.jQuery, v = a(window), w = function(a, c) {
        b.ev.on(o + a + p, c)
    }, x = function(b, c, d, e) {
        var f = document.createElement("div");
        return f.className = "mfp-" + b,
        d && (f.innerHTML = d),
        e ? c && c.appendChild(f) : (f = a(f),
        c && f.appendTo(c)),
        f
    }, y = function(c, d) {
        b.ev.triggerHandler(o + c, d),
        b.st.callbacks && (c = c.charAt(0).toLowerCase() + c.slice(1),
        b.st.callbacks[c] && b.st.callbacks[c].apply(b, a.isArray(d) ? d : [d]))
    }, z = function(c) {
        return c === g && b.currTemplate.closeBtn || (b.currTemplate.closeBtn = a(b.st.closeMarkup.replace("%title%", b.st.tClose)),
        g = c),
        b.currTemplate.closeBtn
    }, A = function() {
        a.magnificPopup.instance || (b = new t,
        b.init(),
        a.magnificPopup.instance = b)
    }, B = function() {
        var a = document.createElement("p").style
          , b = ["ms", "O", "Moz", "Webkit"];
        if (void 0 !== a.transition)
            return !0;
        for (; b.length; )
            if (b.pop() + "Transition"in a)
                return !0;
        return !1
    };
    t.prototype = {
        constructor: t,
        init: function() {
            var c = navigator.appVersion;
            b.isLowIE = b.isIE8 = document.all && !document.addEventListener,
            b.isAndroid = /android/gi.test(c),
            b.isIOS = /iphone|ipad|ipod/gi.test(c),
            b.supportsTransition = B(),
            b.probablyMobile = b.isAndroid || b.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent),
            d = a(document),
            b.popupsCache = {}
        },
        open: function(c) {
            var e;
            if (c.isObj === !1) {
                b.items = c.items.toArray(),
                b.index = 0;
                var g, h = c.items;
                for (e = 0; e < h.length; e++)
                    if (g = h[e],
                    g.parsed && (g = g.el[0]),
                    g === c.el[0]) {
                        b.index = e;
                        break
                    }
            } else
                b.items = a.isArray(c.items) ? c.items : [c.items],
                b.index = c.index || 0;
            if (b.isOpen)
                return void b.updateItemHTML();
            b.types = [],
            f = "",
            c.mainEl && c.mainEl.length ? b.ev = c.mainEl.eq(0) : b.ev = d,
            c.key ? (b.popupsCache[c.key] || (b.popupsCache[c.key] = {}),
            b.currTemplate = b.popupsCache[c.key]) : b.currTemplate = {},
            b.st = a.extend(!0, {}, a.magnificPopup.defaults, c),
            b.fixedContentPos = "auto" === b.st.fixedContentPos ? !b.probablyMobile : b.st.fixedContentPos,
            b.st.modal && (b.st.closeOnContentClick = !1,
            b.st.closeOnBgClick = !1,
            b.st.showCloseBtn = !1,
            b.st.enableEscapeKey = !1),
            b.bgOverlay || (b.bgOverlay = x("bg").on("click" + p, function() {
                b.close()
            }),
            b.wrap = x("wrap").attr("tabindex", -1).on("click" + p, function(a) {
                b._checkIfClose(a.target) && b.close()
            }),
            b.container = x("container", b.wrap)),
            b.contentContainer = x("content"),
            b.st.preloader && (b.preloader = x("preloader", b.container, b.st.tLoading));
            var i = a.magnificPopup.modules;
            for (e = 0; e < i.length; e++) {
                var j = i[e];
                j = j.charAt(0).toUpperCase() + j.slice(1),
                b["init" + j].call(b)
            }
            y("BeforeOpen"),
            b.st.showCloseBtn && (b.st.closeBtnInside ? (w(l, function(a, b, c, d) {
                c.close_replaceWith = z(d.type)
            }),
            f += " mfp-close-btn-in") : b.wrap.append(z())),
            b.st.alignTop && (f += " mfp-align-top"),
            b.fixedContentPos ? b.wrap.css({
                overflow: b.st.overflowY,
                overflowX: "hidden",
                overflowY: b.st.overflowY
            }) : b.wrap.css({
                top: v.scrollTop(),
                position: "absolute"
            }),
            (b.st.fixedBgPos === !1 || "auto" === b.st.fixedBgPos && !b.fixedContentPos) && b.bgOverlay.css({
                height: d.height(),
                position: "absolute"
            }),
            b.st.enableEscapeKey && d.on("keyup" + p, function(a) {
                27 === a.keyCode && b.close()
            }),
            v.on("resize" + p, function() {
                b.updateSize()
            }),
            b.st.closeOnContentClick || (f += " mfp-auto-cursor"),
            f && b.wrap.addClass(f);
            var k = b.wH = v.height()
              , n = {};
            if (b.fixedContentPos && b._hasScrollBar(k)) {
                var o = b._getScrollbarSize();
                o && (n.marginRight = o)
            }
            b.fixedContentPos && (b.isIE7 ? a("body, html").css("overflow", "hidden") : n.overflow = "hidden");
            var r = b.st.mainClass;
            return b.isIE7 && (r += " mfp-ie7"),
            r && b._addClassToMFP(r),
            b.updateItemHTML(),
            y("BuildControls"),
            a("html").css(n),
            b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo || a(document.body)),
            b._lastFocusedEl = document.activeElement,
            setTimeout(function() {
                b.content ? (b._addClassToMFP(q),
                b._setFocus()) : b.bgOverlay.addClass(q),
                d.on("focusin" + p, b._onFocusIn)
            }, 16),
            b.isOpen = !0,
            b.updateSize(k),
            y(m),
            c
        },
        close: function() {
            b.isOpen && (y(i),
            b.isOpen = !1,
            b.st.removalDelay && !b.isLowIE && b.supportsTransition ? (b._addClassToMFP(r),
            setTimeout(function() {
                b._close()
            }, b.st.removalDelay)) : b._close())
        },
        _close: function() {
            y(h);
            var c = r + " " + q + " ";
            if (b.bgOverlay.detach(),
            b.wrap.detach(),
            b.container.empty(),
            b.st.mainClass && (c += b.st.mainClass + " "),
            b._removeClassFromMFP(c),
            b.fixedContentPos) {
                var e = {
                    marginRight: ""
                };
                b.isIE7 ? a("body, html").css("overflow", "") : e.overflow = "",
                a("html").css(e)
            }
            d.off("keyup" + p + " focusin" + p),
            b.ev.off(p),
            b.wrap.attr("class", "mfp-wrap").removeAttr("style"),
            b.bgOverlay.attr("class", "mfp-bg"),
            b.container.attr("class", "mfp-container"),
            !b.st.showCloseBtn || b.st.closeBtnInside && b.currTemplate[b.currItem.type] !== !0 || b.currTemplate.closeBtn && b.currTemplate.closeBtn.detach(),
            b.st.autoFocusLast && b._lastFocusedEl && a(b._lastFocusedEl).focus(),
            b.currItem = null,
            b.content = null,
            b.currTemplate = null,
            b.prevHeight = 0,
            y(j)
        },
        updateSize: function(a) {
            if (b.isIOS) {
                var c = document.documentElement.clientWidth / window.innerWidth
                  , d = window.innerHeight * c;
                b.wrap.css("height", d),
                b.wH = d
            } else
                b.wH = a || v.height();
            b.fixedContentPos || b.wrap.css("height", b.wH),
            y("Resize")
        },
        updateItemHTML: function() {
            var c = b.items[b.index];
            b.contentContainer.detach(),
            b.content && b.content.detach(),
            c.parsed || (c = b.parseEl(b.index));
            var d = c.type;
            if (y("BeforeChange", [b.currItem ? b.currItem.type : "", d]),
            b.currItem = c,
            !b.currTemplate[d]) {
                var f = b.st[d] ? b.st[d].markup : !1;
                y("FirstMarkupParse", f),
                f ? b.currTemplate[d] = a(f) : b.currTemplate[d] = !0
            }
            e && e !== c.type && b.container.removeClass("mfp-" + e + "-holder");
            var g = b["get" + d.charAt(0).toUpperCase() + d.slice(1)](c, b.currTemplate[d]);
            b.appendContent(g, d),
            c.preloaded = !0,
            y(n, c),
            e = c.type,
            b.container.prepend(b.contentContainer),
            y("AfterChange")
        },
        appendContent: function(a, c) {
            b.content = a,
            a ? b.st.showCloseBtn && b.st.closeBtnInside && b.currTemplate[c] === !0 ? b.content.find(".mfp-close").length || b.content.append(z()) : b.content = a : b.content = "",
            y(k),
            b.container.addClass("mfp-" + c + "-holder"),
            b.contentContainer.append(b.content)
        },
        parseEl: function(c) {
            var d, e = b.items[c];
            if (e.tagName ? e = {
                el: a(e)
            } : (d = e.type,
            e = {
                data: e,
                src: e.src
            }),
            e.el) {
                for (var f = b.types, g = 0; g < f.length; g++)
                    if (e.el.hasClass("mfp-" + f[g])) {
                        d = f[g];
                        break
                    }
                e.src = e.el.attr("data-mfp-src"),
                e.src || (e.src = e.el.attr("href"))
            }
            return e.type = d || b.st.type || "inline",
            e.index = c,
            e.parsed = !0,
            b.items[c] = e,
            y("ElementParse", e),
            b.items[c]
        },
        addGroup: function(a, c) {
            var d = function(d) {
                d.mfpEl = this,
                b._openClick(d, a, c)
            };
            c || (c = {});
            var e = "click.magnificPopup";
            c.mainEl = a,
            c.items ? (c.isObj = !0,
            a.off(e).on(e, d)) : (c.isObj = !1,
            c.delegate ? a.off(e).on(e, c.delegate, d) : (c.items = a,
            a.off(e).on(e, d)))
        },
        _openClick: function(c, d, e) {
            var f = void 0 !== e.midClick ? e.midClick : a.magnificPopup.defaults.midClick;
            if (f || !(2 === c.which || c.ctrlKey || c.metaKey || c.altKey || c.shiftKey)) {
                var g = void 0 !== e.disableOn ? e.disableOn : a.magnificPopup.defaults.disableOn;
                if (g)
                    if (a.isFunction(g)) {
                        if (!g.call(b))
                            return !0
                    } else if (v.width() < g)
                        return !0;
                c.type && (c.preventDefault(),
                b.isOpen && c.stopPropagation()),
                e.el = a(c.mfpEl),
                e.delegate && (e.items = d.find(e.delegate)),
                b.open(e)
            }
        },
        updateStatus: function(a, d) {
            if (b.preloader) {
                c !== a && b.container.removeClass("mfp-s-" + c),
                d || "loading" !== a || (d = b.st.tLoading);
                var e = {
                    status: a,
                    text: d
                };
                y("UpdateStatus", e),
                a = e.status,
                d = e.text,
                b.preloader.html(d),
                b.preloader.find("a").on("click", function(a) {
                    a.stopImmediatePropagation()
                }),
                b.container.addClass("mfp-s-" + a),
                c = a
            }
        },
        _checkIfClose: function(c) {
            if (!a(c).hasClass(s)) {
                var d = b.st.closeOnContentClick
                  , e = b.st.closeOnBgClick;
                if (d && e)
                    return !0;
                if (!b.content || a(c).hasClass("mfp-close") || b.preloader && c === b.preloader[0])
                    return !0;
                if (c === b.content[0] || a.contains(b.content[0], c)) {
                    if (d)
                        return !0
                } else if (e && a.contains(document, c))
                    return !0;
                return !1
            }
        },
        _addClassToMFP: function(a) {
            b.bgOverlay.addClass(a),
            b.wrap.addClass(a)
        },
        _removeClassFromMFP: function(a) {
            this.bgOverlay.removeClass(a),
            b.wrap.removeClass(a)
        },
        _hasScrollBar: function(a) {
            return (b.isIE7 ? d.height() : document.body.scrollHeight) > (a || v.height())
        },
        _setFocus: function() {
            (b.st.focus ? b.content.find(b.st.focus).eq(0) : b.wrap).focus()
        },
        _onFocusIn: function(c) {
            return c.target === b.wrap[0] || a.contains(b.wrap[0], c.target) ? void 0 : (b._setFocus(),
            !1)
        },
        _parseMarkup: function(b, c, d) {
            var e;
            d.data && (c = a.extend(d.data, c)),
            y(l, [b, c, d]),
            a.each(c, function(c, d) {
                if (void 0 === d || d === !1)
                    return !0;
                if (e = c.split("_"),
                e.length > 1) {
                    var f = b.find(p + "-" + e[0]);
                    if (f.length > 0) {
                        var g = e[1];
                        "replaceWith" === g ? f[0] !== d[0] && f.replaceWith(d) : "img" === g ? f.is("img") ? f.attr("src", d) : f.replaceWith(a("<img>").attr("src", d).attr("class", f.attr("class"))) : f.attr(e[1], d)
                    }
                } else
                    b.find(p + "-" + c).html(d)
            })
        },
        _getScrollbarSize: function() {
            if (void 0 === b.scrollbarSize) {
                var a = document.createElement("div");
                a.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;",
                document.body.appendChild(a),
                b.scrollbarSize = a.offsetWidth - a.clientWidth,
                document.body.removeChild(a)
            }
            return b.scrollbarSize
        }
    },
    a.magnificPopup = {
        instance: null,
        proto: t.prototype,
        modules: [],
        open: function(b, c) {
            return A(),
            b = b ? a.extend(!0, {}, b) : {},
            b.isObj = !0,
            b.index = c || 0,
            this.instance.open(b)
        },
        close: function() {
            return a.magnificPopup.instance && a.magnificPopup.instance.close()
        },
        registerModule: function(b, c) {
            c.options && (a.magnificPopup.defaults[b] = c.options),
            a.extend(this.proto, c.proto),
            this.modules.push(b)
        },
        defaults: {
            disableOn: 0,
            key: null,
            midClick: !1,
            mainClass: "",
            preloader: !0,
            focus: "",
            closeOnContentClick: !1,
            closeOnBgClick: !0,
            closeBtnInside: !0,
            showCloseBtn: !0,
            enableEscapeKey: !0,
            modal: !1,
            alignTop: !1,
            removalDelay: 0,
            prependTo: null,
            fixedContentPos: "auto",
            fixedBgPos: "auto",
            overflowY: "auto",
            closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>',
            tClose: "Close (Esc)",
            tLoading: "Loading...",
            autoFocusLast: !0
        }
    },
    a.fn.magnificPopup = function(c) {
        A();
        var d = a(this);
        if ("string" == typeof c)
            if ("open" === c) {
                var e, f = u ? d.data("magnificPopup") : d[0].magnificPopup, g = parseInt(arguments[1], 10) || 0;
                f.items ? e = f.items[g] : (e = d,
                f.delegate && (e = e.find(f.delegate)),
                e = e.eq(g)),
                b._openClick({
                    mfpEl: e
                }, d, f)
            } else
                b.isOpen && b[c].apply(b, Array.prototype.slice.call(arguments, 1));
        else
            c = a.extend(!0, {}, c),
            u ? d.data("magnificPopup", c) : d[0].magnificPopup = c,
            b.addGroup(d, c);
        return d
    }
    ;
    var C, D, E, F = "inline", G = function() {
        E && (D.after(E.addClass(C)).detach(),
        E = null)
    };
    a.magnificPopup.registerModule(F, {
        options: {
            hiddenClass: "hide",
            markup: "",
            tNotFound: "Content not found"
        },
        proto: {
            initInline: function() {
                b.types.push(F),
                w(h + "." + F, function() {
                    G()
                })
            },
            getInline: function(c, d) {
                if (G(),
                c.src) {
                    var e = b.st.inline
                      , f = a(c.src);
                    if (f.length) {
                        var g = f[0].parentNode;
                        g && g.tagName && (D || (C = e.hiddenClass,
                        D = x(C),
                        C = "mfp-" + C),
                        E = f.after(D).detach().removeClass(C)),
                        b.updateStatus("ready")
                    } else
                        b.updateStatus("error", e.tNotFound),
                        f = a("<div>");
                    return c.inlineElement = f,
                    f
                }
                return b.updateStatus("ready"),
                b._parseMarkup(d, {}, c),
                d
            }
        }
    });
    var H, I = "ajax", J = function() {
        H && a(document.body).removeClass(H)
    }, K = function() {
        J(),
        b.req && b.req.abort()
    };
    a.magnificPopup.registerModule(I, {
        options: {
            settings: null,
            cursor: "mfp-ajax-cur",
            tError: '<a href="%url%">The content</a> could not be loaded.'
        },
        proto: {
            initAjax: function() {
                b.types.push(I),
                H = b.st.ajax.cursor,
                w(h + "." + I, K),
                w("BeforeChange." + I, K)
            },
            getAjax: function(c) {
                H && a(document.body).addClass(H),
                b.updateStatus("loading");
                var d = a.extend({
                    url: c.src,
                    success: function(d, e, f) {
                        var g = {
                            data: d,
                            xhr: f
                        };
                        y("ParseAjax", g),
                        b.appendContent(a(g.data), I),
                        c.finished = !0,
                        J(),
                        b._setFocus(),
                        setTimeout(function() {
                            b.wrap.addClass(q)
                        }, 16),
                        b.updateStatus("ready"),
                        y("AjaxContentAdded")
                    },
                    error: function() {
                        J(),
                        c.finished = c.loadError = !0,
                        b.updateStatus("error", b.st.ajax.tError.replace("%url%", c.src))
                    }
                }, b.st.ajax.settings);
                return b.req = a.ajax(d),
                ""
            }
        }
    });
    var L, M = function(c) {
        if (c.data && void 0 !== c.data.title)
            return c.data.title;
        var d = b.st.image.titleSrc;
        if (d) {
            if (a.isFunction(d))
                return d.call(b, c);
            if (c.el)
                return c.el.attr(d) || ""
        }
        return ""
    };
    a.magnificPopup.registerModule("image", {
        options: {
            markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
            cursor: "mfp-zoom-out-cur",
            titleSrc: "title",
            verticalFit: !0,
            tError: '<a href="%url%">The image</a> could not be loaded.'
        },
        proto: {
            initImage: function() {
                var c = b.st.image
                  , d = ".image";
                b.types.push("image"),
                w(m + d, function() {
                    "image" === b.currItem.type && c.cursor && a(document.body).addClass(c.cursor)
                }),
                w(h + d, function() {
                    c.cursor && a(document.body).removeClass(c.cursor),
                    v.off("resize" + p)
                }),
                w("Resize" + d, b.resizeImage),
                b.isLowIE && w("AfterChange", b.resizeImage)
            },
            resizeImage: function() {
                var a = b.currItem;
                if (a && a.img && b.st.image.verticalFit) {
                    var c = 0;
                    b.isLowIE && (c = parseInt(a.img.css("padding-top"), 10) + parseInt(a.img.css("padding-bottom"), 10)),
                    a.img.css("max-height", b.wH - c)
                }
            },
            _onImageHasSize: function(a) {
                a.img && (a.hasSize = !0,
                L && clearInterval(L),
                a.isCheckingImgSize = !1,
                y("ImageHasSize", a),
                a.imgHidden && (b.content && b.content.removeClass("mfp-loading"),
                a.imgHidden = !1))
            },
            findImageSize: function(a) {
                var c = 0
                  , d = a.img[0]
                  , e = function(f) {
                    L && clearInterval(L),
                    L = setInterval(function() {
                        return d.naturalWidth > 0 ? void b._onImageHasSize(a) : (c > 200 && clearInterval(L),
                        c++,
                        void (3 === c ? e(10) : 40 === c ? e(50) : 100 === c && e(500)))
                    }, f)
                };
                e(1)
            },
            getImage: function(c, d) {
                var e = 0
                  , f = function() {
                    c && (c.img[0].complete ? (c.img.off(".mfploader"),
                    c === b.currItem && (b._onImageHasSize(c),
                    b.updateStatus("ready")),
                    c.hasSize = !0,
                    c.loaded = !0,
                    y("ImageLoadComplete")) : (e++,
                    200 > e ? setTimeout(f, 100) : g()))
                }
                  , g = function() {
                    c && (c.img.off(".mfploader"),
                    c === b.currItem && (b._onImageHasSize(c),
                    b.updateStatus("error", h.tError.replace("%url%", c.src))),
                    c.hasSize = !0,
                    c.loaded = !0,
                    c.loadError = !0)
                }
                  , h = b.st.image
                  , i = d.find(".mfp-img");
                if (i.length) {
                    var j = document.createElement("img");
                    j.className = "mfp-img",
                    c.el && c.el.find("img").length && (j.alt = c.el.find("img").attr("alt")),
                    c.img = a(j).on("load.mfploader", f).on("error.mfploader", g),
                    j.src = c.src,
                    i.is("img") && (c.img = c.img.clone()),
                    j = c.img[0],
                    j.naturalWidth > 0 ? c.hasSize = !0 : j.width || (c.hasSize = !1)
                }
                return b._parseMarkup(d, {
                    title: M(c),
                    img_replaceWith: c.img
                }, c),
                b.resizeImage(),
                c.hasSize ? (L && clearInterval(L),
                c.loadError ? (d.addClass("mfp-loading"),
                b.updateStatus("error", h.tError.replace("%url%", c.src))) : (d.removeClass("mfp-loading"),
                b.updateStatus("ready")),
                d) : (b.updateStatus("loading"),
                c.loading = !0,
                c.hasSize || (c.imgHidden = !0,
                d.addClass("mfp-loading"),
                b.findImageSize(c)),
                d)
            }
        }
    });
    var N, O = function() {
        return void 0 === N && (N = void 0 !== document.createElement("p").style.MozTransform),
        N
    };
    a.magnificPopup.registerModule("zoom", {
        options: {
            enabled: !1,
            easing: "ease-in-out",
            duration: 300,
            opener: function(a) {
                return a.is("img") ? a : a.find("img")
            }
        },
        proto: {
            initZoom: function() {
                var a, c = b.st.zoom, d = ".zoom";
                if (c.enabled && b.supportsTransition) {
                    var e, f, g = c.duration, j = function(a) {
                        var b = a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image")
                          , d = "all " + c.duration / 1e3 + "s " + c.easing
                          , e = {
                            position: "fixed",
                            zIndex: 9999,
                            left: 0,
                            top: 0,
                            "-webkit-backface-visibility": "hidden"
                        }
                          , f = "transition";
                        return e["-webkit-" + f] = e["-moz-" + f] = e["-o-" + f] = e[f] = d,
                        b.css(e),
                        b
                    }, k = function() {
                        b.content.css("visibility", "visible")
                    };
                    w("BuildControls" + d, function() {
                        if (b._allowZoom()) {
                            if (clearTimeout(e),
                            b.content.css("visibility", "hidden"),
                            a = b._getItemToZoom(),
                            !a)
                                return void k();
                            f = j(a),
                            f.css(b._getOffset()),
                            b.wrap.append(f),
                            e = setTimeout(function() {
                                f.css(b._getOffset(!0)),
                                e = setTimeout(function() {
                                    k(),
                                    setTimeout(function() {
                                        f.remove(),
                                        a = f = null,
                                        y("ZoomAnimationEnded")
                                    }, 16)
                                }, g)
                            }, 16)
                        }
                    }),
                    w(i + d, function() {
                        if (b._allowZoom()) {
                            if (clearTimeout(e),
                            b.st.removalDelay = g,
                            !a) {
                                if (a = b._getItemToZoom(),
                                !a)
                                    return;
                                f = j(a)
                            }
                            f.css(b._getOffset(!0)),
                            b.wrap.append(f),
                            b.content.css("visibility", "hidden"),
                            setTimeout(function() {
                                f.css(b._getOffset())
                            }, 16)
                        }
                    }),
                    w(h + d, function() {
                        b._allowZoom() && (k(),
                        f && f.remove(),
                        a = null)
                    })
                }
            },
            _allowZoom: function() {
                return "image" === b.currItem.type
            },
            _getItemToZoom: function() {
                return b.currItem.hasSize ? b.currItem.img : !1
            },
            _getOffset: function(c) {
                var d;
                d = c ? b.currItem.img : b.st.zoom.opener(b.currItem.el || b.currItem);
                var e = d.offset()
                  , f = parseInt(d.css("padding-top"), 10)
                  , g = parseInt(d.css("padding-bottom"), 10);
                e.top -= a(window).scrollTop() - f;
                var h = {
                    width: d.width(),
                    height: (u ? d.innerHeight() : d[0].offsetHeight) - g - f
                };
                return O() ? h["-moz-transform"] = h.transform = "translate(" + e.left + "px," + e.top + "px)" : (h.left = e.left,
                h.top = e.top),
                h
            }
        }
    });
    var P = "iframe"
      , Q = "//about:blank"
      , R = function(a) {
        if (b.currTemplate[P]) {
            var c = b.currTemplate[P].find("iframe");
            c.length && (a || (c[0].src = Q),
            b.isIE8 && c.css("display", a ? "block" : "none"))
        }
    };
    a.magnificPopup.registerModule(P, {
        options: {
            markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
            srcAction: "iframe_src",
            patterns: {
                youtube: {
                    index: "youtube.com",
                    id: "v=",
                    src: "//www.youtube.com/embed/%id%?autoplay=1"
                },
                vimeo: {
                    index: "vimeo.com/",
                    id: "/",
                    src: "//player.vimeo.com/video/%id%?autoplay=1"
                },
                gmaps: {
                    index: "//maps.google.",
                    src: "%id%&output=embed"
                }
            }
        },
        proto: {
            initIframe: function() {
                b.types.push(P),
                w("BeforeChange", function(a, b, c) {
                    b !== c && (b === P ? R() : c === P && R(!0))
                }),
                w(h + "." + P, function() {
                    R()
                })
            },
            getIframe: function(c, d) {
                var e = c.src
                  , f = b.st.iframe;
                a.each(f.patterns, function() {
                    return e.indexOf(this.index) > -1 ? (this.id && (e = "string" == typeof this.id ? e.substr(e.lastIndexOf(this.id) + this.id.length, e.length) : this.id.call(this, e)),
                    e = this.src.replace("%id%", e),
                    !1) : void 0
                });
                var g = {};
                return f.srcAction && (g[f.srcAction] = e),
                b._parseMarkup(d, g, c),
                b.updateStatus("ready"),
                d
            }
        }
    });
    var S = function(a) {
        var c = b.items.length;
        return a > c - 1 ? a - c : 0 > a ? c + a : a
    }
      , T = function(a, b, c) {
        return a.replace(/%curr%/gi, b + 1).replace(/%total%/gi, c)
    };
    a.magnificPopup.registerModule("gallery", {
        options: {
            enabled: !1,
            arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
            preload: [0, 2],
            navigateByImgClick: !0,
            arrows: !0,
            tPrev: "Previous (Left arrow key)",
            tNext: "Next (Right arrow key)",
            tCounter: "%curr% of %total%"
        },
        proto: {
            initGallery: function() {
                var c = b.st.gallery
                  , e = ".mfp-gallery";
                return b.direction = !0,
                c && c.enabled ? (f += " mfp-gallery",
                w(m + e, function() {
                    c.navigateByImgClick && b.wrap.on("click" + e, ".mfp-img", function() {
                        return b.items.length > 1 ? (b.next(),
                        !1) : void 0
                    }),
                    d.on("keydown" + e, function(a) {
                        37 === a.keyCode ? b.prev() : 39 === a.keyCode && b.next()
                    })
                }),
                w("UpdateStatus" + e, function(a, c) {
                    c.text && (c.text = T(c.text, b.currItem.index, b.items.length))
                }),
                w(l + e, function(a, d, e, f) {
                    var g = b.items.length;
                    e.counter = g > 1 ? T(c.tCounter, f.index, g) : ""
                }),
                w("BuildControls" + e, function() {
                    if (b.items.length > 1 && c.arrows && !b.arrowLeft) {
                        var d = c.arrowMarkup
                          , e = b.arrowLeft = a(d.replace(/%title%/gi, c.tPrev).replace(/%dir%/gi, "left")).addClass(s)
                          , f = b.arrowRight = a(d.replace(/%title%/gi, c.tNext).replace(/%dir%/gi, "right")).addClass(s);
                        e.click(function() {
                            b.prev()
                        }),
                        f.click(function() {
                            b.next()
                        }),
                        b.container.append(e.add(f))
                    }
                }),
                w(n + e, function() {
                    b._preloadTimeout && clearTimeout(b._preloadTimeout),
                    b._preloadTimeout = setTimeout(function() {
                        b.preloadNearbyImages(),
                        b._preloadTimeout = null
                    }, 16)
                }),
                void w(h + e, function() {
                    d.off(e),
                    b.wrap.off("click" + e),
                    b.arrowRight = b.arrowLeft = null
                })) : !1
            },
            next: function() {
                b.direction = !0,
                b.index = S(b.index + 1),
                b.updateItemHTML()
            },
            prev: function() {
                b.direction = !1,
                b.index = S(b.index - 1),
                b.updateItemHTML()
            },
            goTo: function(a) {
                b.direction = a >= b.index,
                b.index = a,
                b.updateItemHTML()
            },
            preloadNearbyImages: function() {
                var a, c = b.st.gallery.preload, d = Math.min(c[0], b.items.length), e = Math.min(c[1], b.items.length);
                for (a = 1; a <= (b.direction ? e : d); a++)
                    b._preloadItem(b.index + a);
                for (a = 1; a <= (b.direction ? d : e); a++)
                    b._preloadItem(b.index - a)
            },
            _preloadItem: function(c) {
                if (c = S(c),
                !b.items[c].preloaded) {
                    var d = b.items[c];
                    d.parsed || (d = b.parseEl(c)),
                    y("LazyLoad", d),
                    "image" === d.type && (d.img = a('<img class="mfp-img" />').on("load.mfploader", function() {
                        d.hasSize = !0
                    }).on("error.mfploader", function() {
                        d.hasSize = !0,
                        d.loadError = !0,
                        y("LazyLoadError", d)
                    }).attr("src", d.src)),
                    d.preloaded = !0
                }
            }
        }
    });
    var U = "retina";
    a.magnificPopup.registerModule(U, {
        options: {
            replaceSrc: function(a) {
                return a.src.replace(/\.\w+$/, function(a) {
                    return "@2x" + a
                })
            },
            ratio: 1
        },
        proto: {
            initRetina: function() {
                if (window.devicePixelRatio > 1) {
                    var a = b.st.retina
                      , c = a.ratio;
                    c = isNaN(c) ? c() : c,
                    c > 1 && (w("ImageHasSize." + U, function(a, b) {
                        b.img.css({
                            "max-width": b.img[0].naturalWidth / c,
                            width: "100%"
                        })
                    }),
                    w("ElementParse." + U, function(b, d) {
                        d.src = a.replaceSrc(d, c)
                    }))
                }
            }
        }
    }),
    A()
});
// jQuery cookie js
"use strict";
jQuery.cookie = function(b, j, m) {
    if (typeof j != "undefined") {
        m = m || {};
        if (j === null) {
            j = "";
            m.expires = -1
        }
        var e = "";
        if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) {
            var f;
            if (typeof m.expires == "number") {
                f = new Date();
                f.setTime(f.getTime() + (m.expires * 24 * 60 * 60 * 1000))
            } else {
                f = m.expires
            }
            e = "; expires=" + f.toUTCString()
        }
        var l = m.path ? "; path=" + (m.path) : "";
        var g = m.domain ? "; domain=" + (m.domain) : "";
        var a = m.secure ? "; secure" : "";
        document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("")
    } else {
        var d = null;
        if (document.cookie && document.cookie != "") {
            var k = document.cookie.split(";");
            for (var h = 0; h < k.length; h++) {
                var c = jQuery.trim(k[h]);
                if (c.substring(0, b.length + 1) == (b + "=")) {
                    d = decodeURIComponent(c.substring(b.length + 1));
                    break
                }
            }
        }
        return d
    }
}
;
// Cart.js - version: 0.4.1
(function() {
    function a(a, c, d, e) {
        return new b(a,c,d,e)
    }
    function b(a, b, d, e) {
        this.options = e || {},
        this.options.adapters = this.options.adapters || {},
        this.obj = a,
        this.keypath = b,
        this.callback = d,
        this.objectPath = [],
        this.parse(),
        c(this.target = this.realize()) && this.set(!0, this.key, this.target, this.callback)
    }
    function c(a) {
        return "object" == typeof a && null !== a
    }
    function d(a) {
        throw new Error("[sightglass] " + a)
    }
    a.adapters = {},
    b.tokenize = function(a, b, c) {
        var d, e, f = [], g = {
            i: c,
            path: ""
        };
        for (d = 0; d < a.length; d++)
            e = a.charAt(d),
            ~b.indexOf(e) ? (f.push(g),
            g = {
                i: e,
                path: ""
            }) : g.path += e;
        return f.push(g),
        f
    }
    ,
    b.prototype.parse = function() {
        var c, e, f = this.interfaces();
        f.length || d("Must define at least one adapter interface."),
        ~f.indexOf(this.keypath[0]) ? (c = this.keypath[0],
        e = this.keypath.substr(1)) : (void 0 === (c = this.options.root || a.root) && d("Must define a default root adapter."),
        e = this.keypath),
        this.tokens = b.tokenize(e, f, c),
        this.key = this.tokens.pop()
    }
    ,
    b.prototype.realize = function() {
        var a, b = this.obj, d = !1;
        return this.tokens.forEach(function(e, f) {
            c(b) ? (void 0 !== this.objectPath[f] ? b !== (a = this.objectPath[f]) && (this.set(!1, e, a, this.update.bind(this)),
            this.set(!0, e, b, this.update.bind(this)),
            this.objectPath[f] = b) : (this.set(!0, e, b, this.update.bind(this)),
            this.objectPath[f] = b),
            b = this.get(e, b)) : (!1 === d && (d = f),
            (a = this.objectPath[f]) && this.set(!1, e, a, this.update.bind(this)))
        }, this),
        !1 !== d && this.objectPath.splice(d),
        b
    }
    ,
    b.prototype.update = function() {
        var a, b;
        (a = this.realize()) !== this.target && (c(this.target) && this.set(!1, this.key, this.target, this.callback),
        c(a) && this.set(!0, this.key, a, this.callback),
        b = this.value(),
        this.target = a,
        this.value() !== b && this.callback())
    }
    ,
    b.prototype.value = function() {
        return c(this.target) ? this.get(this.key, this.target) : void 0
    }
    ,
    b.prototype.setValue = function(a) {
        c(this.target) && this.adapter(this.key).set(this.target, this.key.path, a)
    }
    ,
    b.prototype.get = function(a, b) {
        return this.adapter(a).get(b, a.path)
    }
    ,
    b.prototype.set = function(a, b, c, d) {
        var e = a ? "observe" : "unobserve";
        this.adapter(b)[e](c, b.path, d)
    }
    ,
    b.prototype.interfaces = function() {
        var b = Object.keys(this.options.adapters);
        return Object.keys(a.adapters).forEach(function(a) {
            ~b.indexOf(a) || b.push(a)
        }),
        b
    }
    ,
    b.prototype.adapter = function(b) {
        return this.options.adapters[b.i] || a.adapters[b.i]
    }
    ,
    b.prototype.unobserve = function() {
        var a;
        this.tokens.forEach(function(b, c) {
            (a = this.objectPath[c]) && this.set(!1, b, a, this.update.bind(this))
        }, this),
        c(this.target) && this.set(!1, this.key, this.target, this.callback)
    }
    ,
    "undefined" != typeof module && module.exports ? module.exports = a : "function" == typeof define && define.amd ? define([], function() {
        return this.sightglass = a
    }) : this.sightglass = a
}
).call(this),
function() {
    var a, b, c, d, e = function(a, b) {
        return function() {
            return a.apply(b, arguments)
        }
    }, f = [].slice, g = {}.hasOwnProperty, h = function(a, b) {
        function c() {
            this.constructor = a
        }
        for (var d in b)
            g.call(b, d) && (a[d] = b[d]);
        return c.prototype = b.prototype,
        a.prototype = new c,
        a.__super__ = b.prototype,
        a
    }, i = [].indexOf || function(a) {
        for (var b = 0, c = this.length; c > b; b++)
            if (b in this && this[b] === a)
                return b;
        return -1
    }
    ;
    a = {
        options: ["prefix", "templateDelimiters", "rootInterface", "preloadData", "handler"],
        extensions: ["binders", "formatters", "components", "adapters"],
        public: {
            binders: {},
            components: {},
            formatters: {},
            adapters: {},
            prefix: "rv",
            templateDelimiters: ["{", "}"],
            rootInterface: ".",
            preloadData: !0,
            handler: function(a, b, c) {
                return this.call(a, b, c.view.models)
            },
            configure: function(b) {
                var c, d, e, f;
                null == b && (b = {});
                for (e in b)
                    if (f = b[e],
                    "binders" === e || "components" === e || "formatters" === e || "adapters" === e)
                        for (d in f)
                            c = f[d],
                            a[e][d] = c;
                    else
                        a.public[e] = f
            },
            bind: function(b, c, d) {
                var e;
                return null == c && (c = {}),
                null == d && (d = {}),
                e = new a.View(b,c,d),
                e.bind(),
                e
            },
            init: function(b, c, d) {
                var e, f;
                return null == d && (d = {}),
                null == c && (c = document.createElement("div")),
                b = a.public.components[b],
                c.innerHTML = b.template.call(this, c),
                e = b.initialize.call(this, c, d),
                f = new a.View(c,e),
                f.bind(),
                f
            }
        }
    },
    window.jQuery || window.$ ? (d = "on"in jQuery.prototype ? ["on", "off"] : ["bind", "unbind"],
    b = d[0],
    c = d[1],
    a.Util = {
        bindEvent: function(a, c, d) {
            return jQuery(a)[b](c, d)
        },
        unbindEvent: function(a, b, d) {
            return jQuery(a)[c](b, d)
        },
        getInputValue: function(a) {
            var b;
            return b = jQuery(a),
            "checkbox" === b.attr("type") ? b.is(":checked") : b.val()
        }
    }) : a.Util = {
        bindEvent: function() {
            return "addEventListener"in window ? function(a, b, c) {
                return a.addEventListener(b, c, !1)
            }
            : function(a, b, c) {
                return a.attachEvent("on" + b, c)
            }
        }(),
        unbindEvent: function() {
            return "removeEventListener"in window ? function(a, b, c) {
                return a.removeEventListener(b, c, !1)
            }
            : function(a, b, c) {
                return a.detachEvent("on" + b, c)
            }
        }(),
        getInputValue: function(a) {
            var b, c, d, e;
            if ("checkbox" === a.type)
                return a.checked;
            if ("select-multiple" === a.type) {
                for (e = [],
                c = 0,
                d = a.length; d > c; c++)
                    b = a[c],
                    b.selected && e.push(b.value);
                return e
            }
            return a.value
        }
    },
    a.TypeParser = function() {
        function a() {}
        return a.types = {
            primitive: 0,
            keypath: 1
        },
        a.parse = function(a) {
            return /^'.*'$|^".*"$/.test(a) ? {
                type: this.types.primitive,
                value: a.slice(1, -1)
            } : "true" === a ? {
                type: this.types.primitive,
                value: !0
            } : "false" === a ? {
                type: this.types.primitive,
                value: !1
            } : "null" === a ? {
                type: this.types.primitive,
                value: null
            } : "undefined" === a ? {
                type: this.types.primitive,
                value: void 0
            } : !1 === isNaN(Number(a)) ? {
                type: this.types.primitive,
                value: Number(a)
            } : {
                type: this.types.keypath,
                value: a
            }
        }
        ,
        a
    }(),
    a.TextTemplateParser = function() {
        function a() {}
        return a.types = {
            text: 0,
            binding: 1
        },
        a.parse = function(a, b) {
            var c, d, e, f, g, h, i;
            for (h = [],
            f = a.length,
            c = 0,
            d = 0; f > d; ) {
                if (0 > (c = a.indexOf(b[0], d))) {
                    h.push({
                        type: this.types.text,
                        value: a.slice(d)
                    });
                    break
                }
                if (c > 0 && c > d && h.push({
                    type: this.types.text,
                    value: a.slice(d, c)
                }),
                d = c + b[0].length,
                0 > (c = a.indexOf(b[1], d))) {
                    g = a.slice(d - b[1].length),
                    e = h[h.length - 1],
                    (null != e ? e.type : void 0) === this.types.text ? e.value += g : h.push({
                        type: this.types.text,
                        value: g
                    });
                    break
                }
                i = a.slice(d, c).trim(),
                h.push({
                    type: this.types.binding,
                    value: i
                }),
                d = c + b[1].length
            }
            return h
        }
        ,
        a
    }(),
    a.View = function() {
        function b(b, c, d) {
            var f, g, h, i, j, k, l, m, n, o, p, q, r;
            for (this.els = b,
            this.models = c,
            null == d && (d = {}),
            this.update = e(this.update, this),
            this.publish = e(this.publish, this),
            this.sync = e(this.sync, this),
            this.unbind = e(this.unbind, this),
            this.bind = e(this.bind, this),
            this.select = e(this.select, this),
            this.traverse = e(this.traverse, this),
            this.build = e(this.build, this),
            this.buildBinding = e(this.buildBinding, this),
            this.bindingRegExp = e(this.bindingRegExp, this),
            this.options = e(this.options, this),
            this.els.jquery || this.els instanceof Array || (this.els = [this.els]),
            n = a.extensions,
            j = 0,
            l = n.length; l > j; j++) {
                if (g = n[j],
                this[g] = {},
                d[g]) {
                    o = d[g];
                    for (f in o)
                        h = o[f],
                        this[g][f] = h
                }
                p = a.public[g];
                for (f in p)
                    h = p[f],
                    null == (i = this[g])[f] && (i[f] = h)
            }
            for (q = a.options,
            k = 0,
            m = q.length; m > k; k++)
                g = q[k],
                this[g] = null != (r = d[g]) ? r : a.public[g];
            this.build()
        }
        return b.prototype.options = function() {
            var b, c, d, e, f;
            for (c = {},
            f = a.extensions.concat(a.options),
            d = 0,
            e = f.length; e > d; d++)
                b = f[d],
                c[b] = this[b];
            return c
        }
        ,
        b.prototype.bindingRegExp = function() {
            return new RegExp("^" + this.prefix + "-")
        }
        ,
        b.prototype.buildBinding = function(b, c, d, e) {
            var f, g, h, i, j, k, l;
            return j = {},
            l = function() {
                var a, b, c, d;
                for (c = e.split("|"),
                d = [],
                a = 0,
                b = c.length; b > a; a++)
                    k = c[a],
                    d.push(k.trim());
                return d
            }(),
            f = function() {
                var a, b, c, d;
                for (c = l.shift().split("<"),
                d = [],
                a = 0,
                b = c.length; b > a; a++)
                    g = c[a],
                    d.push(g.trim());
                return d
            }(),
            i = f.shift(),
            j.formatters = l,
            (h = f.shift()) && (j.dependencies = h.split(/\s+/)),
            this.bindings.push(new a[b](this,c,d,i,j))
        }
        ,
        b.prototype.build = function() {
            var b, c, d, e, f;
            for (this.bindings = [],
            c = function(b) {
                return function(d) {
                    var e, f, g, h, i, j, k, l, m, n, o, p, q, r;
                    if (3 === d.nodeType) {
                        if (i = a.TextTemplateParser,
                        (g = b.templateDelimiters) && (l = i.parse(d.data, g)).length && (1 !== l.length || l[0].type !== i.types.text)) {
                            for (m = 0,
                            o = l.length; o > m; m++)
                                k = l[m],
                                j = document.createTextNode(k.value),
                                d.parentNode.insertBefore(j, d),
                                1 === k.type && b.buildBinding("TextBinding", j, null, k.value);
                            d.parentNode.removeChild(d)
                        }
                    } else
                        1 === d.nodeType && (e = b.traverse(d));
                    if (!e) {
                        for (q = function() {
                            var a, b, c, e;
                            for (c = d.childNodes,
                            e = [],
                            a = 0,
                            b = c.length; b > a; a++)
                                h = c[a],
                                e.push(h);
                            return e
                        }(),
                        r = [],
                        n = 0,
                        p = q.length; p > n; n++)
                            f = q[n],
                            r.push(c(f));
                        return r
                    }
                }
            }(this),
            f = this.els,
            d = 0,
            e = f.length; e > d; d++)
                b = f[d],
                c(b);
            this.bindings.sort(function(a, b) {
                var c, d;
                return ((null != (c = b.binder) ? c.priority : void 0) || 0) - ((null != (d = a.binder) ? d.priority : void 0) || 0)
            })
        }
        ,
        b.prototype.traverse = function(b) {
            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
            for (f = this.bindingRegExp(),
            g = "SCRIPT" === b.nodeName || "STYLE" === b.nodeName,
            p = b.attributes,
            l = 0,
            n = p.length; n > l; l++)
                if (c = p[l],
                f.test(c.name)) {
                    if (j = c.name.replace(f, ""),
                    !(e = this.binders[j])) {
                        q = this.binders;
                        for (h in q)
                            k = q[h],
                            "*" !== h && -1 !== h.indexOf("*") && (i = new RegExp("^" + h.replace(/\*/g, ".+") + "$"),
                            i.test(j) && (e = k))
                    }
                    e || (e = this.binders["*"]),
                    e.block && (g = !0,
                    d = [c])
                }
            for (r = d || b.attributes,
            m = 0,
            o = r.length; o > m; m++)
                c = r[m],
                f.test(c.name) && (j = c.name.replace(f, ""),
                this.buildBinding("Binding", b, j, c.value));
            return g || (j = b.nodeName.toLowerCase(),
            this.components[j] && !b._bound && (this.bindings.push(new a.ComponentBinding(this,b,j)),
            g = !0)),
            g
        }
        ,
        b.prototype.select = function(a) {
            var b, c, d, e, f;
            for (e = this.bindings,
            f = [],
            c = 0,
            d = e.length; d > c; c++)
                b = e[c],
                a(b) && f.push(b);
            return f
        }
        ,
        b.prototype.bind = function() {
            var a, b, c, d, e;
            for (d = this.bindings,
            e = [],
            b = 0,
            c = d.length; c > b; b++)
                a = d[b],
                e.push(a.bind());
            return e
        }
        ,
        b.prototype.unbind = function() {
            var a, b, c, d, e;
            for (d = this.bindings,
            e = [],
            b = 0,
            c = d.length; c > b; b++)
                a = d[b],
                e.push(a.unbind());
            return e
        }
        ,
        b.prototype.sync = function() {
            var a, b, c, d, e;
            for (d = this.bindings,
            e = [],
            b = 0,
            c = d.length; c > b; b++)
                a = d[b],
                e.push("function" == typeof a.sync ? a.sync() : void 0);
            return e
        }
        ,
        b.prototype.publish = function() {
            var a, b, c, d, e;
            for (d = this.select(function(a) {
                var b;
                return null != (b = a.binder) ? b.publishes : void 0
            }),
            e = [],
            b = 0,
            c = d.length; c > b; b++)
                a = d[b],
                e.push(a.publish());
            return e
        }
        ,
        b.prototype.update = function(a) {
            var b, c, d, e, f, g, h;
            null == a && (a = {});
            for (c in a)
                d = a[c],
                this.models[c] = d;
            for (g = this.bindings,
            h = [],
            e = 0,
            f = g.length; f > e; e++)
                b = g[e],
                h.push("function" == typeof b.update ? b.update(a) : void 0);
            return h
        }
        ,
        b
    }(),
    a.Binding = function() {
        function b(a, b, c, d, f) {
            this.view = a,
            this.el = b,
            this.type = c,
            this.keypath = d,
            this.options = null != f ? f : {},
            this.getValue = e(this.getValue, this),
            this.update = e(this.update, this),
            this.unbind = e(this.unbind, this),
            this.bind = e(this.bind, this),
            this.publish = e(this.publish, this),
            this.sync = e(this.sync, this),
            this.set = e(this.set, this),
            this.eventHandler = e(this.eventHandler, this),
            this.formattedValue = e(this.formattedValue, this),
            this.parseTarget = e(this.parseTarget, this),
            this.observe = e(this.observe, this),
            this.setBinder = e(this.setBinder, this),
            this.formatters = this.options.formatters || [],
            this.dependencies = [],
            this.formatterObservers = {},
            this.model = void 0,
            this.setBinder()
        }
        return b.prototype.setBinder = function() {
            var a, b, c, d;
            if (!(this.binder = this.view.binders[this.type])) {
                d = this.view.binders;
                for (a in d)
                    c = d[a],
                    "*" !== a && -1 !== a.indexOf("*") && (b = new RegExp("^" + a.replace(/\*/g, ".+") + "$"),
                    b.test(this.type) && (this.binder = c,
                    this.args = new RegExp("^" + a.replace(/\*/g, "(.+)") + "$").exec(this.type),
                    this.args.shift()))
            }
            return this.binder || (this.binder = this.view.binders["*"]),
            this.binder instanceof Function ? this.binder = {
                routine: this.binder
            } : void 0
        }
        ,
        b.prototype.observe = function(b, c, d) {
            return a.sightglass(b, c, d, {
                root: this.view.rootInterface,
                adapters: this.view.adapters
            })
        }
        ,
        b.prototype.parseTarget = function() {
            var b;
            return b = a.TypeParser.parse(this.keypath),
            0 === b.type ? this.value = b.value : (this.observer = this.observe(this.view.models, this.keypath, this.sync),
            this.model = this.observer.target)
        }
        ,
        b.prototype.formattedValue = function(b) {
            var c, d, e, g, h, i, j, k, l, m, n, o, p, q;
            for (q = this.formatters,
            g = m = 0,
            o = q.length; o > m; g = ++m) {
                for (h = q[g],
                e = h.match(/[^\s']+|'([^']|'[^\s])*'|"([^"]|"[^\s])*"/g),
                i = e.shift(),
                h = this.view.formatters[i],
                e = function() {
                    var b, c, f;
                    for (f = [],
                    b = 0,
                    c = e.length; c > b; b++)
                        d = e[b],
                        f.push(a.TypeParser.parse(d));
                    return f
                }(),
                k = [],
                c = n = 0,
                p = e.length; p > n; c = ++n)
                    d = e[c],
                    k.push(0 === d.type ? d.value : ((l = this.formatterObservers)[g] || (l[g] = {}),
                    (j = this.formatterObservers[g][c]) || (j = this.observe(this.view.models, d.value, this.sync),
                    this.formatterObservers[g][c] = j),
                    j.value()));
                (null != h ? h.read : void 0)instanceof Function ? b = h.read.apply(h, [b].concat(f.call(k))) : h instanceof Function && (b = h.apply(null, [b].concat(f.call(k))))
            }
            return b
        }
        ,
        b.prototype.eventHandler = function(a) {
            var b, c;
            return c = (b = this).view.handler,
            function(d) {
                return c.call(a, this, d, b)
            }
        }
        ,
        b.prototype.set = function(a) {
            var b;
            return a = this.formattedValue(a instanceof Function && !this.binder.function ? a.call(this.model) : a),
            null != (b = this.binder.routine) ? b.call(this, this.el, a) : void 0
        }
        ,
        b.prototype.sync = function() {
            var a, b;
            return this.set(function() {
                var c, d, e, f, g, h, i;
                if (this.observer) {
                    if (this.model !== this.observer.target) {
                        for (g = this.dependencies,
                        c = 0,
                        e = g.length; e > c; c++)
                            b = g[c],
                            b.unobserve();
                        if (this.dependencies = [],
                        null != (this.model = this.observer.target) && (null != (h = this.options.dependencies) ? h.length : void 0))
                            for (i = this.options.dependencies,
                            d = 0,
                            f = i.length; f > d; d++)
                                a = i[d],
                                b = this.observe(this.model, a, this.sync),
                                this.dependencies.push(b)
                    }
                    return this.observer.value()
                }
                return this.value
            }
            .call(this))
        }
        ,
        b.prototype.publish = function() {
            var a, b, c, d, e, g, h, i, j;
            if (this.observer) {
                for (d = this.getValue(this.el),
                h = this.formatters.slice(0).reverse(),
                e = 0,
                g = h.length; g > e; e++)
                    b = h[e],
                    a = b.split(/\s+/),
                    c = a.shift(),
                    (null != (i = this.view.formatters[c]) ? i.publish : void 0) && (d = (j = this.view.formatters[c]).publish.apply(j, [d].concat(f.call(a))));
                return this.observer.setValue(d)
            }
        }
        ,
        b.prototype.bind = function() {
            var a, b, c, d, e, f, g;
            if (this.parseTarget(),
            null != (e = this.binder.bind) && e.call(this, this.el),
            null != this.model && (null != (f = this.options.dependencies) ? f.length : void 0))
                for (g = this.options.dependencies,
                c = 0,
                d = g.length; d > c; c++)
                    a = g[c],
                    b = this.observe(this.model, a, this.sync),
                    this.dependencies.push(b);
            return this.view.preloadData ? this.sync() : void 0
        }
        ,
        b.prototype.unbind = function() {
            var a, b, c, d, e, f, g, h, i, j;
            for (null != (g = this.binder.unbind) && g.call(this, this.el),
            null != (h = this.observer) && h.unobserve(),
            i = this.dependencies,
            e = 0,
            f = i.length; f > e; e++)
                d = i[e],
                d.unobserve();
            this.dependencies = [],
            j = this.formatterObservers;
            for (c in j) {
                b = j[c];
                for (a in b)
                    d = b[a],
                    d.unobserve()
            }
            return this.formatterObservers = {}
        }
        ,
        b.prototype.update = function(a) {
            var b, c;
            return null == a && (a = {}),
            this.model = null != (b = this.observer) ? b.target : void 0,
            null != (c = this.binder.update) ? c.call(this, a) : void 0
        }
        ,
        b.prototype.getValue = function(b) {
            return this.binder && null != this.binder.getValue ? this.binder.getValue.call(this, b) : a.Util.getInputValue(b)
        }
        ,
        b
    }(),
    a.ComponentBinding = function(b) {
        function c(a, b, c) {
            var d, f, g, h, j, k, l;
            for (this.view = a,
            this.el = b,
            this.type = c,
            this.unbind = e(this.unbind, this),
            this.bind = e(this.bind, this),
            this.locals = e(this.locals, this),
            this.component = this.view.components[this.type],
            this.static = {},
            this.observers = {},
            this.upstreamObservers = {},
            f = a.bindingRegExp(),
            k = this.el.attributes || [],
            h = 0,
            j = k.length; j > h; h++)
                d = k[h],
                f.test(d.name) || (g = this.camelCase(d.name),
                i.call(null != (l = this.component.static) ? l : [], g) >= 0 ? this.static[g] = d.value : this.observers[g] = d.value)
        }
        return h(c, b),
        c.prototype.sync = function() {}
        ,
        c.prototype.update = function() {}
        ,
        c.prototype.publish = function() {}
        ,
        c.prototype.locals = function() {
            var a, b, c, d, e, f;
            c = {},
            e = this.static;
            for (a in e)
                d = e[a],
                c[a] = d;
            f = this.observers;
            for (a in f)
                b = f[a],
                c[a] = b.value();
            return c
        }
        ,
        c.prototype.camelCase = function(a) {
            return a.replace(/-([a-z])/g, function(a) {
                return a[1].toUpperCase()
            })
        }
        ,
        c.prototype.bind = function() {
            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v;
            if (!this.bound) {
                o = this.observers;
                for (c in o)
                    d = o[c],
                    this.observers[c] = this.observe(this.view.models, d, function(a) {
                        return function(b) {
                            return function() {
                                return a.componentView.models[b] = a.observers[b].value()
                            }
                        }
                    }(this).call(this, c));
                this.bound = !0
            }
            if (null != this.componentView)
                return this.componentView.bind();
            for (this.el.innerHTML = this.component.template.call(this),
            h = this.component.initialize.call(this, this.el, this.locals()),
            this.el._bound = !0,
            g = {},
            p = a.extensions,
            k = 0,
            m = p.length; m > k; k++) {
                if (f = p[k],
                g[f] = {},
                this.component[f]) {
                    q = this.component[f];
                    for (b in q)
                        i = q[b],
                        g[f][b] = i
                }
                r = this.view[f];
                for (b in r)
                    i = r[b],
                    null == (j = g[f])[b] && (j[b] = i)
            }
            for (s = a.options,
            l = 0,
            n = s.length; n > l; l++)
                f = s[l],
                g[f] = null != (t = this.component[f]) ? t : this.view[f];
            this.componentView = new a.View(this.el,h,g),
            this.componentView.bind(),
            u = this.observers,
            v = [];
            for (c in u)
                e = u[c],
                v.push(this.upstreamObservers[c] = this.observe(this.componentView.models, c, function(a) {
                    return function(b, c) {
                        return function() {
                            return c.setValue(a.componentView.models[b])
                        }
                    }
                }(this).call(this, c, e)));
            return v
        }
        ,
        c.prototype.unbind = function() {
            var a, b, c, d, e;
            c = this.upstreamObservers;
            for (a in c)
                b = c[a],
                b.unobserve();
            d = this.observers;
            for (a in d)
                b = d[a],
                b.unobserve();
            return null != (e = this.componentView) ? e.unbind.call(this) : void 0
        }
        ,
        c
    }(a.Binding),
    a.TextBinding = function(a) {
        function b(a, b, c, d, f) {
            this.view = a,
            this.el = b,
            this.type = c,
            this.keypath = d,
            this.options = null != f ? f : {},
            this.sync = e(this.sync, this),
            this.formatters = this.options.formatters || [],
            this.dependencies = [],
            this.formatterObservers = {}
        }
        return h(b, a),
        b.prototype.binder = {
            routine: function(a, b) {
                return a.data = null != b ? b : ""
            }
        },
        b.prototype.sync = function() {
            return b.__super__.sync.apply(this, arguments)
        }
        ,
        b
    }(a.Binding),
    a.public.binders.text = function(a, b) {
        return null != a.textContent ? a.textContent = null != b ? b : "" : a.innerText = null != b ? b : ""
    }
    ,
    a.public.binders.html = function(a, b) {
        return a.innerHTML = null != b ? b : ""
    }
    ,
    a.public.binders.show = function(a, b) {
        return a.style.display = b ? "" : "none"
    }
    ,
    a.public.binders.hide = function(a, b) {
        return a.style.display = b ? "none" : ""
    }
    ,
    a.public.binders.enabled = function(a, b) {
        return a.disabled = !b
    }
    ,
    a.public.binders.disabled = function(a, b) {
        return a.disabled = !!b
    }
    ,
    a.public.binders.checked = {
        publishes: !0,
        priority: 2e3,
        bind: function(b) {
            return a.Util.bindEvent(b, "change", this.publish)
        },
        unbind: function(b) {
            return a.Util.unbindEvent(b, "change", this.publish)
        },
        routine: function(a, b) {
            var c;
            return a.checked = "radio" === a.type ? (null != (c = a.value) ? c.toString() : void 0) === (null != b ? b.toString() : void 0) : !!b
        }
    },
    a.public.binders.unchecked = {
        publishes: !0,
        priority: 2e3,
        bind: function(b) {
            return a.Util.bindEvent(b, "change", this.publish)
        },
        unbind: function(b) {
            return a.Util.unbindEvent(b, "change", this.publish)
        },
        routine: function(a, b) {
            var c;
            return a.checked = "radio" === a.type ? (null != (c = a.value) ? c.toString() : void 0) !== (null != b ? b.toString() : void 0) : !b
        }
    },
    a.public.binders.value = {
        publishes: !0,
        priority: 3e3,
        bind: function(b) {
            return "INPUT" !== b.tagName || "radio" !== b.type ? (this.event = "SELECT" === b.tagName ? "change" : "input",
            a.Util.bindEvent(b, this.event, this.publish)) : void 0
        },
        unbind: function(b) {
            return "INPUT" !== b.tagName || "radio" !== b.type ? a.Util.unbindEvent(b, this.event, this.publish) : void 0
        },
        routine: function(a, b) {
            var c, d, e, f, g, h, j;
            if ("INPUT" === a.tagName && "radio" === a.type)
                return a.setAttribute("value", b);
            if (null != window.jQuery) {
                if (a = jQuery(a),
                (null != b ? b.toString() : void 0) !== (null != (f = a.val()) ? f.toString() : void 0))
                    return a.val(null != b ? b : "")
            } else if ("select-multiple" === a.type) {
                if (null != b) {
                    for (j = [],
                    d = 0,
                    e = a.length; e > d; d++)
                        c = a[d],
                        j.push(c.selected = (g = c.value,
                        i.call(b, g) >= 0));
                    return j
                }
            } else if ((null != b ? b.toString() : void 0) !== (null != (h = a.value) ? h.toString() : void 0))
                return a.value = null != b ? b : ""
        }
    },
    a.public.binders.if = {
        block: !0,
        priority: 4e3,
        bind: function(a) {
            var b, c;
            return null == this.marker ? (b = [this.view.prefix, this.type].join("-").replace("--", "-"),
            c = a.getAttribute(b),
            this.marker = document.createComment(" rivets: " + this.type + " " + c + " "),
            this.bound = !1,
            a.removeAttribute(b),
            a.parentNode.insertBefore(this.marker, a),
            a.parentNode.removeChild(a)) : void 0
        },
        unbind: function() {
            var a;
            return null != (a = this.nested) ? a.unbind() : void 0
        },
        routine: function(b, c) {
            var d, e, f, g;
            if (!!c == !this.bound) {
                if (c) {
                    f = {},
                    g = this.view.models;
                    for (d in g)
                        e = g[d],
                        f[d] = e;
                    return (this.nested || (this.nested = new a.View(b,f,this.view.options()))).bind(),
                    this.marker.parentNode.insertBefore(b, this.marker.nextSibling),
                    this.bound = !0
                }
                return b.parentNode.removeChild(b),
                this.nested.unbind(),
                this.bound = !1
            }
        },
        update: function(a) {
            var b;
            return null != (b = this.nested) ? b.update(a) : void 0
        }
    },
    a.public.binders.unless = {
        block: !0,
        priority: 4e3,
        bind: function(b) {
            return a.public.binders.if.bind.call(this, b)
        },
        unbind: function() {
            return a.public.binders.if.unbind.call(this)
        },
        routine: function(b, c) {
            return a.public.binders.if.routine.call(this, b, !c)
        },
        update: function(b) {
            return a.public.binders.if.update.call(this, b)
        }
    },
    a.public.binders["on-*"] = {
        function: !0,
        priority: 1e3,
        unbind: function(b) {
            return this.handler ? a.Util.unbindEvent(b, this.args[0], this.handler) : void 0
        },
        routine: function(b, c) {
            return this.handler && a.Util.unbindEvent(b, this.args[0], this.handler),
            a.Util.bindEvent(b, this.args[0], this.handler = this.eventHandler(c))
        }
    },
    a.public.binders["each-*"] = {
        block: !0,
        priority: 4e3,
        bind: function(a) {
            var b, c, d, e, f;
            if (null == this.marker)
                b = [this.view.prefix, this.type].join("-").replace("--", "-"),
                this.marker = document.createComment(" rivets: " + this.type + " "),
                this.iterated = [],
                a.removeAttribute(b),
                a.parentNode.insertBefore(this.marker, a),
                a.parentNode.removeChild(a);
            else
                for (f = this.iterated,
                d = 0,
                e = f.length; e > d; d++)
                    c = f[d],
                    c.bind()
        },
        unbind: function() {
            var a, b, c, d, e;
            if (null != this.iterated) {
                for (d = this.iterated,
                e = [],
                b = 0,
                c = d.length; c > b; b++)
                    a = d[b],
                    e.push(a.unbind());
                return e
            }
        },
        routine: function(b, c) {
            var d, e, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, x;
            if (j = this.args[0],
            c = c || [],
            this.iterated.length > c.length)
                for (u = Array(this.iterated.length - c.length),
                o = 0,
                r = u.length; r > o; o++)
                    u[o],
                    n = this.iterated.pop(),
                    n.unbind(),
                    this.marker.parentNode.removeChild(n.els[0]);
            for (g = p = 0,
            s = c.length; s > p; g = ++p)
                if (i = c[g],
                e = {
                    index: g
                },
                e[j] = i,
                null == this.iterated[g]) {
                    v = this.view.models;
                    for (h in v)
                        i = v[h],
                        null == e[h] && (e[h] = i);
                    l = this.iterated.length ? this.iterated[this.iterated.length - 1].els[0] : this.marker,
                    k = this.view.options(),
                    k.preloadData = !0,
                    m = b.cloneNode(!0),
                    n = new a.View(m,e,k),
                    n.bind(),
                    this.iterated.push(n),
                    this.marker.parentNode.insertBefore(m, l.nextSibling)
                } else
                    this.iterated[g].models[j] !== i && this.iterated[g].update(e);
            if ("OPTION" === b.nodeName) {
                for (w = this.view.bindings,
                x = [],
                q = 0,
                t = w.length; t > q; q++)
                    d = w[q],
                    x.push(d.el === this.marker.parentNode && "value" === d.type ? d.sync() : void 0);
                return x
            }
        },
        update: function(a) {
            var b, c, d, e, f, g, h, i;
            b = {};
            for (c in a)
                d = a[c],
                c !== this.args[0] && (b[c] = d);
            for (h = this.iterated,
            i = [],
            f = 0,
            g = h.length; g > f; f++)
                e = h[f],
                i.push(e.update(b));
            return i
        }
    },
    a.public.binders["class-*"] = function(a, b) {
        var c;
        return c = " " + a.className + " ",
        !b == (-1 !== c.indexOf(" " + this.args[0] + " ")) ? a.className = b ? a.className + " " + this.args[0] : c.replace(" " + this.args[0] + " ", " ").trim() : void 0
    }
    ,
    a.public.binders["*"] = function(a, b) {
        return null != b ? a.setAttribute(this.type, b) : a.removeAttribute(this.type)
    }
    ,
    a.public.adapters["."] = {
        id: "_rv",
        counter: 0,
        weakmap: {},
        weakReference: function(a) {
            var b, c, d;
            return a.hasOwnProperty(this.id) || (b = this.counter++,
            Object.defineProperty(a, this.id, {
                value: b
            })),
            (c = this.weakmap)[d = a[this.id]] || (c[d] = {
                callbacks: {}
            })
        },
        cleanupWeakReference: function(a, b) {
            return Object.keys(a.callbacks).length || a.pointers && Object.keys(a.pointers).length ? void 0 : delete this.weakmap[b]
        },
        stubFunction: function(a, b) {
            var c, d, e;
            return d = a[b],
            c = this.weakReference(a),
            e = this.weakmap,
            a[b] = function() {
                var f, g, h, i, j, k, l, m, n;
                h = d.apply(a, arguments),
                k = c.pointers;
                for (g in k)
                    for (f = k[g],
                    n = null != (l = null != (m = e[g]) ? m.callbacks[f] : void 0) ? l : [],
                    i = 0,
                    j = n.length; j > i; i++)
                        (0,
                        n[i])();
                return h
            }
        },
        observeMutations: function(a, b, c) {
            var d, e, f, g, h, j;
            if (Array.isArray(a)) {
                if (f = this.weakReference(a),
                null == f.pointers)
                    for (f.pointers = {},
                    e = ["push", "pop", "shift", "unshift", "sort", "reverse", "splice"],
                    h = 0,
                    j = e.length; j > h; h++)
                        d = e[h],
                        this.stubFunction(a, d);
                if (null == (g = f.pointers)[b] && (g[b] = []),
                i.call(f.pointers[b], c) < 0)
                    return f.pointers[b].push(c)
            }
        },
        unobserveMutations: function(a, b, c) {
            var d, e, f;
            return Array.isArray(a) && null != a[this.id] && (e = this.weakmap[a[this.id]]) && (f = e.pointers[b]) ? ((d = f.indexOf(c)) >= 0 && f.splice(d, 1),
            f.length || delete e.pointers[b],
            this.cleanupWeakReference(e, a[this.id])) : void 0
        },
        observe: function(a, b, c) {
            var d, e, f;
            return d = this.weakReference(a).callbacks,
            null == d[b] && (d[b] = [],
            e = Object.getOwnPropertyDescriptor(a, b),
            (null != e ? e.get : void 0) || (null != e ? e.set : void 0) || (f = a[b],
            Object.defineProperty(a, b, {
                enumerable: !0,
                get: function() {
                    return f
                },
                set: function(e) {
                    return function(g) {
                        var h, j, k, l;
                        if (g !== f && (e.unobserveMutations(f, a[e.id], b),
                        f = g,
                        h = e.weakmap[a[e.id]])) {
                            if (d = h.callbacks,
                            d[b])
                                for (l = d[b].slice(),
                                j = 0,
                                k = l.length; k > j; j++)
                                    c = l[j],
                                    i.call(d[b], c) >= 0 && c();
                            return e.observeMutations(g, a[e.id], b)
                        }
                    }
                }(this)
            }))),
            i.call(d[b], c) < 0 && d[b].push(c),
            this.observeMutations(a[b], a[this.id], b)
        },
        unobserve: function(a, b, c) {
            var d, e, f;
            return (f = this.weakmap[a[this.id]]) && (d = f.callbacks[b]) ? ((e = d.indexOf(c)) >= 0 && (d.splice(e, 1),
            d.length || delete f.callbacks[b]),
            this.unobserveMutations(a[b], a[this.id], b),
            this.cleanupWeakReference(f, a[this.id])) : void 0
        },
        get: function(a, b) {
            return a[b]
        },
        set: function(a, b, c) {
            return a[b] = c
        }
    },
    a.factory = function(b) {
        return a.sightglass = b,
        a.public._ = a,
        a.public
    }
    ,
    "object" == typeof ("undefined" != typeof module && null !== module ? module.exports : void 0) ? module.exports = a.factory(require("sightglass")) : "function" == typeof define && define.amd ? define(["sightglass"], function(b) {
        return this.rivets = a.factory(b)
    }) : this.rivets = a.factory(sightglass)
}
.call(this),
function() {
    var a, b, c, d, e, f, g = function(a, b) {
        return function() {
            return a.apply(b, arguments)
        }
    };
    b = function() {
        function a() {
            this.update = g(this.update, this)
        }
        return a.prototype.update = function(a) {
            var b, c, e;
            for (c in a)
                e = a[c],
                "items" !== c && (this[c] = e);
            return this.items = function() {
                var c, e, f, g;
                for (f = a.items,
                g = [],
                c = 0,
                e = f.length; e > c; c++)
                    b = f[c],
                    g.push(new d(b));
                return g
            }()
        }
        ,
        a
    }(),
    d = function() {
        function a(a) {
            this.propertyArray = g(this.propertyArray, this),
            this.update = g(this.update, this),
            this.update(a)
        }
        return a.prototype.update = function(a) {
            var b, d;
            for (b in a)
                d = a[b],
                "properties" !== b && (this[b] = d);
            return this.properties = c.Utils.extend({}, a.properties)
        }
        ,
        a.prototype.propertyArray = function() {
            var a, b, c, d;
            c = this.properties,
            d = [];
            for (a in c)
                b = c[a],
                d.push({
                    name: a,
                    value: b
                });
            return d
        }
        ,
        a
    }(),
    c = {
        settings: {
            debug: !1,
            dataAPI: !0,
            requestBodyClass: null,
            rivetsModels: {},
            currency: null,
            moneyFormat: null,
            moneyWithCurrencyFormat: null,
            weightUnit: "g",
            weightPrecision: 0
        },
        cart: new b
    },
    c.init = function(a, b) {
        return null == b && (b = {}),
        c.configure(b),
        c.Utils.log("Initialising CartJS."),
        c.cart.update(a),
        c.settings.dataAPI && (c.Utils.log('"dataAPI" setting is true, initialising Data API.'),
        c.Data.init()),
        c.settings.requestBodyClass && (c.Utils.log('"requestBodyClass" set, adding event listeners.'),
        jQuery(document).on("cart.requestStarted", function() {}),
        jQuery(document).on("cart.requestComplete", function() {})),
        c.Rivets.init(),
        jQuery(document).trigger("cart.ready", [c.cart])
    }
    ,
    c.configure = function(a) {
        return null == a && (a = {}),
        c.Utils.extend(c.settings, a)
    }
    ,
    null == window.console && (window.console = {},
    window.console.log = function() {}
    ),
    c.Utils = {
        log: function() {
            return c.Utils.console(console.log, arguments)
        },
        error: function() {
            return c.Utils.console(console.error, arguments)
        },
        console: function(a, b) {
            return c.settings.debug && "undefined" != typeof console && null !== console ? (b = Array.prototype.slice.call(b),
            b.unshift("[CartJS]:"),
            a.apply(console, b)) : void 0
        },
        wrapKeys: function(a, b, c) {
            var d, e, f;
            null == b && (b = "properties"),
            f = {};
            for (d in a)
                e = a[d],
                f[b + "[" + d + "]"] = null != c ? c : e;
            return f
        },
        unwrapKeys: function(a, b, c) {
            var d, e, f, g;
            null == b && (b = "properties"),
            e = {};
            for (d in a)
                g = a[d],
                f = d.replace(b + "[", "").replace("]", ""),
                e[f] = null != c ? c : g;
            return e
        },
        extend: function(a, b) {
            var c, d;
            for (c in b)
                d = b[c],
                a[c] = d;
            return a
        },
        clone: function(a) {
            var b, c;
            if (null == a || "object" != typeof a)
                return a;
            c = new a.constructor;
            for (b in a)
                c[b] = clone(a[b]);
            return c
        },
        isArray: Array.isArray || function(a) {
            return "[object Array]" === {}.toString.call(a)
        }
        ,
        ensureArray: function(a) {
            return c.Utils.isArray(a) ? a : null != a ? [a] : []
        },
        formatMoney: function(a, b, d, e) {
            var f, g;
            return null == e && (e = ""),
            e || (e = c.settings.currency),
            null != window.Currency && e !== c.settings.currency && (a = Currency.convert(a, c.settings.currency, e),
            null != (null != (f = window.Currency) ? f.moneyFormats : void 0) && e in window.Currency.moneyFormats && (b = window.Currency.moneyFormats[e][d])),
            null != (null != (g = window.Shopify) ? g.formatMoney : void 0) ? Shopify.formatMoney(a, b) : a
        },
        getSizedImageUrl: function(a, b) {
            var c, d;
            return null != (null != (c = window.Shopify) && null != (d = c.Image) ? d.getSizedImageUrl : void 0) ? a ? Shopify.Image.getSizedImageUrl(a, b) : Shopify.Image.getSizedImageUrl("https://cdn.shopify.com/s/images/admin/no-image-.gif", b).replace("-_", "-") : a || "https://cdn.shopify.com/s/images/admin/no-image-large.gif"
        }
    },
    f = [],
    e = !1,
    c.Queue = {
        add: function(a, b, d) {
            var g;
            return null == d && (d = {}),
            g = {
                url: a,
                data: b,
                type: d.type || "POST",
                dataType: d.dataType || "json",
                success: c.Utils.ensureArray(d.success),
                error: c.Utils.ensureArray(d.error),
                complete: c.Utils.ensureArray(d.complete)
            },
            d.updateCart && g.success.push(c.cart.update),
            f.push(g),
            e ? void 0 : (jQuery(document).trigger("cart.requestStarted", [c.cart]),
            c.Queue.process())
        },
        process: function() {
            var a;
            return f.length ? (e = !0,
            a = f.shift(),
            a.complete = c.Queue.process,
            jQuery.ajax(a)) : (e = !1,
            void jQuery(document).trigger("cart.requestComplete", [c.cart]));
          	
        }
    },
    c.Core = {
        getCart: function(a) {
            return null == a && (a = {}),
            a.type = "GET",
            a.updateCart = !0,
            c.Queue.add("/cart.js", {}, a)
        },
        addItem: function(a, b, d, e) {
            var f;
            return null == b && (b = 1),
            null == d && (d = {}),
            null == e && (e = {}),
            f = c.Utils.wrapKeys(d),
            f.id = a,
            f.quantity = b,
            c.Queue.add("/cart/add.js", f, e),
            c.Core.getCart()
        },
        updateItem: function(a, b, d, e) {
            var f;
            return null == d && (d = {}),
            null == e && (e = {}),
            f = c.Utils.wrapKeys(d),
            f.line = a,
            null != b && (f.quantity = b),
            e.updateCart = !0,
            c.Queue.add("/cart/change.js", f, e)
        },
        removeItem: function(a, b) {
            return null == b && (b = {}),
            c.Core.updateItem(a, 0, {}, b)
        },
        updateItemById: function(a, b, d, e) {
            var f;
            return null == d && (d = {}),
            null == e && (e = {}),
            f = c.Utils.wrapKeys(d),
            f.id = a,
            null != b && (f.quantity = b),
            e.updateCart = !0,
            c.Queue.add("/cart/change.js", f, e)
        },
        updateItemQuantitiesById: function(a, b) {
            return null == a && (a = {}),
            null == b && (b = {}),
            b.updateCart = !0,
            c.Queue.add("/cart/update.js", {
                updates: a
            }, b)
        },
        removeItemById: function(a, b) {
            var d;
            return null == b && (b = {}),
            d = {
                id: a,
                quantity: 0
            },
            b.updateCart = !0,
            c.Queue.add("/cart/change.js", d, b)
        },
        clear: function(a) {
            return null == a && (a = {}),
            a.updateCart = !0,
            c.Queue.add("/cart/clear.js", {}, a)
        },
        getAttribute: function(a, b) {
            return a in c.cart.attributes ? c.cart.attributes[a] : b
        },
        setAttribute: function(a, b, d) {
            var e;
            return null == d && (d = {}),
            e = {},
            e[a] = b,
            c.Core.setAttributes(e, d)
        },
        getAttributes: function() {
            return c.cart.attributes
        },
        setAttributes: function(a, b) {
            return null == a && (a = {}),
            null == b && (b = {}),
            b.updateCart = !0,
            c.Queue.add("/cart/update.js", c.Utils.wrapKeys(a, "attributes"), b)
        },
        clearAttributes: function(a) {
            return null == a && (a = {}),
            a.updateCart = !0,
            c.Queue.add("/cart/update.js", c.Utils.wrapKeys(c.Core.getAttributes(), "attributes", ""), a)
        },
        getNote: function() {
            return c.cart.note
        },
        setNote: function(a, b) {
            return null == b && (b = {}),
            b.updateCart = !0,
            c.Queue.add("/cart/update.js", {
                note: a
            }, b)
        }
    },
    a = null,
    c.Data = {
        init: function() {
            return a = jQuery(document),
            c.Data.setEventListeners("on"),
            c.Data.render(null, c.cart)
        },
        destroy: function() {
            return c.Data.setEventListeners("off")
        },
        setEventListeners: function(b) {
            return a[b]("click", "[data-cart-add]", c.Data.add),
            a[b]("click", "[data-cart-remove]", c.Data.remove),
            a[b]("click", "[data-cart-remove-id]", c.Data.removeById),
            a[b]("click", "[data-cart-update]", c.Data.update),
            a[b]("click", "[data-cart-update-id]", c.Data.updateById),
            a[b]("click", "[data-cart-clear]", c.Data.clear),
            a[b]("change", "[data-cart-toggle]", c.Data.toggle),
            a[b]("change", "[data-cart-toggle-attribute]", c.Data.toggleAttribute),
            a[b]("submit", "[data-cart-submit]", c.Data.submit),
            a[b]("cart.requestComplete", c.Data.render)
        },
        add: function(a) {
            var b;
            return a.preventDefault(),
            b = jQuery(this),
            c.Core.addItem(b.attr("data-cart-add"), b.attr("data-cart-quantity"))
        },
        remove: function(a) {
            var b;
            return a.preventDefault(),
            b = jQuery(this),
            c.Core.removeItem(b.attr("data-cart-remove"))
        },
        removeById: function(a) {
            var b;
            return a.preventDefault(),
            b = jQuery(this),
            c.Core.removeItemById(b.attr("data-cart-remove-id"))
        },
        update: function(a) {
            var b;
            return a.preventDefault(),
            b = jQuery(this),
            c.Core.updateItem(b.attr("data-cart-update"), b.attr("data-cart-quantity"))
        },
        updateById: function(a) {
            var b;
            return a.preventDefault(),
            b = jQuery(this),
            c.Core.updateItemById(b.attr("data-cart-update-id"), b.attr("data-cart-quantity"))
        },
        clear: function(a) {
            return a.preventDefault(),
            c.Core.clear()
        },
        toggle: function() {
            var a, b;
            return a = jQuery(this),
            b = a.attr("data-cart-toggle"),
            a.is(":checked") ? c.Core.addItem(b) : c.Core.removeItemById(b)
        },
        toggleAttribute: function() {
            var a, b;
            return a = jQuery(this),
            b = a.attr("data-cart-toggle-attribute"),
            c.Core.setAttribute(b, a.is(":checked") ? "Yes" : "")
        },
        submit: function(a) {
            var b, d, e, f;
            return a.preventDefault(),
            b = jQuery(this).serializeArray(),
            d = void 0,
            f = void 0,
            e = {},
            jQuery.each(b, function(a, b) {
                return "id" === b.name ? d = b.value : "quantity" === b.name ? f = b.value : b.name.match(/^properties\[\w+\]$/) ? e[b.name] = b.value : void 0
            }),
            c.Core.addItem(d, f, c.Utils.unwrapKeys(e))
        },
        render: function(a, b) {
            var d;
            return d = {
                item_count: b.item_count,
                total_price: b.total_price,
                total_price_money: c.Utils.formatMoney(b.total_price, c.settings.moneyFormat, "money_format", null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0),
                total_price_money_with_currency: c.Utils.formatMoney(b.total_price, c.settings.moneyWithCurrencyFormat, "money_with_currency_format", null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0)
            },
            jQuery("[data-cart-render]").each(function() {
                var a;
                return a = jQuery(this),
                a.html(d[a.attr("data-cart-render")])
            })
        }
    },
    "rivets"in window ? (c.Rivets = {
        model: null,
        boundViews: [],
        init: function() {
            return c.Rivets.bindViews()
        },
        destroy: function() {
            return c.Rivets.unbindViews()
        },
        bindViews: function() {
            return c.Utils.log("Rivets.js is present, binding views."),
            c.Rivets.unbindViews(),
            c.Rivets.model = c.Utils.extend({
                cart: c.cart
            }, c.settings.rivetsModels),
            null != window.Currency && (c.Rivets.model.Currency = window.Currency),
            jQuery("[data-cart-view]").each(function() {
                var a;
                return a = rivets.bind(jQuery(this), c.Rivets.model),
                c.Rivets.boundViews.push(a)
            })
        },
        unbindViews: function() {
            var a, b, d, e;
            for (e = c.Rivets.boundViews,
            b = 0,
            d = e.length; d > b; b++)
                a = e[b],
                a.unbind();
            return c.Rivets.boundViews = []
        }
    },
    rivets.formatters.eq = function(a, b) {
        return a === b
    }
    ,
    rivets.formatters.includes = function(a, b) {
        return a.indexOf(b) >= 0
    }
    ,
    rivets.formatters.match = function(a, b, c) {
        return a.match(new RegExp(b,c))
    }
    ,
    rivets.formatters.lt = function(a, b) {
        return b > a
    }
    ,
    rivets.formatters.gt = function(a, b) {
        return a > b
    }
    ,
    rivets.formatters.not = function(a) {
        return !a
    }
    ,
    rivets.formatters.empty = function(a) {
        return !a.length
    }
    ,
    rivets.formatters.plus = function(a, b) {
        return parseInt(a) + parseInt(b)
    }
    ,
    rivets.formatters.minus = function(a, b) {
        return parseInt(a) - parseInt(b)
    }
    ,
    rivets.formatters.times = function(a, b) {
        return a * b
    }
    ,
    rivets.formatters.divided_by = function(a, b) {
        return a / b
    }
    ,
    rivets.formatters.modulo = function(a, b) {
        return a % b
    }
    ,
    rivets.formatters.prepend = function(a, b) {
        return b + a
    }
    ,
    rivets.formatters.append = function(a, b) {
        return a + b
    }
    ,
    rivets.formatters.slice = function(a, b, c) {
        return a.slice(b, c)
    }
    ,
    rivets.formatters.pluralize = function(a, b, d) {
        return null == d && (d = b + "s"),
        c.Utils.isArray(a) && (a = a.length),
        1 === a ? b : d
    }
    ,
    rivets.formatters.array_element = function(a, b) {
        return a[b]
    }
    ,
    rivets.formatters.array_first = function(a) {
        return a[0]
    }
    ,
    rivets.formatters.array_last = function(a) {
        return a[a.length - 1]
    }
    ,
    rivets.formatters.money = function(a, b) {
        return c.Utils.formatMoney(a, c.settings.moneyFormat, "money_format", b)
    }
    ,
    rivets.formatters.money_with_currency = function(a, b) {
        return c.Utils.formatMoney(a, c.settings.moneyWithCurrencyFormat, "money_with_currency_format", b)
    }
    ,
    rivets.formatters.weight = function(a) {
        switch (c.settings.weightUnit) {
        case "kg":
            return (a / 1e3).toFixed(c.settings.weightPrecision);
        case "oz":
            return (.035274 * a).toFixed(c.settings.weightPrecision);
        case "lb":
            return (.00220462 * a).toFixed(c.settings.weightPrecision);
        default:
            return a.toFixed(c.settings.weightPrecision)
        }
    }
    ,
    rivets.formatters.weight_with_unit = function(a) {
        return rivets.formatters.weight(a) + c.settings.weightUnit
    }
    ,
    rivets.formatters.product_image_size = function(a, b) {
        return c.Utils.getSizedImageUrl(a, b)
    }
    ,
    rivets.formatters.moneyWithCurrency = rivets.formatters.money_with_currency,
    rivets.formatters.weightWithUnit = rivets.formatters.weight_with_unit,
    rivets.formatters.productImageSize = rivets.formatters.product_image_size) : c.Rivets = {
        init: function() {},
        destroy: function() {}
    },
    c.factory = function(a) {
        return a.init = c.init,
        a.configure = c.configure,
        a.cart = c.cart,
        a.settings = c.settings,
        a.getCart = c.Core.getCart,
        a.addItem = c.Core.addItem,
        a.updateItem = c.Core.updateItem,
        a.updateItemById = c.Core.updateItemById,
        a.updateItemQuantitiesById = c.Core.updateItemQuantitiesById,
        a.removeItem = c.Core.removeItem,
        a.removeItemById = c.Core.removeItemById,
        a.clear = c.Core.clear,
        a.getAttribute = c.Core.getAttribute,
        a.setAttribute = c.Core.setAttribute,
        a.getAttributes = c.Core.getAttributes,
        a.setAttributes = c.Core.setAttributes,
        a.clearAttributes = c.Core.clearAttributes,
        a.getNote = c.Core.getNote,
        a.setNote = c.Core.setNote,
        a.render = c.Data.render
    }
    ,
    "object" == typeof exports ? c.factory(exports) : "function" == typeof define && define.amd ? define(["exports"], function(a) {
        return c.factory(this.CartJS = a),
        a
    }) : c.factory(this.CartJS = {})
}
.call(this);
